import { campaignSocialImportEn } from './campaignSocialImport';
import { rankingEn } from './ranking';

export const en = {

  translation: {
    ranking: rankingEn,
    soundEffectsPicker: {
      "title": "Add audio",
      "description": "Choose a sound effect or upload your own audio.",
      "search": "Search sound effects…",
      "category": "Sound category",
      "allCategories": "All categories",
      "region": "Sound region",
      "regions": {
            "all": "All sounds",
            "br": "Brazil",
            "us": "United States"
      },
      "preview": "Preview {{name}}",
      "stop": "Stop {{name}}",
      "add": "Add {{name}}",
      "addButton": "Add",
      "loading": "Loading sounds…",
      "loadError": "Could not load sound effects. Try again.",
      "retry": "Try again",
      "empty": "No sounds found. Try another search or filter.",
      "loadMore": "Load more",
      "upload": "Upload audio",
      "count": "{{shown}} of {{total}} sounds",
      "previewError": "Could not play this preview. Try again.",
      "errors": {
            "outside_clip": "Move the playhead inside the clip to add this sound.",
            "invalid_time": "Move the playhead inside the clip to add this sound.",
            "too_many_sfx": "This clip already has 30 sound effects. Remove one before adding another.",
            "too_many_overlapping_sfx": "Only two sound effects can play at once. Move the playhead or adjust the existing sounds.",
            "generic": "Could not add this sound. Try again."
      },
      "categories": {
            "whoosh": "Whoosh",
            "impact": "Impact",
            "riser": "Riser",
            "pop": "Pop",
            "click": "Click",
            "ding": "Bell",
            "fail": "Fail",
            "glitch": "Glitch",
            "cash": "Money",
            "reaction": "Reaction",
            "cartoon": "Cartoon",
            "typing": "Typing",
            "drama": "Drama"
      }
},
    motionGallery: {
      "title": "Motion graphics",
      "examples": "Examples",
      "scene": "Saved scene",
      "names": {
            "lower-third": "Lower third",
            "title-card": "Title card",
            "subscribe": "Subscribe",
            "counter": "Counter",
            "kinetic-captions": "Kinetic captions",
            "emoji-burst": "Emoji burst",
            "bar-chart": "Bar chart",
            "route": "Animated route",
            "repeated-stars": "Repeated stars",
            "group-3d": "3D group",
            "kosky1": "Kosky 1",
            "kosky2": "Kosky 2",
            "kosky3": "Kosky 3"
      }
},
    videoEffects: {
      "title": "Effects",
      "enabled": "Enable effects",
      "description": "Color and visual effects for this clip’s footage.",
      "looks": "Looks",
      "adjust": "Adjust",
      "visual": "Visual",
      "original": "Original",
      "customLut": "Custom LUT",
      "strength": "LUT strength",
      "importing": "Importing…",
      "importHint": "3D .cube, up to 12 MB. Optimized to a 17³ SDR table for the editor.",
      "importError": "Choose a valid 3D .cube LUT (2–65 points per axis, up to 12 MB). 1D and combined LUTs are not supported.",
      "importErrorTitle": "Could not import LUT",
      "saveError": "Effects could not be saved.",
      "retry": "Retry",
      "showOriginal": "Before",
      "showEdited": "After",
      "comparing": "Showing original footage. Your effects will still be exported.",
      "reset": "Reset whole-clip effects",
      "resetControl": "Reset",
      "previewUnavailable": "Effects preview unavailable. Try reloading or a browser with WebGL2.",
      "presets": {
        "warm": "Warm",
        "cool": "Cool",
        "cinema": "Cinema",
        "vintage": "Vintage",
        "vivid": "Vivid",
        "mono": "Monochrome"
      },
      "controls": {
        "exposure": "Exposure",
        "contrast": "Contrast",
        "saturation": "Saturation",
        "temperature": "Temperature",
        "tint": "Tint",
        "shadows": "Shadows",
        "highlights": "Highlights",
        "vibrance": "Vibrance",
        "blur": "Blur",
        "vignette": "Vignette",
        "grain": "Film grain",
        "grayscale": "Black & white"
      },
      "import": "Import .cube LUT",
      "sections": {
        "add": "Effects",
        "tabDynamic": "Dynamic",
        "tabLook": "Look",
        "intensity": "Intensity",
        "ease": "Ease in/out",
        "speed": "Speed",
        "frequency": "Frequency",
        "delete": "Delete effect",
        "proTitle": "Timeline effects are a PRO feature",
        "proBody": "You can add and preview effects for free. Exporting a clip with timeline effects requires a PRO plan — upgrade, or remove the effects to export for free.",
        "library": {
          "shake": "Shake", "zoom-punch": "Zoom punch", "flash": "Flash", "glitch": "Glitch", "rgb-split": "RGB split",
          "focus-pull": "Focus pull", "strobe": "Strobe", "vhs": "VHS",
          "look-warm": "Warm", "look-cool": "Cool", "look-cinema": "Cinema", "look-vintage": "Vintage",
          "look-vivid": "Vivid", "look-mono": "Mono", "bw": "B&W", "grain": "Grain", "vignette": "Vignette", "blur": "Blur"
        }
      }
    },

    // Job titles (shared across signup, login/register modal, account settings)
    jobTitles: {
      contentCreator: "Content Creator",
      clippingChannel: "Clipping Channel",
      serviceProvider: "Service Provider",
      brand: "Brand / buyer",
    },

    // Shared color input (swatch + picker popover)
    colorInput: {
      openPicker: "Choose color",
      hexValue: "Hex color value",
      other: "Other",
      palette: "Palette",
    },

    paletteEditor: {
      addColor: "Add color",
      removeColor: "Remove color",
      randomize: "Randomize",
      highlightRole: "Highlight color",
      fontColorRole: "Background color",
      accentColors: "Accent colors",
    },

    billing: {
      storeManagedCheckout: "Your subscription is managed by {{store}}. Change plans in the store.",
      embeddedCourseCheckout: "Courses can't be bought in the app.",
      pastDueBanner: "Your subscription payment is past due. Pay now to keep creating and exporting.",
      payNow: "Pay now",
      paying: "Opening payment...",
      pastDuePortalError: "We couldn't open the payment portal. Please try again in a moment.",
      planRenewsOn: "Plan renews on {{date}}",
      planExpiresOn: "Plan expires on {{date}}",
      partnerUntil: "Partner plan until {{date}}",
      usageResetsOn: "Clips and time reset on {{date}}",
      usageResetsOnPayment: "Clips and time reset once your payment is confirmed",
      planAndUsageRenewOn: "Plan, clips and time renew on {{date}}",
      renewedCycle: {
        notice: "Renewal paid. Your current limits last until {{date}}; the new cycle starts on that date.",
        startNow: "Start new cycle now",
        confirmTitle: "Start the new cycle now?",
        confirmDescription: "Whatever is left of the current cycle's limits will be dropped.",
        confirm: "Start now",
        started: "New cycle started. Your limits have been renewed.",
        error: "We couldn't start the new cycle. Please try again shortly.",
      },
    },

    // Common
    common: {
      email: "Email",
      password: "Password",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      save: "Save",
      confirm: "Confirm",
      delete: "Delete",
      create: "Create",
      edit: "Edit",
      close: "Close",
      back: "Back",
      next: "Next",
      submit: "Submit",
      search: "Search",
      filter: "Filter",
      clear: "Clear",
      yes: "Yes",
      no: "No",
      or: "or",
      and: "and",
      user: "User",
      name: "Name",
      phone: "Phone",
      saveChanges: "Save Changes",
      saving: "Saving...",
      loadingData: "Loading data...",
      pro: "PRO",
      free: "Free",
      comingSoon: "Coming Soon",
      unlimited: "Unlimited",
      perMonth: "per month",
      billedAnnually: "billed annually",
      learnMore: "Learn more",
      viewAll: "View all",
      download: "Download",
      downloading: "Downloading...",
      upload: "Upload",
      uploading: "Uploading...",
      processing: "Processing...",
      retry: "Retry",
      apply: "Apply",
      remove: "Remove",
      fileTooLarge: "File must be at most {{size}}",
      invalidFileType: "Please select a {{types}} file",
      checkingAuth: "Checking authentication...",
      checkingPermissions: "Checking permissions...",
      verifying: "Verifying...",
      enterprise: "Enterprise",
      talkToSpecialist: "Talk to a Specialist",
      responseIn24h: "Response within 24 hours",
    },

    viralizeQualification: {
      title: "Before you start Viralize",
      description: "Answer these quick questions to personalize your journey.",
      progress: "Step {{current}} of {{total}}",
      contact: {
        title: "How can we reach you?",
        name: "Name",
        whatsapp: "WhatsApp",
        country: "Country",
        search: "Search countries...",
        notFound: "No country found.",
        placeholder: "(415) 555-2671",
      },
      back: "Back",
      exit: "Exit",
      continue: "Continue",
      saving: "Saving...",
      loading: "Loading your answers...",
      loadingDescription: "Just a moment.",
      retry: "Try again",
      close: "Close",
      loadError: "We couldn't load your answers. Please try again.",
      saveError: "We couldn't save your answer. Please try again.",
      equipmentOptionalHint: "Optional — you can continue without selecting anything.",
      introVideo: {
        title: "Watch this introduction",
        iframeTitle: "Viralize introduction video",
        countdown: "Continue in {{seconds}}s",
      },
      questions: {
        motivation: {
          question: "What motivates you most in the digital world?",
          options: {
            make_money: "Make money",
            recognition: "Recognition",
            entertain_friends: "Entertain friends",
            professional_growth: "Grow professionally",
          },
        },
        starting_difficulty: {
          question: "What is your biggest challenge when getting started making clips today?",
          options: {
            lack_of_time: "Lack of time",
            technical_difficulty: "Technical difficulty",
            creativity: "Creativity",
            insecurity: "Insecurity",
          },
        },
        equipment: {
          question: "Which of these devices do you have?",
          options: {
            phone_only: "Just my phone",
            notebook: "Laptop",
            tablet: "iPad or tablet",
            desktop: "Desktop computer",
          },
        },
        monthly_income: {
          question: "How much do you earn per month?",
          options: {
            under_1000: "Less than R$1,000.00",
            up_to_2500: "Up to R$2,500.00",
            "2500_to_5000": "R$2,500 - R$5,000.00",
            "5000_to_7000": "R$5,000 - R$7,000.00",
            over_10000: "More than R$10,000.00",
          },
        },
        clipper_experience: {
          question: "Are you already a clipper?",
          options: {
            not_clipper: "I'm not a clipper",
            one_campaign: "I've only joined one campaign/competition!",
            some_campaigns: "I've joined a few campaigns!",
            lives_from_clips: "I make a living creating clips!",
          },
        },
        could_earn_more: {
          question: "Have you ever felt that you could earn much more than you do today?",
          options: {
            false: "No",
            true: "Yes, absolutely",
          },
        },
        financially_stuck: {
          question: "Even though you try, are you still in the same place, earning little and with few financial prospects?",
          options: {
            false: "No",
            true: "Yes",
          },
        },
        likes_current_job: {
          question: "Do you like your current job?",
          options: {
            false: "No",
            true: "Yes",
          },
        },
        wants_remote_mobile_work: {
          question: "Would working from home on your phone and earning very well be a good situation for you?",
          options: {
            true: "Yes, absolutely!",
            false: "No, I'd rather stay where I am!",
          },
        },
        self_employment_outlook: {
          question: "Have you thought about being your own boss and working for yourself?",
          options: {
            dream: "Yes, that would be my dream",
            not_possible: "I don't think that's possible for me",
            already_self_employed_more_income: "I already work for myself and want to earn more!",
          },
        },
        first_30_day_revenue_outlook: {
          question: "Do you want to make your first revenue within the first 30 days?",
          options: {
            yes: "Yes, absolutely!",
            afraid: "I don't know, I'm too afraid!",
            no: "No, I want to stay where I am!",
          },
        },
      },
    },

    // Login page
    login: {
      title: "Login",
      subtitle: "Enter your credentials",
      emailPlaceholder: "Enter your email",
      passwordPlaceholder: "Enter your password",
      forgotPassword: "Forgot password?",
      submitButton: "Login",
      submitting: "Logging in...",
      lastUsed: "Last used",
      noAccount: "Don't have an account?",
      createAccount: "Create account",
      errors: {
        invalidCredentials: "Invalid email or password",
      },
    },

    // Register page
    register: {
      title: "Create Account",
      name: "Name",
      namePlaceholder: "Enter your name",
      emailPlaceholder: "Enter your email",
      function: "Role",
      functionPlaceholder: "Choose your role",
      objectivesLabel: "What is your main goal when using Autoclipper?",
      objectivesPlaceholder: "Describe your main goal...",
      workflowLabel: "How do you plan to use Autoclipper in your day-to-day?",
      workflowPlaceholder: "Describe how you plan to use it in your day-to-day...",
      phone: "Phone",
      passwordPlaceholder: "Enter your password",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "Enter your password",
      submitButton: "Create Account",
      submitting: "Creating account...",
      marketingOptIn: "Send me product updates, tips and offers by email. You can unsubscribe at any time.",
      tosNotice: "By creating an account you agree to our <tos>Terms of Use</tos> and our <privacy>Privacy Policy</privacy>.",
      signUpWithGoogle: "Sign up with Google",
      hasAccount: "Already have an account?",
      loginHere: "Login here",
      errors: {
        passwordMismatch: "Passwords do not match.",
        selectFunction: "Please select your role.",
        minWords: "Please write at least 4 words.",
        emailTaken: "Email already registered.",
        invalidEmail: "Invalid email.",
        registrationError: "Registration error. Please try again.",
      },
    },

    // Forgot Password page
    forgotPassword: {
      title: "Forgot Password",
      subtitle: "Enter your email to receive a reset link",
      emailPlaceholder: "Enter your email",
      submitButton: "Send Email",
      submitting: "Sending...",
      rememberedPassword: "Remembered your password?",
      loginLink: "Login",
      emailSent: {
        title: "Email Sent",
        subtitle: "Check your inbox to reset your password",
        message: "We sent a password reset link to the provided email.",
        sendAgain: "Send again",
        backToLogin: "Back to login",
      },
      toast: {
        successTitle: "Email sent",
        successDescription: "Check your inbox to reset your password",
        errorTitle: "Error",
        errorDescription: "Error sending reset email",
      },
    },

    // Reset Password page
    resetPassword: {
      title: "Reset Password",
      subtitle: "Enter your new password",
      newPassword: "New Password",
      newPasswordPlaceholder: "Enter new password",
      confirmNewPassword: "Confirm New Password",
      confirmNewPasswordPlaceholder: "Confirm new password",
      submitButton: "Reset Password",
      submitting: "Resetting...",
      backToLogin: "Back to login",
      success: {
        title: "Password Reset",
        subtitle: "Your password has been reset successfully",
        message: "You can now login with your new password.",
        goToLogin: "Go to Login",
      },
      toast: {
        invalidToken: "Invalid token",
        invalidLink: "Invalid reset link",
        successTitle: "Password reset",
        successDescription: "Your password has been reset successfully",
        errorTitle: "Error",
        errorDescription: "Error resetting password",
        passwordMismatch: "Passwords do not match",
        passwordTooShort: "Password must be at least 6 characters",
      },
    },

    // Header
    header: {
      joinCommunity: "Join our WhatsApp community",
      logout: "Logout",
      objective: {
        ownBrand: "My brand",
        otherChannels: "Other channels",
        tooltip: "The interface will be optimized for the selected purpose",
      },
      viralizeCourseCta: "Go Viral in 4 Weeks",
      viralizeCourseCtaShort: "Go Viral",
    },

    // Sidebar
    sidebar: {
      challenge: "AutoClipper Championship",
      challengeLabel: "Challenge",
      createNewProject: "Create new project",
      projectsList: "Projects List",
      exportedClips: "Exported Clips",
      calendar: "Calendar",
      queues: "Publishing Queues",
      viralizeCourse: "Go Viral in 4 Weeks",
      analytics: "Analytics",
      earn: "Earn with Clips",
      ranks: "Rankings",
      earnWallet: "My wallet - Clip&Pix",
      affiliates: 'Refer & Earn',
      newBadge: "NEW",
      brandKit: "Templates",
      myMedia: "My Media",
      tutorials: "Tutorials",
      api: "API",
      apiKeys: "API Keys",
      apiRequests: "API Requests",
      apiReference: "API Reference",
      myPlan: "My Plan",
      time: "Time",
      clips: "Clips",
      curations: "Curations",
      exports: "Exports",
      videoTime: "Video Time",
      upgradeToPro: "Upgrade to PRO",
      accessPreviousVersion: "Access Previous Version",
      library: "Library",
      myLibrary: "My Library",
      communityLibrary: "Community Library",
      myProjects: "My Projects",
      exploreLibrary: "Browse Library",
      hireClippers: "Hire clippers",
      templateIdeas: "Template ideas",
      buyMoreMinutes: "Buy more minutes",
      renewPix: "Renew via PIX",
      pastDue: "Payment past due",
      payNow: "Pay now",
      logout: "Logout",
      admin: {
        title: "Admin",
        users: "Users",
        projects: "Projects",
        clips: "Clips",
        downloads: "Downloads",
        coupons: "Coupons",
        liveWatches: "Live Watches",
        emailFlows: 'Email Flows',
        payouts: "Payouts",
        pixVerifications: "PIX Verification",
        contatos: "Contacts",
        challenges: "Challenges",
        campaigns: "CPM Campaigns",
        clipperSeasons: "Clipper seasons",
        channels: "Channels",
        library: "Library",
        brandKits: "Templates",
        resultados: "Results & Metrics",
        botConversations: "Bot Conversations",
        cpmLeads: "CPM leads",
        courseRevenueShares: "Course co-producers",
        affiliateEarnings: 'Affiliates',
        commissionsAndRoyalties: 'Commissions & royalties',
        templateSuggestions: 'Template suggestions',
        communityCuration: 'Community curation',
        aiUsage: 'AI usage',
      },
      campaignAudit: "Campaign Audit",
      campaignAuditBadge: "CPM",
    },

    analytics: {
      title: "Analytics",
      subtitle: "A clear view of the public performance of your connected social accounts.",
      platforms: {
        instagram: "Instagram",
        tiktok: "TikTok",
        youtube: "YouTube",
        linkedin: "LinkedIn",
        facebook: "Facebook",
      },
      mediaTypes: { video: "Video", reel: "Reel", short: "Short", image: "Image", carousel: "Carousel", unknown: "Other" },
      filters: {
        accounts: "Accounts",
        allAccounts: "All accounts",
        multiSelectHint: "Select one or more accounts",
        platforms: "Platforms",
        allPlatforms: "All platforms",
        dateRange: "Date range",
        search: "Search content",
        clear: "Clear filters",
        label: "Filters",
        platformsCount: "Platforms ({{count}})",
        mediaTypes: "Content types",
        allMediaTypes: "All types",
        mediaTypesCount: "Types ({{count}})",
        period: "Posts to show",
        periodActive: "Active in period",
        periodPublished: "Published in period",
        availability: "Availability",
        availabilityValues: { all: "All statuses", available: "Available", unavailable: "Unavailable", deleted: "Deleted" },
      },
      importing: {
        title: "Importing account analytics",
        description: "Your official account data is being prepared. Existing results stay available while the import continues.",
        accountProgress: "Importing @{{account}}",
      },
      empty: {
        title: "Connect an account to start tracking performance",
        description: "Analytics uses the public media made available by each official platform connection. Connect an account to import its available content and lifetime metrics.",
        connectInstagram: "Connect Instagram",
        connectTiktok: "Connect TikTok",
        connectYoutube: "Connect YouTube",
        connectLinkedin: "Connect LinkedIn",
        connectFacebook: "Connect Facebook",
        officialDataNote: "Private, deleted, or provider-withheld content may not be available.",
      },
      error: {
        title: "Analytics are temporarily unavailable",
        description: "Please return in a moment. Your connected account data has not been changed.",
        retry: "Try again",
      },
      reconnect: {
        beforeImport: "Reconnect this account to begin importing its available analytics.",
      },
      status: {
        stale: {
          title: "Showing your most recently saved analytics",
          description: "One or more account updates did not finish. Your stored results remain available.",
        },
        reconnectRequired: {
          title: "Reconnect an account to resume updates",
          description: "The affected account needs to be reconnected before its analytics can update again.",
        },
        reconnectRequiredShort: "Reconnect",
        nonActiveShort: "Inactive",
        nonActive: "Account inactive — reconnect to resume updates.",
        reconnect: "Manage connection",
        lastSuccess: "Last successful sync: {{date}}",
        lastCompleteSync: "Last complete sync: {{date}}",
        noSuccessfulSync: "No completed sync yet",
        cachedDataHint: "Saved metrics remain visible until the next successful update.",
        automaticRetry: "We will try again automatically",
        queued: "Update queued",
        running: "Updating account analytics",
        cooldown: "Refresh available again at {{date}}",
      },
      refresh: {
        label: "Refresh",
        comingSoon: "Manual refresh will be available once the analytics workspace is complete.",
        unavailable: "No selected accounts can be refreshed yet",
        account: "Account",
        results: { queued: "Update queued", already_running: "Already updating", cooldown: "This account is cooling down", cooldownUntil: "Refresh available again at {{date}}", reconnect_required: "Reconnect required", unsupported: "Refresh is unavailable for this account", featureDisabled: "Analytics refresh is temporarily unavailable.", queueFailed: "We could not start this update. Try again shortly.", unavailable: "We could not queue the refresh. Try again shortly." },
      },
      metrics: {
        lifetimeViews: "Lifetime views",
        viewsGained: "Views gained",
        engagementRate: "Engagement rate",
        trackedContent: "Tracked content",
        likes: "Likes",
        comments: "Comments",
        shares: "Shares",
        selectedAccounts: "Selected accounts",
        unavailable: "Not available",
        previousPeriod: "Previous period",
        interactionsDetail: "{{likes}} likes · {{comments}} comments · {{shares}} shares",
        label: "Performance metrics",
      },
      tooltips: {
        engagementRate: "Availability of likes, comments, and shares differs by platform and content type.",
        unavailableMetric: "This metric is not provided for this content by the connected platform.",
        measuredGrowth: "Growth is measured only from stored observations after tracking began.",
        trackedContent: "Includes every imported media item, even when a platform does not provide views.",
      },
      tabs: {
        label: "Analytics content views",
        allContent: "All content",
        cpmCampaigns: "CPM campaigns",
      },
      cpm: {
        title: "CPM campaigns",
        payoutQualifiedDescription: "Only CPM payout-qualified views and accrued payout are shown here. They are not general content analytics.",
        payoutQualifiedViews: "Payout-qualified views",
        loading: "Loading CPM campaign records…",
        error: "CPM campaign records are temporarily unavailable. Your saved records remain visible when available.",
        empty: "No CPM campaign submissions match these platform filters yet.",
        unnamedCampaign: "Unnamed campaign",
        openPost: "Open canonical post",
        columns: {
          campaign: "Campaign",
          account: "Account",
          status: "Status",
          accumulatedPayout: "Accumulated payout",
          lastSync: "Last CPM sync",
        },
        status: {
          approved: "Approved",
          pending: "Pending review",
          disapproved: "Not approved",
          disqualified: "Disqualified",
          unknown: "Status unavailable",
        },
      },
      drawer: {
        openOn: "Open on {{platform}}",
        chartTitle: "Views over time",
        trackingSince: "Tracking since {{date}} (imported)",
        singlePoint: "Growth appears after the next daily sync.",
        error: "This post's history couldn't be loaded.",
        thatDay: "that day",
      },
      content: {
        details: "Details",
        detailsFor: "Details for {{title}}",
        title: "All content",
        filtersLabel: "Content filters",
        searchPlaceholder: "Search content",
        content: "Content",
        account: "Account",
        published: "Published",
        lastSync: "Last sync",
        availability: "Availability",
        noContent: "No tracked content for this selection yet.",
        noActiveContent: "No posts gained views in this period yet.",
        showPublished: "Show posts published in the period",
        untitled: "Untitled content",
        openProvider: "Open on provider",
        resultCount: "{{count}} items",
        mobileEquivalent: "The mobile cards below contain the same content fields as the table.",
        loading: "Loading saved content…",
        error: "Saved content could not be loaded. Your account data has not changed.",
        columns: { content: "Content", account: "Account", views: "Views", published: "Published", viewsInPeriod: "Views in period", lastSync: "Last sync" },
      },
      ranges: { D7: "Last 7 days", D30: "Last 30 days", D90: "Last 90 days", ALL: "All time" },
      chart: { title: "Daily views gained", subtitle: "Measured changes from official stored observations", summary: "{{range}} daily views gained. Total measured growth: {{value}}.", trackingSince: "Tracking data available from {{date}}" },
      platformBreakdown: { empty: "No platform metrics are available for this selection." },
      breakdown: {
        title: "Breakdown",
        label: "Breakdown view",
        platform: "Platform",
        account: "Account",
        posts_one: "{{count}} post",
        posts_other: "{{count}} posts",
        shareOfViews: "{{value}} of views",
        lastSync: "Last sync: {{date}}",
        emptyAccounts: "No account metrics are available for this selection.",
      },
      pagination: { previous: "Previous", next: "Next", page: "Page {{page}} of {{count}}" },
      workspace: {
        label: "Analytics workspace",
        overviewTitle: "Performance overview",
        contentTitle: "Content workspace",
        placeholder: "Your saved overview will appear here as the analytics workspace rolls out.",
        contentPlaceholder: "Content and CPM campaign views will be available here.",
      },
      insights: {
        label: "What's working",
        subtitle_one: "Median views per post · {{count}} post",
        subtitle_other: "Median views per post · {{count}} posts",
        posts_one: "{{count}} post",
        posts_other: "{{count}} posts",
        insufficient: "Faded: fewer than {{count}} posts, not ranked.",
        insufficientShort: "Not enough posts to rank",
        error: "Insights are temporarily unavailable.",
        shortRange: { title: "Pick 30 days or longer", description: "These insights only count posts at least {{days}} days old, so this range has none." },
        notEnough: { title: "Not enough posts yet", description: "Insights appear once at least {{count}} posts in this range are {{days}} or more days old." },
        formats: { title: "What format works" },
        times: {
          title: "When to post",
          weekdays: { 0: "Sun", 1: "Mon", 2: "Tue", 3: "Wed", 4: "Thu", 5: "Fri", 6: "Sat" },
          weekdaysLong: { 0: "Sunday", 1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday", 5: "Friday", 6: "Saturday" },
          cell: "{{slot}} · median {{median}} views · posts: {{count}}",
          cellEmpty: "{{slot}} · no posts",
          best: "Best: {{slot}}",
          bestDetail: "({{median}} median · posts: {{count}})",
          timezone: "Times in {{timezone}}",
        },
      },
      errors: {
        mediaNotFound: "This post is no longer available.",
        invalidTimezone: "Your browser's time zone isn't supported for these insights.",
        invalidMediaType: "That content type filter isn't supported.",
        invalidPeriod: "That period filter isn't supported.",
      },
    },

    // Projects page
    projects: {
      title: "Transform your long videos into viral clips!",
      titleViewOnly: "View projects and clips",
      subtitle: "Clip and create with AI and generate the best clips to go viral on TikTok, Reels or Shorts!",
      subtitleViewOnly: "Explore available projects and see clips generated by the team.",
      pasteVideoUrl: "Paste your video link here",
      acceptedLinks: "We accept YouTube, Twitch (pro), Instagram (pro), Google Drive (pro) and Dropbox (pro) links",
      urlPlaceholder: "https://youtube.com/watch?v=...",
      createClips: "Create clips",
      analyzingVideo: "Analyzing video...",
      orUploadVideo: "Or upload your video",
      uploadProOnly: "Feature available only for PRO users",
      acceptedFiles: "We accept MP4 files up to 50 GB",
      selectFile: "Select File",
      uploadingFile: "Uploading...",
      processingFile: "Processing...",
      upgradeToPro: "Upgrade to PRO",
      newsMode: "News Mode",
      newsModeDescription: "Upload a video and the news script mirror to create clips",
      selectFiles: "Select Files",
      heroTitle: "Transform your long videos",
      heroTitleAccent: "into viral clips",
      heroSubtitle: "Clip and create with AI and generate the best clips to go viral on TikTok, Reels or Shorts!",
      exploreCommunity: "Or explore the Community Library",
      projectHistory: "Project history",
      noProjectsFound: "No projects found.",
      failedToLoadProjects: "Failed to load projects.",
      loadingMore: "Loading more...",
      tour: {
        welcome: "Welcome to Autoclipper! Here you can create video clips automatically.",
        urlInput: "Start by creating your first project. Paste your video link here. We accept YouTube, Twitch (pro), Instagram (pro), Google Drive (pro) and Dropbox (pro) links",
        fileInput: "Or you can upload your video here (PRO users only). We accept MP4 files up to 50 GB",
        projectHistory: "Here you can view all your created projects. Click on a project to automatically generate clips from it.",
        helpButton: "Click here to see the Autoclipper tour again.",
      },
    },

    dropbox: {
      linkHelp: "Dropbox PRO: use a public video file link. Up to 50 GiB, subject to your plan and video limits.",
      previewAfterImport: "The video preview will be available after import. You can enter a time range manually.",
      errors: {
        proRequired: "Dropbox imports require PRO. Upgrade your plan to continue.",
        invalidLink: "Paste a complete public Dropbox video file link, including its access key when present.",
        folderUnsupported: "This is a folder link. Open the individual video in Dropbox and copy its shared link.",
        unavailable: "Could not access this Dropbox video. Check that the link is public and try again.",
        unsupportedMedia: "This file is not a supported video. Choose another video file.",
        fileTooLarge: "This video exceeds the supported Dropbox file size. Use a file up to 50 GiB, subject to the current limits.",
        sourceChanged: "The Dropbox file changed. Paste the link again to refresh its information.",
        metadataTimeout: "The video analysis timed out. Try again shortly.",
        storageUnavailable: "Video import is temporarily unavailable. Try again shortly.",
        downloadFailed: "The Dropbox video could not be imported. Check the shared link and try again.",
        processingFailed: "The imported video could not be processed. Try another video file.",
      },
    },

    frameio: {
      linkHelp: "Frame.io PRO: paste the public share link of a folder or a video.",
      shareTitle: "Frame.io videos",
      selectAll: "Select all",
      clearSelection: "Clear selection",
      selectedCount: "{{selected}} of {{total}} selected",
      truncated: "Showing only the first 200 videos in this folder.",
      tooLong: "Longer than your plan's limit",
      portrait: "Portrait",
      landscape: "Landscape",
      noSelection: "Select at least one Frame.io video.",
      creatingProgress: "Creating {{current}} of {{total}}…",
      summaryAllCreated_one: "{{count}} video imported from Frame.io",
      summaryAllCreated_other: "{{count}} videos imported from Frame.io",
      summaryPartial: "{{created}} imported, {{failed}} failed",
      summaryStopped: "Import stopped: plan limit reached.",
      summaryStoppedPro: "Import stopped: Frame.io import requires PRO.",
      failedListTitle: "Could not import:",
      errors: {
        proRequired: "Frame.io import requires PRO. Upgrade your plan to continue.",
        unsupportedLink: "Paste a public Frame.io share link (next.frame.io/share/…).",
        privateOrExpired: "This Frame.io share is private, password-protected, or expired.",
        notFound: "We couldn't find this Frame.io share. Check the link.",
        noVideos: "There are no videos in this Frame.io link.",
        notReady: "Frame.io is still processing this video. Try again shortly.",
        unavailable: "We couldn't reach Frame.io right now. Try again shortly.",
        downloadFailed: "We couldn't import the Frame.io video. Try again.",
      },
    },

    mediasilo: {
      linkHelp: "MediaSilo PRO: paste the public review link (app.mediasilo.com/review/…).",
      shareTitle: "MediaSilo videos",
      selectAll: "Select all",
      clearSelection: "Clear selection",
      selectedCount: "{{selected}} of {{total}} selected",
      truncated: "Showing only the first 200 videos in this review.",
      tooLong: "Longer than your plan's limit",
      portrait: "Portrait",
      landscape: "Landscape",
      noSelection: "Select at least one MediaSilo video.",
      creatingProgress: "Creating {{current}} of {{total}}…",
      summaryAllCreated_one: "{{count}} video imported from MediaSilo",
      summaryAllCreated_other: "{{count}} videos imported from MediaSilo",
      summaryPartial: "{{created}} imported, {{failed}} failed",
      summaryStopped: "Import stopped: plan limit reached.",
      summaryStoppedPro: "Import stopped: MediaSilo import requires PRO.",
      failedListTitle: "Could not import:",
      errors: {
        proRequired: "MediaSilo import requires PRO. Upgrade your plan to continue.",
        unsupportedLink: "Paste a public MediaSilo review link (app.mediasilo.com/review/…).",
        privateOrExpired: "This MediaSilo review is private, password-protected, or expired.",
        notFound: "We couldn't find this MediaSilo review. Check the link.",
        noVideos: "There are no videos in this MediaSilo link.",
        notReady: "MediaSilo is still processing this video. Try again shortly.",
        unavailable: "We couldn't reach MediaSilo right now. Try again shortly.",
        downloadFailed: "We couldn't import the MediaSilo video. Try again.",
      },
    },

    // Library page
    library: {
      title: "Content Library",
      titleViewOnly: "Content Library",
      subtitle: "Add videos to the library and browse curated content from all users.",
      subtitleViewOnly: "Browse curated videos from the library.",
      pasteVideoUrl: "Paste your video link here",
      addToLibrary: "Add to library",
      heroTitle: "Turn one of your videos",
      heroTitleAccent: "into clips ready to publish",
      heroSubtitle: "Paste a link to a video, podcast, class or live and let AI do the work for you.",
      urlPlaceholder: "Paste a video link here",
      generateFirstClip: "Generate my first clip",
      generateClips: "Generate clips",
      uploadFile: "Upload a file",
      uploadFileShort: "File",
      sources: {
        youtube: "YouTube",
        instagram: "Instagram",
        twitch: "Twitch",
        googleDrive: "Google Drive",
        dropbox: "Dropbox",
        frameio: "Frame.io",
        mediasilo: "MediaSilo",
      },
      unsupportedSource: "Unsupported link",
      unsupportedSourceDescription: "Use YouTube, Instagram, Twitch, Google Drive, a public Dropbox, Frame.io or MediaSilo video link, or upload a file.",
      urlRequired: "Paste a video link",
      urlRequiredDescription: "Add a video URL to generate clips.",
      steps: {
        addVideo: {
          title: "Add your video",
          description: "Paste the link or send the file",
        },
        aiSelects: {
          title: "AI picks the best moments",
          description: "The strongest moments become clips",
        },
        export: {
          title: "Export and publish",
          description: "Review, edit if you want, then publish",
        },
      },
      libraryItems: "Library",
      noItemsFound: "No library items found.",
      failedToLoad: "Failed to load library.",
      loadingMore: "Loading more...",
      exploreCommunity: "Explore Community Library",
      exploreCommunityDescription: "Podcasts and videos shared by The Clippers community",
      exploreCommunityChannels: "{{count}} channels to remix",
      openCollection: "Open library",
      emptyCommunityTab: "You haven't added any community projects yet.",
      exploreCommunityButton: "Explore Community Library",
      addYourVideo: "Add your video",
      addYourVideoDescription: "Paste a YouTube link to your video",
      videoLink: "Video link",
      or: "or",
      selectFile: "Select file",
      fileFormats: "Formats: MKV, AVI or MP4 • Up to 3GB",
      createClips: "Create clips",
      projectHistory: "Project History",
      projectHistoryDescription: "Your uploads and community remixes, newest first.",
      createdByMe: "Created by me",
      community: "Community (colab)",
      originUploaded: "Uploaded",
      originCommunity: "Community",
      copyToMyAccount: "Copy to my account",
      generateAIClips: "Generate AI Clips",
      copyDialogTitle: "Copy to my account",
      copyDialogDescription: "Choose a prompt and template to create a new library in your account from this community video.",
      copyConfirm: "Generate Clips",
      videoUnavailableForClips: "This video isn't available for clip generation yet. Please try again shortly.",
      copying: "Creating...",
      copySuccess: "Library created",
      copySuccessDescription: "The library has been added to your account and will be processed shortly.",
      copyError: "Failed to create library",
      copyErrorDescription: "We couldn't create this library item right now. Please try again in a moment.",
      pastDueErrorTitle: "Subscription payment is past due",
      pastDueErrorDescription: "Update your subscription payment to create library items.",
      pastDuePortalError: "We couldn't open the payment portal. Please try again in a moment.",
      payNow: "Pay now",
      curationLimitErrorTitle: "Monthly curation limit reached",
      curationLimitErrorDescription: "You've used all AI curations included in your plan this month. Upgrade your plan to keep generating clips from the community library.",
      proOnlyFeature: "Pro plan only",
      upgradeToPro: "Upgrade",
      searchPlaceholder: "Search by name...",
      allTags: "All",
      communityAvailableTitle: "Video already in the Community Library",
      communityAvailableDescription: "This video is already available in the community library. Go there to remix it and generate your AI clips directly — no need to upload it again.",
      goToCommunityLibrary: "Remix in Community Library",
      paidPlanRequired: "Upgrade to add new videos",
      paidPlanRequiredDescription: "Upgrade to a paid plan to submit new videos to the library. You can still generate clips from existing community videos.",
      upgradePlan: "Upgrade Plan",
      tour: {
        welcome: "Welcome to your Library! Here you can manage your personal video collection and explore community content.",
        exploreCommunity: "Browse videos shared by The Clippers community. Find trending podcasts and videos to remix with AI clips.",
        addVideo: "Paste a YouTube link to add your own video to the library and generate AI clips from it.",
        steps: "Paste a link, let AI pick the moments, then export and publish.",
        projectHistory: "View all your library projects here. Switch between videos you created and ones you copied from the community.",
        tabs: "Use these tabs to filter between your own creations and community remixes.",
        helpButton: "Click here to see the library tour again.",
      },
    },

    proDialog: {
      priceAnchor: 'PRO from {{price}}/month',
    },

    downloadUpsell: {
      title: 'Your clip is ready 🎉',
      body: 'Nice one. On a paid plan you keep going without the monthly limits — more processing time, more clips and bulk export in one go.',
      dismiss: 'Keep clipping',
      upgrade: 'See plans',
    },

    quotaUpsell: {
      dismiss: 'Not now',
      upgrade: 'Upgrade',
      clip_exports: {
        title: 'You have hit this month’s clip limit',
        body: 'The free plan includes 5 clips per month. A paid plan removes that cap so you can keep exporting.',
      },
      processing_time: {
        title: 'Not enough processing time',
        body: 'This video is longer than the processing time left on your plan. A paid plan adds more hours each month.',
      },
      library_curation: {
        title: 'Monthly curation limit',
        body: 'You have used the AI curations included this month. Upgrade to keep generating cuts from the library.',
      },
      library_video_time: {
        title: 'Library video time limit',
        body: 'This video is longer than the library time left on your plan. Upgrade to submit longer videos.',
      },
      library_exports: {
        title: 'Library export limit',
        body: 'You have used this month’s library clip exports. Upgrade to keep exporting.',
      },
      brand_kits: {
        title: 'Template limit',
        body: 'Your plan does not allow more Templates. Upgrade to save more visual identities.',
      },
      paid_feature: {
        title: 'Paid-plan feature',
        body: 'File upload, Google Drive, Dropbox, and adding new library videos are paid-plan features. You can still use YouTube links on the free plan.',
      },
    },

    copyLibrary: {
      processingMode: "Processing mode",
      copilot: "Copilot",
      copilotDescription: "More control over the clips you want to export.",
      automatic: "Automatic",
      automaticDescription: "Easier to generate and export all clips at once.",
      unlockedForCampaign: "Unlocked for this campaign",
    },

    // Community Library page
    communityLibrary: {
      receiveToClip: "Clip & Pix",
      ratePerThousand: "{{amount}} / 1,000 views",
      minViewsShort: "Min. {{views}} views",
      noMinViews: "No min. views",
      prizePool: "Prize pool: {{amount}}",
      seeCampaign: "See Campaign",
      viewCampaignShort: "View",
      subscribeProCta: "Get a plan",
      // Short on purpose: the Acervo chip button is ~90px wide.
      selectedOnlyCta: "Invite-only",
      activeCampaignsSectionTitle: "Active campaigns",
      title: "Community Library",
      subtitle: "Podcasts and videos shared by The Clippers community",
      liveWatch: {
        title: "Live being clipped",
        subtitle: "Autoclipper is clipping this live now.",
        openLive: "Open live",
        badge: "Live",
        curate: "Curate",
        waitingForClips: "Clips appear after the first window.",
      },
      freeAnalysis: "Choose any video. The analysis is free.",
      joinWhatsAppCommunity: "Join WhatsApp Community",
      joinTheClippers: "Join",
      theClippersCommunityLabel: "Official WhatsApp community",
      back: "Back",
      banner: "Content shared by the community for you to generate AI clips",
      trending: "Trending",
      searchPlaceholder: "Search by podcast, creator or topic...",
      pageTitle: "Community Library",
      smartSearchPlaceholder: "Search videos or paste a YouTube link...",
      searchSubtitle: "To create a new project, browse the library for a video or add a new one by pasting a YouTube link",
      teaserTitle: "This library is for clipper mode",
      teaserBody: "These videos are here so clippers can make clips for other creators. Switch to clipper mode to use this page — you can switch back anytime.",
      searchExample: "Search example: Renato Cariani",
      urlExample: "Link example: youtube.com/watch?v=...",
      filterByChannel: "Filter by channel",
      searchChannels: "Search channels...",
      channelSortName: "Name",
      channelSortRemixes: "Most remixes",
      channelSortSubscribers: "Most subscribers",
      seeMoreVideos: "See more videos",
      clearFilters: "Clear filters",
      allChannels: "All",
      allTypes: "All types",
      subscribers: "subs",
      viewChannel: "View channel",
      partnerBadge: "Partner",
      partnerChannelsTitle: "Partner Channels",
      watchOnYouTube: "Watch on YouTube",
      originalVideoDownload: {
        triggerLabel: "Download original video",
        title: "Download original video?",
        description: "This file is the full original video ({{sourceDuration}}).",
        descriptionWithoutDurations: "This file is the full original video.",
        cancel: "Cancel",
        confirm: "Download original video",
        proTitle: "Downloading the original video is PRO",
        proBody: "On the free plan you can generate clips from community videos. Upgrade to download the original file.",
        proDismiss: "Not now",
        proUpgrade: "Upgrade",
      },
      uploadedBy: "Uploaded by {{name}}",
      views: "views",
      remixes_one: "remix",
      remixes_other: "remixes",
      remixes: "remixes",
      sortBy: "Sort by",
      languageFilter: "Video language",
      languageFilterShort: "Language",
      languageAll: "All languages",
      languagePtBr: "Português",
      languageEnUs: "English",
      sortNewest: "Newest",
      sortOldest: "Oldest",
      sortViews: "Most views",
      sortSubscribers: "Most subscribers",
      sortRemixes: "Most remixes",
      sortRemixesLabel: "Most remixes — {{window}}",
      sortRemixesWindow24h: "Last 24 hours",
      sortRemixesWindow7d: "Last 7 days",
      sortRemixesWindow30d: "Last 30 days",
      sortRemixesWindow90d: "Last 90 days",
      sortRemixesWindowAll: "All time",
      remixesInWindow24h: "({{count}} today)",
      remixesInWindow7d: "({{count}} this week)",
      remixesInWindow30d: "({{count}} this month)",
      remixesInWindow90d: "({{count}} this quarter)",
      campaignRow: {
        title: "Campaigns paying now",
        subtitle: "Tap a campaign to see its videos.",
        seeAll: "See all",
        filterBy: "Filter videos by the campaign {{name}}",
        scrollLeft: "Previous campaigns",
        scrollRight: "More campaigns",
        used: "Used",
      },
      categories: {
        "Film & Animation": "Film & Animation",
        "Autos & Vehicles": "Autos & Vehicles",
        "Music": "Music",
        "Pets & Animals": "Pets & Animals",
        "Sports": "Sports",
        "Short Movies": "Short Movies",
        "Travel & Events": "Travel & Events",
        "Gaming": "Gaming",
        "Videoblogging": "Videoblogging",
        "People & Blogs": "People & Blogs",
        "Comedy": "Comedy",
        "Entertainment": "Entertainment",
        "News & Politics": "News & Politics",
        "Howto & Style": "Howto & Style",
        "Education": "Education",
        "Science & Technology": "Science & Technology",
        "Nonprofits & Activism": "Nonprofits & Activism",
      },
      tour: {
        welcome: "Welcome to the Community Library! Discover videos shared by The Clippers community and generate AI clips from them.",
        uploadCard: "Search for an existing video in the library by topic, creator or podcast, or paste a YouTube link to add your own video directly to the library.",
        searchSort: "Search for specific podcasts, creators or topics, and sort results by newest, views, subscribers or remixes.",
        channels: "Filter videos by channel. Browse channels by category, search for specific ones, or sort them by name, remixes or subscribers.",
        videoGrid: "Browse the video collection here. Click on any video to generate AI clips from it.",
        helpButton: "Click here to see the community library tour again.",
      },
      metrics: {
        title: "Community Engagement Metrics",
        subtitle: "The creators, videos and templates that generate the most value in the community",
        week: "Week",
        month: "Month",
        topCreator: "Top Creator of the Week",
        topVideos: "Top 3 most used community videos",
        topBrandKits: "Top 3 most applied community Templates",
        disclaimer: "* The values shown are simulations for gamification purposes and do not represent real values.",
      },
    },

    // CPM Campaigns
    campaign: {
      socialImport: campaignSocialImportEn,
      cpmBadge: "CPM Campaign",
      aiGuidelines: {
        eyebrow: "CAMPAIGN GUIDELINES",
        title: "AI usage is enabled for this campaign",
        accessTitle: "Available on every plan",
        accessBadge: "FULL ACCESS",
        accessDescription: "Free, Starter, Plus, and Pro+ can use AI in this campaign.",
        allPlans: "AI available on every plan",
        openCampaigns: "Only in open campaigns",
        eligibleVideos: "Only with eligible videos",
        explanation: "In this campaign, you can use AI to generate clips automatically at no extra cost, regardless of your plan. AI may only be used in open campaigns and exclusively with the eligible videos available on this page.",
        permittedTitle: "PERMITTED:",
        permittedItem1: "Use AI to generate clips from the campaign's eligible videos",
        permittedItem2: "Use AI on any plan (Free, Starter, Plus, or Pro+)",
        permittedItem3: "Create content exclusively from the campaign's eligible videos",
        forbiddenTitle: "NOT PERMITTED:",
        forbiddenItem1: "Use AI with videos from outside the campaign",
        forbiddenItem2: "Create clips with content unrelated to the campaign",
        forbiddenItem3: "Reuse older videos that are not listed as eligible",
        importantPrefix: "Important:",
        importantMessage: "only videos in the “Eligible Videos” section may be used to generate AI clips and qualify for monetization.",
        dismissAll: "Do not show this notice again",
        joinCta: "Got it, join the campaign",
        acknowledgeCta: "Got it",
      },
      wallet: {
        title: "Available balance",
        statusPill: "Available for withdrawal",
        requestButton: "Request withdrawal",
        minimumNotMet: "Minimum withdrawal: {{min}}",
      },
      multipleBadge: "{{count}} campaigns",
      earnPerThousand: "Earn {{amount}} per 1,000 views",
      remainingBudget: "Remaining budget: {{amount}}",
      statusAvailable: "Campaign available",
      ended: {
        title: "Campaign ended",
        deadline: "Ended on {{date}} (Brasília time).",
        submissionsClosed: "This campaign no longer accepts clip submissions.",
        quotaNote: "This campaign's free allowance has ended. Choose videos from active campaigns to continue without using your plan allowance.",
      },
      budgetConsumingFast: "Budget consuming fast",
      maxEarningsLabel: "Total Campaign Value",
      editingAssets: {
        title: "Editing assets",
        hint: "Download these files to edit the campaign videos outside the platform (logos, fonts, overlays, etc.).",
      },
      budgetRemainingLabel: "Remaining Budget",
      unlimited: "Unlimited",
      participateCta: "Join campaign",
      participateSubtext: "Earn for every 1,000 views",
      createViralClips: "Create viral clips",
      sendMyClips: "Send my clips",
      participateTagsReminder: "Remember to include the required tags in your video captions so they are counted.",
      howItWorks: {
        title: "How It Works",
        subtitle: "5 simple steps to start earning",
        steps: {
          chooseVideo:  { title: "Choose a video",    description: "Browse the campaign's eligible videos" },
          createClip:   { title: "Create a clip",     description: "Generate a viral clip with AutoClipper AI" },
          postOnSocial: { title: "Post on social",    description: "Publish on TikTok, Instagram or YouTube" },
          sendLink:     { title: "Send the link",     description: "Paste your published video link here" },
          earnByViews:  { title: "Earn by views",     description: "Get paid for every 1,000 verified views" },
        },
      },
      rateLabel: "CPM rate",
      per1kViews: "1k views",
      rateLabelHint: "Earn {{rate}} for every 1,000 views on your clip",
      rateLabelHintPerPlatform: "Per 1,000 views. Each network pays its own CPM, and a clip earns the rate of the network it was posted on.",
      minViewsLabel: "Min views to earn",
      minViewsHint: "Each clip needs at least {{views}} views before it starts earning. After that, every view counts.",
      minViewsShort: "min. {{count}}",
      minViewsPerClipSuffix: "views / clip",
      noMinViews: "No minimum",
      noMinViewsHint: "There is no minimum: your clip earns from its very first view.",
      accrualWindowNote: "Views count toward payment for the first {{hours}} hours after you submit your clip. Views keep being tracked afterwards, but no longer generate earnings.",
      clipLimitLabel: "Max earnings per clip",
      allowedNetworks: "Allowed networks",
      budgetSectionTitle: "Campaign budget",
      budgetLow: "Budget running low",
      budgetExhausted: "Budget exhausted",
      budgetExhaustedBanner: "This campaign's budget is exhausted. Approved clips will not earn until more budget is added.",
      budgetSpendDrift: "Payout counter {{stored}} vs approved earnings {{approved}}. {{amount}} is reserved and cannot be paid until this is repaired.",
      budgetSpendDriftBehind: "Payout counter {{stored}} is behind approved earnings {{approved}}.",
      totalSpent: "Total spent",
      remaining: "remaining",
      budget: {
        spent: "Paid",
        pending: "Pending",
        remaining: "Available",
        pendingTooltip: "Pending review — may deduct from the budget if approved",
      },
      budgetGoal: "Goal: {{amount}}",
      loading: "Loading…",
      notFound: "Campaign not found",
      error: "Error",
      requiredHashtags: "Required hashtags",
      hashtagsCardTitle: "Required tags",
      hashtagsCardDescription: "Copy and use these tags in the caption of your videos",
      requiredMentionLabel: "Required mention: {{mention}}",
      copyHashtags: "Copy tags",
      hashtagsCopied: "Tags copied!",
      copyHashtagsTiktok: "Copy TikTok tags",
      copyHashtagsInstagram: "Copy Instagram tags",
      copyHashtagsYoutube: "Copy YouTube tags",
      hashtagsCopiedTiktok: "TikTok tags copied!",
      hashtagsCopiedInstagram: "Instagram tags copied!",
      hashtagsCopiedYoutube: "YouTube tags copied!",
      hashtagsAuditWarning: "Our tools automatically verify tags in submitted videos. Missing them may result in disqualification.",
      followRequiredWarning: "You must follow the tagged profile to participate in this campaign.",
      captionExamplesTitle: "Caption examples",
      eligibleContent: "Eligible content",
      generateAiClips: "Generate clips with AI",
      clipQuotaExemption: "Clips from this video do not count against your plan limit",
      clipQuotaStandardUsage: "New curations and exports use your plan limits",
      curatedRecommendation: "Approved for this campaign",
      removeVideo: {
        trigger: "Remove from campaign",
        title: "Remove this video from the campaign?",
        description: "It stops showing in the eligible videos and counting for the campaign. You can restore it later in the campaign editor.",
        confirm: "Remove",
        cancel: "Cancel",
        errorTitle: "Could not remove",
        error: "We could not remove the video from the campaign. Please try again.",
      },
      participatingVideos: {
        title: "Eligible Videos",
        available_one: "{{count}} Available",
        available_other: "{{count}} Available",
        showAll: "See all {{count}} campaign videos",
        showLess: "Show less",
        empty: "No participating videos yet.",
      },
      warningBanner: "Hey clipper, read the rules carefully before submitting your videos. Failure to comply may result in disqualification or banishment.",
      warningPrefix: "Attention:",
      titleBrand: "Campaign",
      titleHighlight: "CPM",
      subtitle: "Monetize your clips through views",
      rules: {
        title: "Rules",
        readCarefully: "read the rules carefully before submitting your clips",
        authorizedBadge: "AUTHORIZED",
        authorizedTitle: "What you can do in this campaign",
        forbiddenBadge: "FORBIDDEN",
        forbiddenTitle: "What is not allowed",
        punishmentsBadge: "PENALTIES",
        punishmentsTitle: "Consequences for non-compliance",
        layoutModelsBadge: "TEMPLATES",
        layoutModelsTitle: "Suggested layout for manual clips",
        layoutModels: {
          intro: "The campaign's mandatory video must be visible and legible in your clip. If you need a reference, check the templates below — they follow safe zone best practices for social media. Feel free to adapt them to your style, as long as the campaign video appears clearly.",
          safeZoneLabel: "SAFE ZONE",
          safeZoneCaption: "9:16 safe zone — keep content inside the green border",
          model1Caption: "Template A — Side Split",
          model2Caption: "Template B — Vertical Split",
          model3Caption: "Template C — 50/50 Split",
          hint: "These are reference templates only. Any format that keeps the mandatory video visible and legible is within the rules.",
        },
        allowed: "ALLOWED",
        forbidden: "FORBIDDEN",
        attention: "ATTENTION",
        warning: "WARNING",
      },
      status: {
        draft: "Draft",
        active: "Active",
        paused: "Paused",
        ended: "Ended",
      },
      channels: {
        title: "My channels for this campaign",
        empty: "Add the channels you'll post from. An admin will review your request before you can submit videos.",
        add: "Request channel approval",
        cancel: "Cancel request",
        statusPending: "Pending review",
        statusApproved: "Approved",
        statusRejected: "Rejected",
        platformLabel: { youtube: "YouTube", instagram: "Instagram", tiktok: "TikTok", facebook: "Facebook" },
        invalidUrl: "We couldn't recognize that channel URL.",
        duplicate: "You already have a request for this channel.",
        cannotDelete: "You can only cancel a request while it is pending.",
      },
      accountDisqualification: {
        title: "Accounts disqualified in this campaign",
        description: "Clips from these accounts do not count in this campaign. Your other clips and accounts stay valid.",
        item: "{{account}} ({{platform}})",
        reason: "Reason: {{reason}}",
      },
      submit: {
        title: "Submit a clip",
        instruction: "Paste the link of the post you already published on social media with the required hashtags.",
        platform: "Platform",
        url: "Clip URL",
        submit: "Submit",
        success: "Clip submitted! Awaiting approval.",
        successTitle: "Clip submitted!",
        successDescription: "We received your clip and it's now awaiting approval.",
        submitTooltip: "Approval within 72h of submission. Views are counted for 72h after the link is submitted to the campaign.",
        afterSubmitMessage: "Clip received! Approval takes up to 72h. Eligible views are counted during the first 72h after the link is submitted to the campaign.",
        paymentFaqLink: "Questions about payment?",
        duplicateError: "This URL was already submitted to this campaign.",
        viewSubmission: "View submission",
        unsupportedUrl: "URL not recognized. Use YouTube, Instagram, or TikTok links.",
        channelRequired: "You need an approved {{platform}} channel for this campaign.",
        channelMismatch: "This video is from a channel you haven't been approved for.",
        connectionRequired: "Connect the {{platform}} account that owns this post before submitting it.",
        missingHashtags: "Missing hashtags: {{tokens}}.",
        missingMentions: "Missing mentions: {{tokens}}.",
        selectConnection: "Publishing account",
        errors: {
          cpm_required_caption_tokens_missing: "The post caption is missing required campaign tags. Update the caption and submit this link again.",
          social_connection_required: "Connect the social account that owns this post.",
          social_media_not_owned: "This video isn't from any account you've linked. Link the {{platform}} account that published it, then try again.",
          social_connection_reconnect_required: "Reconnect this social account and try again.",
          invalid_tiktok_video_url: "Use the full TikTok URL in the format tiktok.com/@user/video/id.",
          provider_unavailable: "We couldn't check this post right now. Please try again shortly.",
          invalid_youtube_video_url: "Use a full YouTube watch, Shorts, or youtu.be URL.",
          invalid_instagram_media_url: "Use the full Instagram post or Reel URL.",
          channel_not_approved: "This video is from a channel you haven't been approved for.",
          platform_not_approved: "You need an approved channel for this platform.",
          duplicate_submission: "This video was already submitted to this campaign.",
          cpm_account_disqualified: "The {{account}} account is disqualified in this campaign and cannot submit clips.",
          generic: "Submission failed.",
          not_joined: "Join the campaign before submitting clips.",
        },
      },
      join: {
        title: "Join this campaign",
        description: "Enter the campaign to submit your clips and start earning.",
        cta: "Join campaign",
        joining: "Joining...",
        successTitle: "You joined the campaign!",
        upgradeCta: "Upgrade to join more campaigns",
        freeLimitNote: "Free plan: you can participate in 1 campaign at a time. Upgrade to PRO for unlimited campaigns.",
        errors: {
          free_campaign_limit: "You're already participating in a campaign. Upgrade to PRO to join more than one campaign at a time.",
          invite_required: "This campaign is invite-only. You need an invitation to join.",
        },
      },
      leave: {
        cta: "Leave campaign",
        successTitle: "You left the campaign.",
        successDescription: "Your approved clips keep earning.",
        confirmTitle: "Leave this campaign?",
        confirmDescription: "You won't be able to send new clips or get new-video alerts for this campaign. You can join again while it's active.",
        pendingRejected_one: "Your clip waiting for review will be rejected.",
        pendingRejected_other: "Your {{count}} clips waiting for review will be rejected.",
        approvedKept_one: "Your approved clip keeps what it earned and keeps earning from new views.",
        approvedKept_other: "Your {{count}} approved clips keep what they earned and keep earning from new views.",
        confirm: "Leave campaign",
        cancel: "Stay in the campaign",
        errors: {
          generic: "We couldn't take you out of the campaign. Try again.",
        },
      },
      submission: {
        checkingDuplicate: "Checking link",
      },
      terms: {
        title: "Terms of Adhesion — Paid Campaigns",
        versionLabel: "Version {{version}}",
        download: "Download PDF",
        cancel: "Cancel",
        accept: "Accept",
        accepting: "Saving…",
        accepted: "Terms accepted",
        acceptCheckbox: "I have read and agree to the AutoClipper Paid Campaigns Terms of Adhesion",
        overlayTitle: "Accept the Terms of Adhesion",
        overlayBody: "To submit clips to this campaign, please read and accept the AutoClipper Paid Campaigns Terms of Adhesion.",
        overlayCta: "Read & Accept Terms",
        errorGeneric: "Failed to register acceptance. Please try again.",
      },
      submissions: {
        title: "Your submissions",
        empty: "You have not submitted any clips to this campaign yet.",
        url: "URL",
        platform: "Platform",
        views: "Views",
        viewsCount: "{{count}} views",
        earnings: "Earnings",
        approval: "Approval",
        approvalStates: {
          pending: "Pending",
          pendingTooltip: "Awaiting audit — approval within 72h of submission",
          approved: "Approved",
          disapproved: "Disapproved",
          disqualified: "Disqualified",
          pre_approved: "Pre-Approved",
          preApprovedTooltip: "Preliminary automatic approval — the audit still needs to review this clip. Not a final approval.",
        },
        preApproval: {
          pendingAuditNote: "Automatic pre-approval. The audit still needs to review this clip.",
          estimatedPayout: "Estimate (subject to audit): {{amount}}",
        },
        synced: "Synced",
        disqualified: "disqualified",
        provisionalEarnings: "My provisional earnings",
        summary: {
          confirmed: "Confirmed earnings",
          potential: "Potential earnings",
          views: "Views counted",
          clips: "Clips counted",
        },
        calculatedAt: "Calculated based on the rate of {{rate}} per 1,000 views",
        calculatedAtPerPlatform: "Calculated with each network's CPM, per 1,000 views",
        customRate: "Custom CPM: {{rate}}",
        clipLink: "Clip link",
        duplicateLinkTag: "Duplicate link",
        verdict: "Verdict",
        feedback: "Feedback",
        adminObservationLabel: "Admin observation",
        feedbackCodes: {
          video_from_unapproved_channel: "Video posted from a channel that wasn't approved for this campaign.",
          left_campaign: "Rejected automatically because you left the campaign.",
          missing_hashtag: "The clip is missing the campaign's required hashtags.",
          off_brief: "The clip content is off the campaign brief.",
          missing_watermark: "The clip is missing the required campaign watermark.",
          suspected_duplicate_resolved: "This clip was disqualified from this campaign because the same link was submitted twice for this campaign. If you think this is a mistake, contact the Autoclipper team.",
          missing_mention: "The clip is missing the campaign's required mention.",
          platform_not_allowed: "This platform isn't among the ones allowed for this campaign.",
        },
        captionTokens: {
          missing: "Missing from the caption: {{tokens}}.",
          required: "This campaign requires on this platform: {{tokens}}.",
          hint: "Upper or lower case doesn't matter, but each tag must be complete, with no letters or numbers attached right after it.",
        },
        appeal: {
          contest: "Contest",
          dialogTitle: "Contest disapproval",
          dialogHint: "Explain why this clip should be approved. The auditor will review your argument.",
          argumentLabel: "Your argument",
          extraUrlLabel: "Extra link (optional)",
          photosLabel: "Photos (optional)",
          photosHint: "Add up to {{max}} screenshots or photos as evidence.",
          photosRemove: "Remove photo",
          photosInvalidType: "Use JPEG, PNG, or WebP images.",
          photosUploadFailed: "Couldn't upload one of the photos. Try again.",
          submit: "Submit contest",
          pendingBadge: "Under contest",
          pendingCopy: "Your contest is being reviewed by the auditor.",
          keptReplyLabel: "Auditor reply",
          needsMoreCopy: "The auditor kept the disapproval and asked for more information.",
          sendMoreData: "Send additional data",
          followUpTitle: "Send additional data",
          followUpHint: "Send a new argument and any extra evidence the auditor asked for. This replaces your previous contest packet.",
          followUpSubmit: "Send additional data",
          acceptedReplyLabel: "Auditor observation",
          errors: {
            campaign_not_active: "This campaign is no longer active for contests.",
            not_disapproved: "Only disapproved clips can be contested.",
            appeal_window_closed: "The window to contest this disapproval has closed.",
            appeal_already_exists: "You already contested this disapproval.",
            left_campaign: "Clips rejected because you left the campaign can't be contested.",
            grouped_submission: "This clip is part of a group and can't be contested individually.",
            disqualified_submission: "Disqualified clips can't be contested.",
            not_owner: "You can only contest your own submissions.",
            argument_required: "Write an argument to submit the contest.",
            invalid_extra_url: "Enter a valid link or leave the field blank.",
            invalid_evidence_image_urls: "One or more photo links are invalid. Re-upload and try again.",
            too_many_evidence_images: "You can attach at most 5 photos.",
            appeal_not_awaiting_response: "This contest is not waiting for additional data.",
            generic: "Couldn't submit the contest. Please try again.",
          },
        },
        disqualifiedGenericReason: "This clip was disqualified from this campaign. This usually happens when the same clip was already submitted before. If you think this is a mistake, contact the Autoclipper team.",
        underReviewReason: "We're confirming whether this link was already submitted to this campaign before. This doesn't affect your clip's approval — it may just take a little longer.",
        metricsErrors: {
          instagram_insights_permission_denied: "Instagram did not share official views for this reel. Reconnect the account in Account Settings and make sure Insights are available for this post.",
          instagram_media_unavailable: "Instagram no longer recognizes this post on the connected account. Reconnect the account that posted this reel, or submit a new link.",
          facebook_insights_permission_denied: "Facebook didn't allow reading this reel's insights. Reconnect the Page and grant every permission.",
          facebook_media_unavailable: "This reel is no longer available on Facebook.",
          social_connection_reconnect_required: "Reconnect this Instagram account in Account Settings so we can read official views.",
          unofficial_metrics_source: "Official Instagram views are required for this clip. Reconnect the account and resubmit if needed.",
          official_media_identity_mismatch: "This clip no longer matches the connected Instagram account. Reconnect the account that posted it, or submit a new link.",
          official_metrics_failed: "We could not read official views for this clip yet. Reconnect the account if this keeps happening.",
        },
        earningsProgress: "Earnings / Progress to cap",
        potentialLabel: "Estimated",
        potentialTooltip: "Estimate based on current views. It is added to your wallet only after approval.",
        viewsRemainingToEarn: "{{count}} views left to start earning (min. {{threshold}})",
        missedThresholdInWindow: "Did not reach {{threshold}} views in the first {{hours}}h, so this clip did not earn.",
        budgetExhaustedApprovedWarning: "Campaign budget exhausted. This clip has enough views, but there is no remaining budget to pay it.",
        viewsUntilMin: "{{count}} views left (min. {{threshold}})",
        meetsMinViews: "Min. {{threshold}} views to earn",
        clipsCount_one: "{{count}} clip",
        clipsCount_other: "{{count}} clips",
        progress: "Progress",
        status: "Status",
        submittedAt: "Submitted",
        limitReached: "Limit reached",
        remainingToLimit: "{{amount}} left until the limit",
        accrualWindowClosed: "Views after {{hours}}h no longer pay",
        budgetExhaustedPendingWarning: "Campaign budget exhausted. This clip is pending review, but no funds are reserved for it.",
        maxEarnReached: "Max earning of {{amount}} reached",
        disclaimer: "The values above are estimates based on collected data. Payment will be made at the end of the campaign, subject to verification of view authenticity.",
        hideDisapproved_one: "Hide disapproved ({{count}})",
        hideDisapproved_other: "Hide disapproved ({{count}})",
        showDisapproved_one: "Show disapproved ({{count}})",
        showDisapproved_other: "Show disapproved ({{count}})",
        allDisapprovedHidden: "All the clips you submitted to this campaign were disapproved.",
      },
      calculator: {
        title: "Earnings calculator",
        numberOfClips: "Number of clips",
        viewsPerClip: "Views per clip",
        perClip: "Per clip",
        totalViews: "Total views",
        estimatedEarnings: "Estimated earnings",
        belowMinimumPayout: "Below the per-clipper minimum payout ({{amount}}).",
        belowMinimumViews: "Each clip needs at least {{count}} views to count.",
      },
    },

    campaignAudit: {
      report: {
        download: "Download PDF report",
        analyzing: "Analyzing results with AI…",
        collecting: "Collecting data…",
        progress: "Loading {{loaded}}/{{total}} submissions…",
        rendering: "Generating PDF…",
        scope: "Complete campaign report in Portuguese, using the latest available data.",
        errorTitle: "Could not generate the report",
        retry: "Try again",
        errors: {
          ai_unavailable: "AI analysis is temporarily unavailable. Please try again later.",
          ai_busy: "AI analysis is busy. Please wait a moment and try again.",
          ai_failed: "The AI analysis could not be completed. Please try generating the report again.",
          load: "Could not load all campaign data. Check your connection and access, then try again.",
          invalid: "Some campaign data needs to be checked before generating the report. Try again or contact support.",
          inconsistent: "Campaign records changed during collection or the totals do not reconcile yet. Wait a moment and try again.",
          pdf: "Could not generate the PDF file. Please try again.",
        },
      },

      title: "Campaign Audit",
      subtitle: "Manage and review the clips submitted to your campaigns.",
      empty: "You are not an auditor on any campaign yet.",
      loading: "Loading…",
      pendingAppeals: "{{value}} appealing",
      reviewAction: "Review submissions",
      startsAt: "Starts {{date}}",
      pendingClips_one: "{{value}} clip pending",
      pendingClips_other: "{{value}} clips pending",
      allReviewed: "All reviewed",
      noSubmissions: "No clips submitted yet",
      approvedClips_one: "{{value}} approved",
      approvedClips_other: "{{value}} approved",
      disapprovedClips_one: "{{value}} rejected",
      disapprovedClips_other: "{{value}} rejected",
      pendingChannelRequests_one: "{{value}} channel request",
      pendingChannelRequests_other: "{{value}} channel requests",
      searchPlaceholder: "Search campaign or channel…",
      clearSearch: "Clear search",
      found_one: "{{count}} campaign found",
      found_other: "{{count}} campaigns found",
      noMatchTitle: "No campaigns found",
      noMatchBody: "Try another status or search term.",
      tabs: {
        all: "All",
        active: "Active",
        paused: "Paused",
        scheduled: "Scheduled",
        draft: "Drafts",
        ended: "Finished",
      },
      kpis: {
        pendingClips: "Pending clips",
        pendingClipsHint: "waiting for review",
        pendingAppeals: "Appeals",
        pendingAppealsHint: "waiting for a reply",
        pendingChannelRequests: "Channel requests",
        pendingChannelRequestsHint: "waiting for approval",
        activeCampaigns: "Active campaigns",
        activeCampaignsHint: "of {{total}} · {{scheduled}} scheduled · {{draft}} drafts",
      },
      viewsChart: {
        title: "Submission views over time",
        empty: "No view data yet for this campaign.",
        yLabel: "Views",
      },
      status: {
        draft: "Draft",
        scheduled: "Scheduled",
        active: "In progress",
        paused: "Paused",
        ended: "Finished",
      },
    },

    // Delete Library
    deleteLibrary: {
      success: "Library item removed",
      successDescription: "The library item has been removed successfully.",
      error: "Error",
      errorDescription: "Failed to remove library item. Please try again.",
    },

    // Upload Modal
    uploadModal: {
      chooseAudioTrack: "Choose an audio track",
      audioTrack: "Audio track",
      audioLanguage: "Audio language",
      subtitleLanguage: "Subtitle language",
      trackOriginalSuffix: "original",
      trackAutoDubSuffix: "auto-dubbed",
      trackUnsupported: "not supported",
      subtitleProHint: "Subtitles in another language are a PRO feature.",
      audioLookupPending: "Checking the video's audio tracks...",
      title: "Create New Project",
      projectName: "Project Name",
      projectNamePlaceholder: "Enter project name...",
      videoFormat: "Video duration",
      selectFormat: "Select format",
      shortMax30Sec: "Short Max. 30s.",
      shortMax1Min: "Short Max. 1min.",
      automatic: "Automatic",
      videoLanguage: "Video language",
      selectLanguage: "Select language",
      portuguese: "Portuguese",
      english: "English",
      spanish: "Spanish",
      removeSilence: "Remove silence",
      removeSilenceDescription: "Automatically remove pauses and silent gaps from the generated clips for a tighter, more dynamic result.",
      brandKit: "Template (Optional)",
      loadingBrandKits: "Loading templates...",
      selectBrandKit: "Select a template (optional)",
      noBrandKit: "No template",
      myBrandKits: "My Templates",
      publicBrandKits: "Public Templates",
      default: "Default",
      brandKitProTip: "💡 Automatically apply the visual style of the selected template to generated clips.",
      brandKitProOnly: "🔒 Upgrade to PRO plan to use custom templates.",
      createFirstBrandKit: "Create your first Template",
      brandKitDescription: "Customize your videos with your brand's colors, logos, and fonts. Templates ensure visual consistency across all your clips.",
      createBrandKit: "Create Template",
      whatYouLookingFor: "What are you looking for in the video",
      viralClips: "Viral clips",
      viralClipsDesc: "Create clips with the most engaging and high-impact parts of the video.",
      memorableQuotes: "Memorable quotes",
      memorableQuotesDesc: "Generate a clip with the most memorable quotes.",
      topicClips: "Topic clips",
      topicClipsDesc: "Generate multiple clips based on the main topics covered.",
      productAds: "Product ads",
      productAdsDesc: "Create video ads for my product or service.",
      testimonials: "Testimonials",
      testimonialsDesc: "Extract testimonials and success stories from the video.",
      other: "Other",
      otherDesc: "Specify the task you want to perform with the video.",
      describeWhatYouLookFor: "Describe what you're looking for in the video",
      customPromptPlaceholder: "For example: 'Extract funny moments', 'Find parts about digital marketing', 'Create clips with practical tips'...",
      customPromptTip: "💡 Be specific about what you want to extract from the video to get better results.",
      videoExtension: "Video extension for processing",
      selectExtension: "Select extension",
      fullVideo: "Full video",
      videoSegment: "Video Segment",
      selectVideoSegment: "Select Video Segment",
      startTime: "Start Time (HH:mm:ss)",
      endTime: "End Time (HH:mm:ss)",
      typeOnlyNumbers: "Type only numbers (e.g. 123456 = 12:34:56)",
      useCaptureButtons: "💡 Use the buttons to capture the current video time, or type only numbers in HH:mm:ss format",
      processingTime: "Processing Time",
      clipsCreated: "Clips Created",
      videoWillConsume: "This video will consume:",
      processingOnlySegment: "(Processing only the selected segment:",
      insufficientTime: "Insufficient time: this project requires {{required}} and you have {{available}} available this month.",
      considerUpgrading: "Consider upgrading your plan to have more processing time.",
      upgradePlan: "Upgrade Plan",
      errorCreatingProject: "⚠️ Error creating project:",
      cancelButton: "Cancel",
      waitingUpload: "Waiting for upload...",
      creating: "Creating...",
      createProject: "Create Project",
      uploadInProgress: "Upload in progress",
      waitForUpload: "Wait for the upload to finish before creating the project.",
      cannotCreateYet: "Complete the required details first",
      projectNameRequired: "Enter a project name.",
      customPromptRequired: "Describe what you want to extract from the video.",
      internalError: "Internal error",
      videoUrlNotProcessed: "Video URL not yet processed. Please wait a moment.",
      projectCreatedSuccess: "Project created successfully! 🎉",
      projectAddedToList: "\"{{name}}\" was added to your project list.",
      browserNotSupportVideo: "Your browser does not support the video element.",
      browserNotSupportAudio: "Your browser does not support the audio element.",
      videoAudio: "Video Audio",
      previewLowRes: "Preview displayed in low resolution for faster loading. Processing will be done at the original video quality.",
      uploadingFile: "Uploading file...",
      progress: "Progress:",
      transferred: "Transferred:",
      speed: "Speed:",
      remainingTime: "Remaining time:",
      uploadComplete: "Upload completed successfully!",
      sectionVideo: "The video",
      sectionHowToCut: "How to cut it",
      sectionBranding: "Branding",
      invalidTimeFormat: "Invalid time format. Use HH:mm:ss",
      startMustBeLessThanEnd: "Start time must be less than end time",
      segmentMustBeOver10Min: "The selected segment must be over 10 minutes",
      endTimeExceedsDuration: "End time cannot exceed video duration",
      videoPreview: "Video Preview",
      video: "Video",
      platform: "Platform",
      yourVideoWillAppearHere: "Your video will appear here",
      insufficientProcessingTime: "Insufficient processing time",
      projectRequiresTime: "This project requires {{required}} and you have {{available}} available this month.",
      videoTags: "Video Tags",
      videoTagsDescription: "These tags will be automatically applied to your library.",
      channel: "Channel",
    },

    // Clips page
    clips: {
      title: "Exported Clips",
      noClipsFound: "No clips found.",
      failedToLoadClips: "Failed to load clips.",
      loadingMore: "Loading more...",
      tour: {
        welcome: "Welcome to the Exported Clips page! Here you find all the videos that have been exported and are ready to use.",
        clipsGrid: "Your exported clips appear here. Click on a clip to download, edit, or manage the video.",
        helpButton: "Click here to see the clips page tour again.",
      },
    },

    // Clip Card
    clipCard: {
      noName: "No name",
      estimate: "Estimate:",
      clipThumbnail: "Clip thumbnail",
      downloading: "Downloading...",
      titleGenerator: "Title Generator",
      editVideo: "Edit Video",
      downloadVideo: "Download video",
      videoPreview: "Video preview",
      browserNotSupportVideo: "Your browser does not support video playback.",
      videoNotEdited: "Video Not Edited",
      videoNotEditedDesc: "This clip has not been edited yet. The downloaded video will only be the raw cut from the original project.",
      addSubtitlesDesc: "If you want to add subtitles and other modifications, edit the video before downloading.",
      editVideoButton: "Edit Video",
      downloadAnyway: "Download Anyway",
      downloadFailedTitle: "Download Failed",
      downloadFailedDesc: "We couldn't download the video automatically. Please try again.",
      openInNewTab: "Open in New Tab",
    },
    clipCover: {
      action: 'Thumbnail',
      title: 'Clip thumbnail',
      description: 'Make a cover image and download it to upload on YouTube.',
      empty: 'This clip has no thumbnail yet.',
      frameSource: 'Frame from the video',
      frame: {
        title: 'Pick the frame',
        use: 'Use this frame',
        back: 'Back',
        scrubber: 'Position in the video',
        prev: 'Previous frame',
        next: 'Next frame',
        previewAlt: 'Video frame',
        unavailable: 'The video could not be opened. Use an image or generate one with AI.',
      },
      download: 'Download',
      downloading: 'Downloading...',
      downloadError: 'The thumbnail could not be downloaded. Try again.',
      saving: 'Saving...',
      saveError: 'The thumbnail could not be saved. Try again.',
      fileSuffix: 'cover',
      reExportHint: 'The rendered video stays as it is. If you export again, the thumbnail becomes its first frame.',
      ai: {
        renderedReference: 'Frame of the rendered clip',
      },
    },

    projectPreview: {
      playbackErrorTitle: "This preview could not be played",
      playbackErrorDescription: "The browser had a problem with the video's audio. Retry without sound to keep editing.",
      retryMuted: "Retry without sound",
      loading: "Loading preview",
    },

    // Pricing Plans
    pricing: {
      title: "Choose your Plan",
      subtitle: "Unlock the full potential of AutoClipper with our professional plans",
      failedToLoadPlans: "Failed to load plans.",
      monthly: "Monthly",
      yearly: "Yearly",
      saveUpTo: "Save up to {{percent}}%",
      loadingPlans: "Loading plans...",
      currentPlan: "Current Plan",
      mostPopular: "Most Popular",
      walletDiscount: "{{percent}}% off with wallet balance · {{price}}",
      selectPlan: "Select Plan",
      selectYearlyPlan: "Select Yearly Plan",
      processingMinutes: "{{minutes}} minutes of processing",
      processingHours: "{{hours}} hours of processing",
      processingHoursMinutes: "{{hours}}h {{minutes}}m of processing",
      processingTime: "{{time}} of processing",
      clipsPerMonth: "{{clips}} clips exported per month",
      unlimitedClips: "Unlimited clips per month",
      projectsKeptDays: "Projects and Clips kept for {{days}} days",
      projectsKeptDaysTooltip: "Need to keep your projects longer? Contact us and we can extend the retention period.",
      withWatermark: "With watermark",
      lowerPriorityRendering: "Lower priority rendering and curation",
      lowerPriorityRenderingTooltip: "Free plan videos are processed after paid plan videos, so they may take longer to be ready.",
      priorityRendering: "Priority rendering and curation",
      priorityRenderingTooltip: "Paid plan videos are processed first, so your clips are ready faster.",
      free: "Free",
      comingSoon: "Coming soon",
      haveQuestions: "Have questions?",
      contactSupport: "Contact",
      customPlanMessage: "our support for a custom plan.",
      clippers: {
        title: "Exclusive Plans for Clippers",
        subtitle1: "Unlock your full potential with the Community Shared Library",
        subtitle2: "The Clippers",
        cutsPerMonth: "cuts/month",
        perCut: "per cut",
        perMonthShort: "mo",
        hoursForNewVideos: "{{hours}} hours for new videos",
        hoursMinutesForNewVideos: "{{hours}}h {{minutes}}m for new videos",
        timeForNewVideos: "{{time}} for new videos",
        exclusive: "EXCLUSIVE",
        subscribeNow: "Subscribe now",
        mostPopular: "MOST POPULAR",
        explorePlans: "Explore plans",
        close: "Close",
      },
      plans: {
        enterprise: {
          description: "Customized solutions for large teams and agencies with specific needs",
          price: "Contact Us",
          priceSubtitle: "Customized plan for your company",
          features: [
            "Unlimited processing",
            "Unlimited users and projects",
            "Dedicated API and custom integrations",
            "Guaranteed SLA and 24/7 priority support",
            "Dedicated account manager",
            "Personalized onboarding and training",
          ],
        },
      },
    },

    // Plan Checkout
    checkout: {
      backToPlans: "Back to plans",
      planSummary: "Plan Summary",
      total: "Total",
      annualTotal: "Annual total:",
      save: "Save {{percent}}%",
      discountCode: "Discount Code",
      enterCouponCode: "Enter coupon code",
      validating: "Validating...",
      couponApplied: "Coupon {{code}} applied",
      discount: "{{percent}}% discount",
      discountForever: "forever",
      discountForMonths: "for {{cycles}} month",
      discountForMonths_plural: "for {{cycles}} months",
      discountForYears: "for {{cycles}} year",
      discountForYears_plural: "for {{cycles}} years",
      subtotal: "Subtotal:",
      discountAmount: "Discount:",
      featuresIncluded: "Features included:",
      paymentMethod: "Payment Method",
      creditCard: "Credit Card",
      bankSlip: "Bank Slip",
      pix: "PIX",
      whatsapp: "WhatsApp",
      phoneCountry: "Country calling code",
      searchCountry: "Search country...",
      noCountryFound: "No country found.",
      whatsappPlaceholder: "Enter your WhatsApp number",
      documentType: "Document Type",
      cpf: "CPF",
      cnpj: "CNPJ",
      awaitingPayment: "Awaiting payment",
      scanQrCode: "Scan the QR Code below to make the payment via PIX",
      expiresIn: "Expires in {{time}}",
      expired: "Expired",
      orCopyPixCode: "Or copy the PIX code:",
      paymentAutoConfirm: "Payment will be confirmed automatically after the transaction is processed.",
      generateNewQrCode: "Generate new QR Code",
      finalizePayment: "Finalize Payment",
      processing: "Processing...",
      simulatePurchase: "Simulate Purchase",
      loadingPlan: "Loading plan...",
      planNotFound: "Plan not found",
      couponRequired: "Coupon required",
      enterCouponCodeRequired: "Please enter a coupon code.",
      couponInvalid: "Coupon invalid",
      couponNotValidForPlan: "The coupon is not valid for this plan.",
      couponValidationError: "Coupon validation error",
      couponValidationErrorDesc: "An error occurred while validating the coupon. Try again.",
      pixCodeCopied: "PIX code copied!",
      pixCodeCopiedDesc: "The code was copied to your clipboard.",
      pixCopyError: "Copy error",
      pixCopyErrorDesc: "Could not copy the code. Try again.",
      qrCodeGenerated: "QR Code generated",
      qrCodeGeneratedDesc: "Scan the QR Code to make the payment.",
      qrCodeExpired: "QR Code expired",
      qrCodeExpiredDesc: "The PIX code has expired. Generate a new one to continue.",
      paymentConfirmed: "Payment confirmed!",
      paymentConfirmedDesc: "Your payment was processed successfully.",
      paymentNotProcessed: "Payment not processed",
      paymentNotProcessedDesc: "The payment was not completed. Try again.",
      requiredField: "Required field",
      fillDocumentField: "Please fill in the document field.",
      invalidDocument: "Invalid document",
      invalidDocumentDesc: "Please enter a valid {{type}}.",
      invalidPhoneDesc: "Please enter a valid mobile number for the selected country.",
      pixError: "Error generating PIX",
      pixErrorDesc: "An error occurred while generating the PIX code. Try again.",
      checkoutError: "Error processing payment",
      checkoutErrorDesc: "An error occurred while starting the checkout. Try again.",
      walletPayButton: "Subscribe with balance",
      walletCouponNote: "Coupons reduce the balance charge. If balance covers 100%, no further payment details are needed.",
      walletDiscountNote: "The {{percent}}% discount applies only to the portion paid with balance.",
      walletDiscountAmount: "Wallet discount ({{percent}}%)",
      walletConfirmTitle: "Confirm subscription with balance",
      walletPlanLabel: "Plan",
      walletBalanceApplied: "Balance applied",
      walletFullCoverage: "Your balance covers 100% of the price — nothing else to pay.",
      walletRemainderVia: "Remainder via {{method}}",
      walletHoldNote: "Your balance is held and only debited once the remainder payment is confirmed.",
      walletConfirmButton: "Confirm",
      walletRedeemSuccess: "Subscription activated!",
      walletRedeemSuccessDesc: "Your balance was used to activate the plan.",
      walletErrorBalanceTooLow: "Your available balance is not enough to start the redemption.",
      walletErrorPayoutPending: "You already have a withdrawal or redemption in progress. Wait for it to finish before starting another.",
      walletErrorRemainderRequired: "Choose how to pay the remainder (card or PIX).",
      walletErrorRenewalNotDue: "Renewal is not due yet.",
      walletErrorNotEligible: "This plan cannot be renewed with balance.",
      apply: "Apply",
      remove: "Remove",
    },

    // Wallet (CPM balance holds)
    wallet: {
      totalEarnedDescription: "Campaigns, affiliates, and course royalties",
      producerBreakdown: "Course royalties: {{amount}}",
      viewCourseRoyalties: "View course royalties",
      viewCampaign: "View campaign",
      viewCampaignAria: "View campaign {{name}}",
      pendingHoldNotice: "You have a balance redemption awaiting its remainder payment — it reserves your balance until it completes.",
      affiliateHoldBadge: "On hold",
      affiliateHoldTitle: "On hold (30 days)",
      affiliateHoldProtection: "Chargeback protection",
      affiliateHoldDescription: "This amount becomes available automatically after the security period.",
      cancelHoldButton: "Cancel pending redemption",
      cancelHoldConfirmTitle: "Cancel pending redemption?",
      cancelHoldConfirmDesc: "The remainder charge will be voided (the QR/checkout stops working) and the reserved balance becomes available again. Nothing will be debited.",
      cancelHoldConfirmButton: "Cancel redemption",
      holdCancelledTitle: "Redemption cancelled",
      holdCancelledDesc: "Your balance has been released.",
      holdCancelErrorTitle: "Could not cancel",
      holdErrorAlreadyPaid: "The remainder payment was already confirmed — the redemption will complete shortly.",
      holdErrorCancelFailed: "We couldn't void the remainder charge right now. Try again in a few minutes.",
      holdErrorNothingPending: "No pending redemption found.",
      holdErrorWithdrawal: "Pending PIX withdrawals are processed by the team and can't be cancelled here.",
    },

    courseRoyalties: {
      title: "Course royalties",
      subtitle: "Your statement as a co-producer",
      loading: "Loading royalties",
      dateUnavailable: "—",
      totals: {
        title: "Royalty summary",
        accrued: "Total accrued",
        pending: "Pending",
        available: "Released (all time)",
        reversed: "Reversed",
      },
      configurations: {
        title: "Your agreements",
        rate: "{{rate}}% of every paid sale",
        active: "Active",
        inactive: "Inactive",
      },
      earnings: {
        title: "Sales statement",
        empty: "No royalty sales have been recorded yet.",
        loadMore: "Load more",
        loadingMore: "Loading more",
        loadMoreError: "We couldn't load more sales. Try again.",
      },
      columns: {
        course: "Course",
        date: "Sale date",
        releasesAt: "Release",
        gross: "Gross sale",
        rate: "Your share",
        royalty: "Your royalty",
        status: "Status",
      },
      status: {
        pending: "Pending",
        available: "Released",
        reversed: "Reversed",
      },
      empty: {
        title: "No co-production agreement",
        description: "Your active agreements will appear here.",
      },
      error: {
        title: "We couldn't load your royalties",
        description: "Try again to refresh your statement.",
        retry: "Try again",
      },
    },

    // Purchase Complete
    purchaseComplete: {
      thankYou: "Thank you for your purchase!",
      paymentProcessed: "Your payment was processed successfully!",
      nowHaveAccess: "You now have access to all features of your plan. Start creating amazing content right now!",
      startCreating: "Start Creating",
      joinCommunity: "Join Community",
      readyToCreate: "🚀 Ready to create your first projects?",
    },

    // Not Found
    notFound: {
      title: "Oops! Page not found",
      description: "The page you are looking for does not exist or has been moved. How about going back to the beginning and exploring our features?",
      backToHome: "Back to Home",
      previousPage: "Previous Page",
      needHelp: "Need help? Contact our",
      whatsAppCommunity: "WhatsApp community",
    },

    facebookDataDeletion: {
      neutralTitle: "Facebook data deletion",
      title: "Your Facebook data deletion request was processed",
      body: "We disconnected your Facebook Pages from Autoclipper, discarded their access tokens and deleted the analytics and reel descriptions we received from Meta. Keep this confirmation code for your records:",
      missingCode: "This page confirms Facebook data deletion requests. Open the link Facebook gave you to see your confirmation code.",
    },

    legalPage: {
      toc: "Contents",
      updatedAt: "Updated {{date}}",
      questionsTitle: "Questions about this document?",
      questionsBody: "Contact us at <email>contato@autoclipper.live</email>.",
      seeAlso: "See also",
      logoAlt: "Autoclipper",
      skipToContent: "Skip to content",
      terms: {
        title: "Terms of Use",
        subtitle: "Autoclipper — automatic video clipping platform",
      },
      privacy: {
        title: "Privacy Policy",
        subtitle: "Autoclipper — automatic video clipping platform",
      },
    },

    // Account Settings
    account: {
      title: "My Account",
      editPhoto: "Edit Photo",
      fullName: "Full Name",
      jobTitle: "Job Title",
      changePassword: "Change Password",
      setPassword: "Create Password",
      setPasswordDescription: "Create a password to sign in with email as well as Google.",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      passwordMismatch: "Passwords do not match.",
      changing: "Changing...",
      changePasswordButton: "Change Password",
      setPasswordButton: "Create Password",
      connectSocialMedia: "Connect Social Media",
      instagram: "Instagram",
      tiktok: "TikTok",
      youtube: "YouTube",
      linkedin: "LinkedIn",
      socialConnectionsDescription: "Connect the account that owns your CPM posts. Tokens stay on the server and are used only for official metrics.",
      connectInstagram: "Connect Instagram",
      connectTikTok: "Connect TikTok",
      connectYouTube: "Connect YouTube",
      connectLinkedIn: "Connect LinkedIn",
      facebook: "Facebook Page",
      connectFacebook: "Connect Facebook Page",
      facebookConnectionNote: "Only Facebook Pages can be connected, not personal profiles.",
      addAnotherSocialAccount: "Add another account",
      instagramProfessionalRequired: "Requires an Instagram Business or Creator account.",
      tiktokConnectionNote: "Connect the TikTok account that publishes your campaign videos.",
      youtubeConnectionNote: "Connect a YouTube channel to prove ownership; public views still use the official API.",
      linkedinConnectionNote: "Connect a LinkedIn Company Page you administer. Personal profiles cannot import analytics.",
      youtubeOfficialNoConnection: "Public YouTube views already use the official API; no connection is required.",
      socialConnectedBadge: "Connected",
      facebookReconnectTitle: "Reconnect your Facebook Page to post",
      facebookReconnectRequired: "If you manage this Page and want to post to it, reconnect and allow posting so Autoclipper can publish.",
      youtubeReconnectRequired: "Reconnect this YouTube account to grant video upload permission.",
      reconnectSocial: "Reconnect",
      disconnectSocial: "Disconnect",
      disconnectSocialTitle: "Disconnect social account?",
      disconnectSocialDescription: "Future CPM view updates for {{account}} will stop until you reconnect.",
      socialConnected: "Social account connected",
      socialConnectedDescription: "You can now submit posts owned by this account to CPM campaigns.",
      socialConnectionFailed: "Could not connect the account",
      socialConnectionFailedDescription: "Please try again.",
      socialOauthErrors: {
        accessDenied: "Authorization was canceled or denied. Please connect the account again.",
        alreadyConnected: "This account is already connected to another Autoclipper account. Disconnect it there or sign in to that account, then try again.",
        sessionExpired: "The connection session expired. Please start the connection again.",
        linkedinOrganizationRequired: "Connect a LinkedIn Company Page you administer. Personal profiles cannot import analytics.",
        facebook_page_required: "We could not connect a Facebook Page. Choose a Page you manage; personal profiles cannot be connected.",
        facebook_connections_unavailable: "Facebook Page connections are not available for your account yet.",
      },
      socialPopupBlocked: "Allow pop-ups to connect your social account.",
      socialOauthRelay: {
        title: "Connecting your account",
        body: "Continue in this window to authorize Autoclipper.",
        invalidPlatform: "This connection link is invalid. Close this window and try again from Account Settings.",
        startFailed: "We could not start the connection. Close this window and try again.",
      },
      socialDisconnected: "Social account disconnected",
      socialDisconnectFailed: "Could not disconnect the account",
      myPlan: "My Plan",
      plan: "Plan:",
      subscriptionCanceled: "Subscription canceled",
      pastDue: "Subscription payment is past due",
      pastDuePay: "Pay now",
      storeManaged: {
        app_store: "Managed by the App Store",
        google_play: "Managed by Google Play",
        manage: "Manage in the store",
      },
      pastDueGrace: "Pay by {{date}} to keep your plan",
      renewPixSubscription: "Renew PIX Subscription",
      renewPixTitle: "Renew Subscription via PIX",
      renewPixDescription: "Scan the QR Code or copy the PIX code to renew your subscription.",
      renewPixGenerating: "Generating QR Code...",
      renewPixError: "Error generating renewal QR Code. Please try again.",
      renewPixExpires: "Expires at",
      renewPixAmount: "Amount",
      renewPixCopyCode: "Copy PIX Code",
      renewPixCodeCopied: "PIX Code copied!",
      renewPixSuccess: "Payment confirmed! Your subscription has been renewed.",
      renewPixWaiting: "Waiting for payment...",
      renewPixCheckingStatus: "Checking payment status...",
      renewWithWallet: "Renew with balance",
      renewPlanNow: "Renew plan now",
      renewPayCard: "Pay by card",
      renewWalletTitle: "Renew your plan",
      renewWalletInsufficient: "Not enough balance. Renew from Plans.",
      renewWalletPriceUnavailable: "The renewal price is temporarily unavailable. You can still renew using PIX.",
      renewWalletGoPlans: "Go to plans",
      renewWalletSuccess: "Payment confirmed! Your plan was renewed.",
      buyExtraMinutesTitle: "Buy Extra Minutes",
      buyExtraMinutesDescription: "Extra minutes never expire and are only consumed when you exceed your plan limit.",
      buyExtraMinutesLabel: "Number of minutes",
      buyExtraMinutesHours: "{{hours}}h {{minutes}}min",
      buyExtraMinutesHoursOnly: "{{hours}}h",
      buyExtraMinutesMinutesOnly: "{{minutes}}min",
      buyExtraMinutesTotal: "Total",
      buyExtraMinutesPayCard: "Pay with Card",
      buyExtraMinutesPayPix: "Pay with PIX",
      buyExtraMinutesCpfCnpj: "CPF or CNPJ",
      buyExtraMinutesGeneratePix: "Generate PIX",
      buyExtraMinutesBack: "Back",
      buyExtraMinutesPixDescription: "Scan the QR Code or copy the PIX code to pay.",
      buyExtraMinutesCopyCode: "Copy PIX Code",
      buyExtraMinutesCodeCopied: "PIX Code copied!",
      buyExtraMinutesPixExpires: "Expires at",
      buyExtraMinutesPixWaiting: "Waiting for payment...",
      buyExtraMinutesSuccess: "Payment confirmed! Your extra minutes have been added.",
      buyExtraMinutesError: "Error processing payment. Please try again.",
      buyExtraMinutesPastDue: "Pay your subscription before buying extra minutes.",
      buyExtraMinutesWalletTitle: "Wallet balance",
      buyExtraMinutesWalletAvailable: "Available",
      buyExtraMinutesWalletRemainder: "Remainder to pay",
      buyExtraMinutesWalletApplied: "Balance applied",
      buyExtraMinutesWalletPayFull: "Pay with balance",
      buyExtraMinutesWalletPlusCard: "Balance + Card",
      buyExtraMinutesWalletPlusPix: "Balance + PIX",
      buyExtraMinutesMinimum: "Minimum 60 minutes",
      buyExtraMinutesPricePerMinute: "R$ 0.27 / minute",
      processingTime: "Processing Time",
      clipsUsed: "Clips Used",
      curationsUsed: "Curations Used",
      exportsUsed: "Exports Used",
      videoTime: "Video Time",
      upgradeToPro: "Upgrade to PRO",
      changePlan: "Change Plan",
      cancelSubscription: "Cancel Subscription",
      reactivateSubscription: "Reactivate Subscription",
      manageSubscription: "Manage Subscription",
      loading: "Loading...",
      usersOnPlan: "Users on Plan",
      invite: "Invite",
      master: "Master",
      leaveTeam: "Leave Team",
      userManagement: "User Management",
      availableOnGoldPlan: "Available only on Gold Plan.",
      inviteUser: "Invite User",
      invitationLink: "Invitation Link",
      shareLink: "Share this link with the person you want to invite to the plan.",
      regenerateLink: "Regenerate Invitation Link",
      regenerateLinkTitle: "Regenerate Invitation Link",
      regenerateLinkWarning: "Warning:",
      regenerateLinkDesc: "By regenerating the invitation link, all previous links will stop working. Users who have not yet accepted the invitation will need to receive the new link.",
      regenerating: "Regenerating...",
      changeProfilePicture: "Change Profile Picture",
      file: "File:",
      cancel: "Cancel",
      confirm: "Confirm",
      uploading: "Uploading...",
      cancelSubscriptionTitle: "Cancel Subscription",
      whyCanceling: "Why are you canceling the subscription?",
      selectReason: "Select a reason",
      cancellationReasons: {
        notExpected: "It wasn't what I expected",
        tooExpensive: "I found it expensive for what it offers",
        noTime: "I didn't have time to use it",
        technicalProblems: "I had technical problems",
        foundBetterTool: "I found a better tool",
        other: "Other",
      },
      whatReason: "What is the reason?",
      describeReason: "Describe the specific reason...",
      couldWeHaveDoneSomething: "Is there something we could have done to prevent the cancellation?",
      shareFeedback: "Help us improve by sharing your feedback...",
      sendAndContinue: "Send and Continue",
      sending: "Sending...",
      leaveTeamTitle: "Leave Team",
      leaveTeamConfirm: "Are you sure you want to leave the team? You will lose access to the shared plan and will need to be invited again to return.",
      leaving: "Leaving...",
      confirmLeave: "Confirm Leave",
      removeUser: "Remove User",
      removeUserConfirm: "Are you sure you want to remove <strong>{{name}}</strong> from the team? The user will immediately lose access to the shared plan.",
      removing: "Removing...",
      confirmRemoval: "Confirm Removal",
      notifications: "Notifications",
      profileUpdated: "Profile updated",
      profileUpdatedDesc: "Your profile was updated successfully.",
      profileUpdateError: "Error updating profile",
      profileUpdateErrorDesc: "Please try again.",
      profilePictureUpdated: "Profile picture updated",
      profilePictureUpdatedDesc: "Your profile picture was updated successfully.",
      uploadError: "Upload error",
      formatNotSupported: "Format not supported",
      onlyJpgPng: "Only JPG and PNG files are accepted.",
      fileTooLarge: "File too large",
      maxSize: "Maximum allowed size is 5MB.",
      feedbackSent: "Feedback sent",
      feedbackSentDesc: "Thank you for your feedback. You will be redirected to WhatsApp.",
      feedbackError: "Error sending feedback",
      leftTeam: "Left team successfully",
      leftTeamDesc: "You are no longer part of the team.",
      leaveTeamError: "Error leaving team",
      userRemoved: "User removed successfully",
      userRemovedDesc: "The user was removed from the team.",
      removeUserError: "Error removing user",
      roleChanged: "Role changed successfully",
      roleChangedDesc: "The user's role was changed to {{role}}.",
      roleChangeError: "Error changing role",
      invitationRegenerated: "Invitation link regenerated",
      invitationRegeneratedDesc: "The new invitation link was generated successfully. Previous links will no longer work.",
      invitationRegenerateError: "Error regenerating link",
      featureUnavailable: "Feature Unavailable",
      featureOnGoldPlan: "This feature is only available on the Gold Plan.",
      microsoftAccess: "Access via Microsoft",
      switchToOwnContent: {
        cta: "Use content creator mode",
        hint: "Your home page and how used minutes count will change.",
        title: "Switch to content creator mode?",
        getHeading: "You'll get",
        getHome: "Projects as your home page",
        getWorkflow: "A workspace made for content creators",
        getUnlimitedClips: "Unlimited clips",
        loseHeading: "You'll lose",
        loseHome: "Browse Library as your home page",
        loseMinutes: "Counting used minutes on Browse Library — those minutes will count on your own videos instead",
        loseNoMigrate: "Projects and clips from clipper mode — they stay there and are not moved here",
        loseAcervo: "Using Browse Library videos to make clips",
        keep: "You can switch back anytime. Clip & Pix and the rest of this month stay as they are.",
        confirm: "Switch",
        cancel: "Cancel",
        error: "Could not switch right now. Try again.",
      },
      switchToClippingChannels: {
        cta: "Use clipper mode",
        hint: "Your home page and how used minutes count will change.",
        title: "Switch to clipper mode?",
        getHeading: "You'll get",
        getHome: "Browse Library as your home page",
        getWorkflow: "A workspace made for clipper mode",
        getAcervo: "Access to Browse Library",
        getUnlimitedCurations: "Unlimited curations",
        getClips: "{{count}} clips per month",
        getUnlimitedClips: "Unlimited clips",
        loseHeading: "You'll lose",
        loseHome: "Projects as your home page",
        loseMinutes: "Counting used minutes on your own videos — those minutes will count on Browse Library instead",
        loseNoMigrate: "Projects from content creator mode — they stay there and are not moved here",
        keep: "You can switch back anytime. Clip & Pix and the rest of this month stay as they are.",
        confirm: "Switch",
        cancel: "Cancel",
        error: "Could not switch right now. Try again.",
      },
      onboarding: {
        title: "Usage Preferences",
        objective: "What is your main goal?",
        selectObjective: "Select your objective",
        dailyVolume: "What daily volume do you expect?",
        selectDailyVolume: "Select daily volume",
        savePreferences: "Save Preferences",
      },
    },

    clipperFeatureNag: {
      title: "This is a clipper feature",
      communityLibraryBody: "Browse Library is made for clipper mode. You can keep using it — anything you make here becomes one of your projects.",
      earnBody: "Clip & Pix is built for clippers. You can keep using it — your workspace is still set up for content creator mode.",
      continue: "Continue",
      dontShowAgain: "Do not show this again",
    },

    // Tutorials
    tutorials: {
      title: "Autoclipper Tutorials",
      subtitle: "Learn to use all Autoclipper features with our video tutorials",
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
    },

    // Project Card
    projectCard: {
      readyToProcess: "Ready to process",
      processing: "Processing",
      completed: "Completed",
      failed: "Failed",
      clips: "clips",
      viewProject: "View project",
      estimate: "Estimate: {{time}}",
      noPreview: "No preview",
      removeProject: "Remove project",
      removeProjectConfirm: "Are you sure you want to remove this project?",
      removeProjectWarning: "The minutes from this project will not be refunded.",
      removing: "Removing...",
      remove: "Remove",
      viewExportedClips: "View Exported Clips",
      editClipsManually: "Edit Clips Manually",
      exportedClipsTooltip: "You need to export at least 1 clip to view exported clips",
      modeCopilot: "Copilot",
      modeAutomatic: "Automatic",
      duplicateProject: "Reprocess",
      originalVideoDownload: {
        triggerLabel: "Download original video",
        title: "Download original video?",
        description: "This file is the full original video ({{sourceDuration}}).",
        descriptionWithoutDurations: "This file is the full original video.",
        cancel: "Cancel",
        confirm: "Download original video",
        proTitle: "Downloading the original video is PRO",
        proBody: "On the free plan you can generate clips. Upgrade to download the original file.",
        proDismiss: "Not now",
        proUpgrade: "Upgrade",
      },
    },

    // Duplicate Project Dialog
    duplicateProject: {
      title: "Reprocess Project",
      description: "Reprocess this video with different settings. Choose a new format, prompt, and template.",
      confirm: "Reprocess",
      creating: "Creating...",
      success: "Project created",
      successDescription: "The project has been created and will be processed shortly.",
      error: "Failed to create project",
      replacePdf: "Replace PDF (optional)",
      replacePdfHint: "Leave empty to keep the original PDF.",
      selectPdf: "Click to select a PDF",
      uploadingPdf: "Uploading PDF...",
      invalidPdf: "Only .pdf files are accepted",
      pdfUploadError: "PDF upload failed. Please try again.",
    },

    // Export Modal
    exportModal: {
      title: "Export Clip",
      exporting: "Exporting...",
      export: "Export",
      chooseFormat: "Choose export format",
      horizontal: "Horizontal",
      horizontalDescription: "16:9 format ideal for YouTube, websites and other horizontal video platforms.",
      exportHorizontal: "Export Horizontal",
      vertical: "Vertical",
      verticalDescription: "9:16 format ideal for TikTok, Instagram Reels, YouTube Shorts and social media.",
      exportVertical: "Export Vertical",
    },

    // Error Messages
    errors: {
      invalidFileType: "Invalid file type",
      onlyMp4Accepted: "Only .mp4 files are accepted",
      failedToReadVideo: "Failed to read video",
      couldNotDetermineDuration: "Could not determine video duration.",
      videoHasNoAudio: "Video has no audio",
      videoHasNoAudioDescription: "This video has no audio track, so it can't be transcribed. Export it again with audio turned on and upload it again.",
      liveVideo: "Live video",
      insertNonLiveVideo: "Insert a video link that is not live.",
      videoProcessing: "Video processing",
      videoStillProcessing: "This video is still being processed by YouTube, wait for processing to finish",
      scheduledVideo: "Scheduled video",
      insertAvailableVideo: "Insert a video link that is already available.",
      youtubeOnly: "Only YouTube links are accepted",
      youtubeOnlyDescription: "The library only supports YouTube video links.",
      videoTooLong: "Video too long",
      videoTooLongDescription: "Only videos up to {{hours}}h long are accepted for your plan.",
      videoAnalysisError: "Error analyzing video",
      checkVideoLink: "Could not analyze the video. Check if the link is correct.",
      uploadError: "Upload error",
      uploadErrorOccurred: "An error occurred during the file upload.",
      proFeatureRequired: "PRO Feature Required",
      fileUploadProOnly: "File upload is available only for PRO users. Upgrade to access this feature.",
      googleDriveProOnly: "Google Drive is available only for PRO users. Upgrade to access this feature.",
    },

    // Validation
    validation: {
      required: "This field is required",
      invalidEmail: "Invalid email address",
      minLength: "Must be at least {{min}} characters",
      maxLength: "Must be at most {{max}} characters",
      passwordsDoNotMatch: "Passwords do not match",
    },

    // Time and Duration
    time: {
      seconds: "{{count}}s",
      minutes: "{{count}}m",
      hours: "{{count}}h",
      days: "{{count}}d",
      ago: "ago",
      remaining: "remaining",
    },

    // File Size
    fileSize: {
      bytes: "B",
      kilobytes: "KB",
      megabytes: "MB",
      gigabytes: "GB",
    },

    // Brand Kits page
    brandKits: {
      title: "Templates",
      subtitle: "Manage all your customized templates",
      brandKitsCount: "{{count}} of {{max}} templates created",
      createNewBrandKit: "Create New Template",
      createFirstBrandKit: "Create First Template",
      noBrandKitFound: "No template found",
      noBrandKitCreated: "No template created",
      adjustSearch: "Try adjusting your search or creating a new template.",
      startCreatingBrandKit: "Start by creating your first template to personalize your videos.",
      loadingBrandKits: "Loading templates...",
      errorLoadingBrandKits: "Error loading templates",
      errorLoadingBrandKitsDesc: "Could not load your templates. Try again.",
      tryAgain: "Try again",
      deletedSuccess: "Template deleted successfully!",
      errorDeleting: "Error deleting template. Try again.",
      setAsDefaultSuccess: "Template set as default successfully!",
      errorSettingDefault: "Error setting template as default. Try again.",
      default: "Default",
      edit: "Edit",
      setAsDefault: "Set as Default",
      setting: "Setting...",
      delete: "Delete",
      deleting: "Deleting...",
      confirmDelete: "Confirm Deletion",
      confirmDeleteDefault: "Are you sure you want to delete the default template \"{{name}}\"? This action cannot be undone and you will need to set another template as default.",
      confirmDeleteNormal: "Are you sure you want to delete the template \"{{name}}\"? This action cannot be undone.",
      cancel: "Cancel",
      logoNotDefined: "Logo: Not defined",
      logo: "Logo",
      logoCouldNotLoad: "Logo could not be loaded",
      colorPalette: "Color Palette",
      titleFont: "Title Font",
      bodyFont: "Body Font",
      subtitleFont: "Subtitle Font",
      notDefined: "Not defined",
      unnamed: "Unnamed template",
      sampleText: "Sample Text",
      created: "Created:",
      updated: "Updated:",
      reachedLimit: "You have reached the limit of {{max}} templates on your plan",
      tour: {
        welcome: "Welcome to Templates! Here you can create and manage custom templates with fonts, colors, logos and subtitle styles.",
        createButton: "Click here to create a new template. You can customize fonts, colors, logos and subtitles for your videos.",
        grid: "Here all your created templates appear. Click on a card to edit or manage an existing template.",
        helpButton: "Click here to see the templates tour again.",
      },
    },

    // My Media page
    myMedia: {
      title: "My Media",
      subtitle: "Your personal library of uploaded images, videos and audio — reuse them across projects.",
      upload: "Upload",
      uploading: "Uploading…",
      searchPlaceholder: "Search by name…",
      picker: {
        title: "Choose from My Media",
        description: "Reuse an image you already uploaded. Search by name or narrow the list by folder.",
        open: "My Media",
        images: "My images",
        searchPlaceholder: "Search your images…",
        folderFilter: "Filter images by folder",
        browseStock: "Browse stock",
        uploadInstead: "Upload new",
        loading: "Loading your images…",
        emptyTitle: "No images found",
        emptyDescription: "Try another search or folder, or upload a new image from your computer.",
      },
      kind: {
        all: "All",
        image: "Images",
        video: "Videos",
        audio: "Audio",
      },
      folders: {
        all: "All",
        root: "No folder",
        options: "Folder options",
        new: "New folder",
        newTitle: "New folder",
        nameLabel: "Name",
        namePlaceholder: "E.g. B-roll, Logos, Music…",
        create: "Create",
        creating: "Creating…",
        rename: "Rename",
        renameTitle: "Rename folder",
        delete: "Delete",
        confirmDeleteTitle: "Delete this folder?",
        confirmDeleteBody: "The folder \"{{name}}\" will be removed. Media inside it will not be deleted — it moves back to \"No folder\".",
      },
      item: {
        rename: "Rename",
        renameTitle: "Rename item",
        moveTo: "Move to folder",
        delete: "Delete",
        confirmDeleteTitle: "Delete this item?",
        confirmDeleteBody: "\"{{name}}\" will be permanently deleted from your media library. This cannot be undone. Projects that use this file may lose access to it.",
        untitled: "Untitled",
      },
      empty: "You haven't uploaded any media yet. Click Upload to add images, videos or audio.",
      noResults: "No media matches your filters.",
      errorLoading: "Could not load your media. Try again.",
      retry: "Try again",
      loadMore: "Load more",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving…",
      deleting: "Deleting…",
      toast: {
        unsupportedType: "Unsupported file type.",
        uploadError: "Upload failed. Try again.",
        folderError: "Something went wrong with the folder. Try again.",
        itemError: "Something went wrong. Try again.",
      },
    },

    // API Keys page
    apiKeys: {
      title: "API Keys",
      subtitle: "Manage your API keys for integration.",
      newKey: "New Key",
      createNewApiKey: "Create New API Key",
      createNewApiKeyDesc: "Create a new API key for integration.",
      keyName: "Key Name",
      keyNamePlaceholder: "E.g. Production Key, Test Key, etc.",
      cancel: "Cancel",
      creating: "Creating...",
      createKey: "Create Key",
      failedToLoad: "Failed to load API keys",
      noApiKeys: "No API keys",
      noApiKeysDesc: "You haven't created any API key yet. Create your first key to start integrating.",
      createFirstKey: "Create First Key",
      createdAt: "Created on",
      edit: "Edit",
      delete: "Delete",
      apiKey: "API Key",
      copy: "Copy",
      editApiKey: "Edit API Key",
      editApiKeyDesc: "Change your API key name.",
      saving: "Saving...",
      saveChanges: "Save Changes",
      deleteApiKey: "Delete API Key",
      deleteApiKeyDesc: "Are you sure you want to delete this API key? This action cannot be undone and all integrations using this key will stop working.",
      deleting: "Deleting...",
      toast: {
        error: "Error",
        keyNameRequired: "Key name is required",
        success: "Success",
        keyCreated: "API key created successfully",
        keyCreateError: "Failed to create API key",
        keyUpdated: "API key updated successfully",
        keyUpdateError: "Failed to update API key",
        keyDeleted: "API key deleted successfully",
        keyDeleteError: "Failed to delete API key",
        copied: "Copied",
        keyCopied: "API key copied to clipboard",
        copyError: "Failed to copy API key",
      },
    },

    // API Requests page
    apiRequests: {
      title: "API Requests",
      noName: "No name",
      failedToLoad: "Failed to load API requests.",
      noRequests: "No API requests found.",
      loadingMore: "Loading more...",
      webhookRetriggered: "Webhook notification sent successfully",
      webhookRetriggerFailed: "Failed to retrigger webhook",
      stats: {
        total: "Total",
      },
      card: {
        source: "Source",
        copyWebhookUrl: "Copy webhook URL",
        retriggerWebhook: "Retrigger webhook",
      },
      status: {
        processing: "Processing",
        completed: "Completed",
        failed: "Failed",
        pending: "Pending",
        expired: "Expired",
      },
    },

    // API Documentation page
    apiDocumentation: {
      title: "Autoclipper API Documentation",
      subtitle: "Integrate powerful AI-driven video clipping into your applications. Transform long-form videos into engaging clips with just a few API calls.",
      getStarted: "Get Started",
      tryPlayground: "Try Playground",
      apiReference: "API Reference",
      apiEndpoints: "API Endpoints",
      apiArchitecture: "API Architecture",
      responseFormat: "Response Format",
      quickStart: "Quick Start",
      quickStartDescription: "Get up and running with the Autoclipper API in three simple steps",
      step1Title: "Get Your API Key",
      step1Description: "Generate an API key from your dashboard to authenticate requests",
      getApiKey: "Get API Key",
      step2Title: "Create a Project",
      step2Description: "Submit a video URL to start the automated clipping process",
      tryExample: "Try Example",
      step3Title: "Monitor Progress",
      step3Description: "Check project status and retrieve generated clips when ready",
      viewDocs: "View Docs",
      keyFeatures: "Key Features",
      keyFeaturesDescription: "Powerful video processing capabilities at your fingertips",
      features: {
        autoClipGeneration: "Automatic Clip Generation",
        autoClipGenerationDescription: "AI-powered video analysis to create engaging clips from long-form content",
        multiLanguageSupport: "Multi-language Support",
        multiLanguageSupportDescription: "Process videos in multiple languages with accurate subtitle generation",
        realtimeUpdates: "Real-time Status Updates",
        realtimeUpdatesDescription: "Track processing status and receive webhook notifications when clips are ready",
        webhookNotifications: "Webhook Notifications",
        webhookNotificationsDescription: "Automatic POST notifications to your endpoint when processing completes",
        multipleFormats: "Multiple Output Formats",
        multipleFormatsDescription: "Choose from various clip length formats to suit your content strategy",
      },
      codeExamples: "Code Examples",
      codeExamplesDescription: "Sample requests to help you get started quickly",
      createProject: "Create Project",
      listProjects: "List Projects",
      getProject: "Get Project",
      additionalResources: "Additional Resources",
      additionalResourcesDescription: "Explore more documentation and tools to enhance your integration",
      gettingStartedGuide: "Getting Started Guide",
      gettingStartedGuideDescription: "Step-by-step tutorial for beginners",
      interactivePlayground: "Interactive Playground",
      interactivePlaygroundDescription: "Test API endpoints directly",
      apiReferenceTitle: "API Reference",
      apiReferenceDescription: "Complete endpoint documentation",
      openApiSpec: "OpenAPI Specification",
      openApiSpecDescription: "Machine-readable API specification",
      manageApiKeys: "API Key Management",
      manageApiKeysDescription: "Generate and manage your API keys",
    },

    // API Playground
    apiPlayground: {
      copiedToClipboard: "Copied to clipboard",
      copiedDescription: "The content has been copied to your clipboard.",
      selectApiKeyFirst: "Please select an API key first",
      enterProjectId: "Please enter a project ID",
      title: "API Playground",
      subtitle: "Test the Autoclipper API endpoints directly from your browser",
      authentication: "Authentication",
      selectApiKeyDescription: "Select an API key to authenticate your requests",
      loadingApiKeys: "Loading API keys...",
      chooseApiKey: "Choose API Key",
      selectApiKey: "Select an API key",
      noApiKeys: "No API keys found.",
      createOneHere: "Create one here",
      makeRequest: "Make Request",
      configureAndSend: "Configure and send API requests",
      videoUrl: "Video URL *",
      projectName: "Project Name *",
      format: "Format *",
      language: "Language *",
      webhookUrl: "Webhook URL",
      prompt: "Prompt",
      brandKitId: "Template",
      brandKitDefault: "Default (account template or Basic)",
      brandKitOverridePlaceholder: "Optional template override",
      myBrandKits: "My Templates",
      publicBrandKits: "Public Templates",
      promptPlaceholder: "Additional instructions for clip generation...",
      createProject: "Create Project",
      listProjects: "List Projects",
      getProject: "Get Project",
      createProjectDescription: "Create a new video project for processing",
      listProjectsDescription: "Get a list of your projects",
      getProjectDescription: "Get details of a specific project",
      formatAuto: "Auto - AI determines optimal length",
      formatMax1Min: "Max 1 Minute",
      formatMax30Sec: "Max 30 Seconds",
      langPtBr: "Portuguese (Brazil)",
      langEnUs: "English (US)",
      langEsEs: "Spanish (Spain)",
      limit: "Limit",
      offset: "Offset",
      projectId: "Project ID *",
      projectIdPlaceholder: "Enter project ID from list or create response",
      response: "Response",
      responseDescription: "View API responses and debug information",
      requestUrl: "Request URL",
      requestBody: "Request Body",
      makingRequest: "Making request...",
      error: "Error:",
      emptyResponse: "Select an API key and make a request to see the response here",
      codePreview: "Code Preview",
      codePreviewDescription: "Copy-paste examples for your preferred language",
      copy: "Copy",
      needHelp: "Need Help?",
      gettingStarted: "Getting Started",
      learnBasics: "Learn the basics",
      apiReference: "API Reference",
      completeDocumentation: "Complete documentation",
      manageApiKeys: "Manage API Keys",
      createAndManageKeys: "Create and manage keys",
    },

    // Invitation Accept page
    invitation: {
      invalidToken: "Invalid invitation token",
      teamInvitation: "Team Invitation",
      invitedToTeam: "You have been invited to join a team on Autoclipper",
      acceptingInvitation: "By accepting this invitation, you will become part of a team and can:",
      accessTeamProjects: "Access team projects",
      ownerPermissions: "The team owner can determine if you have permission to submit projects or create clips.",
      accepting: "Accepting...",
      acceptInvitation: "Accept Invitation",
      cancel: "Cancel",
      processingInvitation: "Processing Invitation",
      acceptingTeamInvitation: "Accepting team invitation...",
      invitationAccepted: "Invitation Accepted!",
      welcomeToTeam: "Welcome to the team!",
      redirectingToProjects: "You will be redirected to your projects shortly...",
      invitationError: "Invitation Error",
      couldNotAccept: "Could not accept the invitation",
      backToProjects: "Back to Projects",
      toast: {
        acceptedSuccess: "Invitation accepted successfully!",
        acceptedDesc: "You are now part of the team. You will be redirected shortly.",
        errorAccepting: "Error accepting invitation",
      },
    },

    linkAccount: {
      connectingAs: "Connecting account:",
      title: "Connect your account",
      description: "Connect your Autoclipper account so the bot can create clips for you.",
      confirmButton: "Connect account",
      connecting: "Connecting...",
      successTitle: "Account connected!",
      successDescription: "You can head back to the bot chat now.",
      errorTitle: "Couldn't connect",
      tryAgain: "Try again",
      error: {
        invalidCode: "This link is invalid, expired, or already used. Ask the bot for a new one.",
        missingCode: "This link is missing its code. Ask the bot for a new one.",
        generic: "Something went wrong. Please try again in a moment.",
      },
    },
    botConnection: {
      title: "Bot connections",
      channelName: { telegram: "Telegram", whatsapp: "WhatsApp" },
      connectedSince: "Connected since {{date}}",
      description: "Your Autoclipper account is connected to the bot.",
      disconnectButton: "Disconnect {{channel}} bot",
      confirmTitle: "Disconnect {{channel}} bot?",
      confirmBody: "You'll need to re-link from the bot chat to use it again.",
      cancel: "Cancel",
      confirmDisconnect: "Disconnect",
      disconnectedTitle: "Bot disconnected",
      disconnectedDesc: "Your {{channel}} bot connection was removed.",
      errorTitle: "Couldn't disconnect",
      errorDesc: "Something went wrong. Please try again in a moment.",
    },

    // Clip Titles Dialog
    clipTitles: {
      title: "Copy",
      generate: "Generate Copy",
      titlesAndSuggestions: "Titles and Suggestions",
      titlesGeneratedBy: "Titles and descriptions generated by AI for:",
      mainTitles: "Main Titles",
      description: "Description",
      copyDescription: "Copy description",
      tags: "Tags",
      copyAllTags: "Copy all tags",
      noTitlesGenerated: "No titles have been generated yet for this clip.",
      clickToGenerate: "Click the button below to generate titles, descriptions and tags using AI.",
      copyAll: "Copy All",
      downloadTxt: "Download TXT",
      close: "Close",
      regenerate: "Regenerate",
      generateTitles: "Generate Titles",
      startingGeneration: "Starting generation...",
      generatingTitles: "Generating titles and descriptions...",
      toast: {
        copied: "Copied!",
        copiedToClipboard: "Text copied to clipboard",
      },
    },

    // Quota Warning
    quotaWarning: {
      limitReached: "Monthly clip limit reached. Upgrade your plan to continue.",
      viewPlans: "View plans",
      approaching: {
        clips: "{{remaining}} clip left on your plan this month.",
        processing_time: "You've used {{percentage}}% of this month's processing time.",
        library_curations: "{{remaining}} curation left on your plan this month.",
        library_exports: "{{remaining}} export left on your plan this month.",
        library_video_time: "You've used {{percentage}}% of this month's library video time.",
      },
    },

    // Profile Completion Modal
    profileCompletion: {
      title: "Complete your profile",
      subtitle: "We need some information to personalize your experience.",
      name: "Full name",
      namePlaceholder: "Enter your full name",
      phoneNumber: "Phone number",
      jobTitle: "What is your role?",
      jobTitlePlaceholder: "Select your role",
      objective: "What is your main goal?",
      dailyVolume: "What daily volume do you expect?",
      saving: "Saving...",
      continue: "Continue",
      toast: {
        success: "Profile updated",
        profileUpdated: "Your profile was updated successfully.",
        error: "Error updating",
        couldNotUpdate: "Could not update your profile. Try again.",
      },
    },

    // Onboarding Modal
    hireClippers: {
      title: "Hire clippers",
      subtitle: "Tell us about your brand and our team sets up a campaign with clippers posting clips of your content. You pay for the views delivered.",
      stepCounter: "Step {{current}} of {{total}}",
      steps: {
        demandType: { title: "Who are you?" },
        objective: { title: "What is your main goal?" },
        contentType: { title: "What do you already have?", hint: "Choose one or more options." },
        platforms: { title: "Where do you want to distribute?" },
        budget: { title: "How much do you plan to invest?" },
        contact: { title: "How do we reach you?" },
      },
      options: {
        demandType: {
          brand: "Brand",
          creator: "Creator",
          agency: "Agency",
          infoproducer: "Digital product seller",
          podcast: "Podcast",
          mediaGroup: "Media group",
          seller: "Seller / e-commerce",
          other: "Other",
        },
        objective: {
          awareness: "Awareness",
          distributeContent: "Distribute content",
          launch: "Launch",
          growAudience: "Grow audience",
          sales: "Drive sales",
          distributePodcast: "Distribute a podcast",
          other: "Other",
        },
        contentType: {
          readyContent: "Ready content",
          podcast: "Podcast",
          longVideos: "Long videos",
          creators: "Creators",
          ugc: "UGC",
          archive: "Content archive",
          product: "Product",
          needToProduce: "I still need to produce it",
        },
        platforms: {
          tiktok: "TikTok",
          instagram: "Instagram",
          youtube: "YouTube",
          multiple: "Several",
        },
        budget: {
          undecided: "Still deciding",
          range_5k_10k: "R$5k to R$10k",
          range_10k_20k: "R$10k to R$20k",
          range_20k_50k: "R$20k to R$50k",
          range_50k_150k: "R$50k to R$150k",
          range_150k_plus: "Over R$150k",
        },
      },
      fields: {
        name: "Your name",
        company: "Company / project",
        email: "Email",
        whatsapp: "WhatsApp",
        country: "Country",
        search: "Search country",
        notFound: "No country found.",
        placeholder: "(11) 99999-9999",
      },
      actions: {
        back: "Back",
        next: "Continue",
        submit: "Send",
        submitting: "Sending…",
      },
      errors: {
        required: "Choose at least one option to continue.",
        invalidName: "Enter your name.",
        invalidEmail: "Check the email.",
        invalidPhone: "Check the WhatsApp number: use a valid mobile number with area code.",
        submit: "We couldn't send it right now. Check your details and try again.",
      },
      success: {
        title: "We got your request",
        description: "Our team will reach you on WhatsApp soon to set up your campaign.",
        cta: "Meanwhile, try the AI clipper",
      },
    },
    onboarding: {
      saving: "Saving...",
      objective: {
        question: "What is your goal with AutoClipper?",
        subtitle: "Choose the option that best describes what you want to do right now.",
        hireClippers: {
          heading: "I want to hire clippers",
          title: "You don't edit anything",
          description: "Our team runs a clipper campaign and you pay for the views.",
        },
        clippingChannels: {
          heading: "I'm a Clipper",
          title: "Create content to make money with my clipping channels",
          description: "Find content, speed up your workflow, and build channels that monetize.",
        },
        aiClipping: {
          heading: "I'm a creator, brand or agency",
          title: "I want to use the AI clipper",
          description: "Turn videos, podcasts and livestreams into ready-to-publish clips.",
        },
      },
      experience: {
        question: "How would you describe your experience with clipping channels?",
        subtitle: "Your answer helps us recommend the most useful next step.",
        options: {
          starting_from_zero: "I'm starting from scratch",
          started_not_monetizing: "I've started, but I'm not monetizing yet",
          experienced_with_clips: "I already have experience creating clips",
          monetizing_clipping_channel: "I already monetize my clipping channel",
        },
      },
      courseOffer: {
        eyebrow: "Your next step",
        title: "Go Viral in 4 Weeks",
        description: "A practical path from planning your channel to building a consistent publishing routine.",
        detail: "Learn to choose niches, create high-potential clips, and build a monetization strategy.",
        visualLabel: "04 weeks / practical plan",
        player: {
          play: "Play video",
          pause: "Pause video",
          seek: "Video position",
          mute: "Mute",
          unmute: "Unmute",
          volume: "Volume",
          fullscreen: "Full screen",
          enableAudio: "Tap to enable audio",
          errorTitle: "This video could not be loaded",
          retry: "Try again",
        },
        primary: "Explore Viralize",
        secondary: "Not now",
      },
      communityOffer: {
        title: "Join the largest community of clippers in Brazil!",
        description: "Join The Clippers community on WhatsApp and connect with other clippers.",
        primary: "I want to join!",
        secondary: "Not now.",
      },
      toast: {
        error: "Error updating",
        couldNotUpdate: "Could not update your profile. Try again.",
      },
    },

    // Clip Edit page
    clipEdit: {
      loadingClip: "Loading clip…",
      errorLoading: "Error loading the clip.",
      clipNotFound: "Clip not found.",
      clipExpired: "This clip has expired and cannot be edited.",
      preparingClip: "Preparing clip…",
      waitForGeneration: "Wait for the current generation of this clip...",
      estimate: "Estimate:",
    },
    clipStudio: {
      title: "AutoCut Studio",
      beta: "Beta",
      open: "AutoCut Studio",
      back: "Back",
      loading: "Opening AutoCut Studio…",
      unavailable: "This clip could not be found.",
      sourcePreparing: "This clip's video is still being prepared. Try again in a few minutes.",
      sourceUnavailable: "This clip's video is no longer available.",
      goToClips: "Back to clips",
      unsupported: "AutoCut Studio cannot open {{composition}} clips yet.",
      loadFailed: "Could not open AutoCut Studio.",
      saving: "Saving…",
      saved: "Saved",
      saveFailed: "Could not save the studio project.",
      restart: "Start over from the clip",
      restartTitle: "Start over from the current clip?",
      restartDescription: "This clip's studio project will be replaced by the clip as it is now in the editor.",
      cancel: "Cancel",
      confirmRestart: "Start over",
      warnings: "Not shown in the studio yet: {{list}}",
    },

    // Community Modal
    community: {
      title: "The Clippers Community",
      joinNow: "I want to join",
      close: "Close",
    },

    // WhatsApp Community Gate (hard block)
    communityGate: {
      title: "Join the Clippers community",
      description: "Join our official WhatsApp community — it's where we share updates, tips, and answer questions in real time.",
      bullet1: "Be the first to hear about new features and updates",
      bullet2: "Ask questions directly to the team and other creators",
      bullet3: "Learn viral content strategies from the community",
      cta: "Join the WhatsApp community",
      dismiss: "Maybe later",
      footer: "You'll be redirected to WhatsApp in a new tab.",
    },

    // News PDF Upload Modal
    newsPdf: {
      title: "News Mode",
      projectName: "Project Name",
      projectNamePlaceholder: "Enter project name...",
      pdfFile: "PDF File",
      clickToSelectPdf: "Click to select the PDF",
      mp4Video: "MP4 Video",
      clickToSelectMp4: "Click to select the MP4 video",
      brandKitOptional: "Template (Optional)",
      loadingBrandKits: "Loading templates...",
      selectBrandKit: "Select a template (optional)",
      proOnlyFeature: "Feature available only in PRO plan",
      noBrandKit: "No template",
      myBrandKits: "My Templates",
      default: "Default",
      publicBrandKits: "Public Templates",
      brandKitTip: "💡 The selected template will be automatically applied to generated clips.",
      brandKitProOnly: "🔒 Upgrade to PRO plan to use custom templates.",
      createFirstBrandKit: "Create your first Template",
      brandKitDescription: "Customize your videos with your brand's colors, logos and fonts. Templates ensure visual consistency across all your clips.",
      createBrandKit: "Create Template",
      uploadingPdf: "Uploading PDF...",
      uploadingMp4: "Uploading MP4 video...",
      cancel: "Cancel",
      uploadingFiles: "Uploading files...",
      creating: "Creating...",
      createProject: "Create Project",
      toast: {
        invalidFileType: "Invalid file type",
        onlyMp4: "Only .mp4 files are accepted for video",
        onlyPdf: "Only .pdf files are accepted",
        failedToReadVideo: "Failed to read video",
        couldNotDetermineDuration: "Could not determine video duration.",
        requiredFiles: "Required files",
        selectBothFiles: "Please select both the MP4 video and the PDF.",
        pdfUploadError: "Error uploading PDF",
        pdfUploadErrorDesc: "An error occurred during PDF upload.",
        mp4UploadError: "Error uploading video",
        mp4UploadErrorDesc: "An error occurred during video upload.",
        projectCreated: "Project created successfully! 🎉",
        projectAdded: "\"{{name}}\" was added to your project list.",
        projectError: "Error creating project",
        projectErrorDesc: "An error occurred while creating the project. Try again.",
      },
    },

    // Configure Subtitles Modal
    configureSubtitles: {
      title: "Configure Subtitles with Templates",
      description: "Select a template to preview and apply subtitles to the {{count}} selected clips",
      availableBrandKits: "Available Templates",
      noBrandKitFound: "No template found",
      createBrandKit: "Create Template",
      myBrandKits: "My Templates",
      publicBrandKits: "Public Templates",
      default: "Default",
      public: "Public",
      subtitle: "Subtitle",
      loadingClipData: "Loading clip data...",
      selectClipToPreview: "Select a clip to preview",
      noTranscription: "No transcription available for this clip",
      loadingPreview: "Loading preview...",
      clipHasNoSubtitles: "The clip has no subtitles",
      brandKitWillBeApplied: "The template will be applied to selected clips",
      editBrandKit: "Edit Template",
      applying: "Applying...",
      applyToClips: "Apply to {{count}} Clips",
      selectBrandKitToPreview: "Select a template to preview",
      selectedClips: "Selected Clips ({{count}})",
      noClipSelected: "No clip selected",
      clip: "Clip",
      landscapeFormat: "Landscape Format (16:9)",
      portraitFormat: "Portrait Format (9:16)",
      portraitWarning: "The video will be automatically cropped according to speaking faces detected in the video.",
      toast: {
        error: "Error",
        noBrandKitSelected: "No template selected",
        success: "Success!",
        appliedToClips: "Template applied to {{count}} clip(s). Videos are being rendered.",
        partiallyCompleted: "Partially completed",
        appliedWithErrors: "Template applied to {{success}} clip(s). {{errors}} failed.",
        applyError: "Could not apply template to clips.",
        unexpectedError: "An error occurred while applying template.",
        clipsTooLong: "{{count}} clip(s) exceed the 15-minute limit for subtitle rendering and were skipped.",
        allClipsTooLong: "All selected clips exceed the 15-minute limit for subtitle rendering.",
      },
      tooLong: "Too long",
      editor: {
        customize: "Customize",
        readOnly: "read-only",
        save: "Save",
        saving: "Saving...",
        brandKitSaved: "Template saved successfully.",
        saveError: "Could not save template changes.",
        fontAndText: "Font & Text",
        font: "Font",
        fontSize: "Font Size",
        textColor: "Text Color",
        overridesPaletteDefault: "Overrides palette default",
        revertToPaletteDefault: "Palette default",
        textAlign: "Text Alignment",
        textTransform: "Letter case",
        textTransformNone: "Aa",
        textTransformNoneTooltip: "As typed — keep the original letter case",
        textTransformUppercase: "AA",
        textTransformUppercaseTooltip: "All uppercase",
        textTransformLowercase: "aa",
        textTransformLowercaseTooltip: "All lowercase",
        textTransformSmallCaps: "Small Caps",
        textTransformSmallCapsTooltip: "Small caps — first letter full height, the rest reduced",
        removePunctuation: "Remove punctuation",
        removePunctuationHint: "Strips periods, commas, and question marks from subtitle words",
        highlight: "Word Highlight",
        highlightCurrentWord: "Highlight Current Word",
        highlightColor: "Highlight Color",
        highlightBox: "Highlight Box",
        highlightBoxColor: "Box Background Color",
        borderRadius: "Border Radius",
        paddingX: "Horizontal Padding",
        paddingY: "Vertical Padding",
        positionAndLayout: "Position & Layout",
        verticalPosition: "Vertical Position",
        verticalMargin: "Vertical Margin",
        horizontalMargin: "Horizontal Margin",
        maxWordsPerLine: "Max Words per Line",
        animation: "Animation",
        animationPrevious: "Previous animations",
        animationNext: "Next animations",
        tabHighlight: "Highlight",
        tabPosition: "Position",
        tabEffects: "Effects",
        background: "Background",
        enableBackground: "Enable Background",
        backgroundColor: "Background Color",
        opacity: "Opacity",
        width: "Width",
        height: "Height",
        shadow: "Shadow",
        enableShadow: "Enable Shadow",
        shadowColor: "Shadow Color",
        shadowSize: "Shadow Size",
        enableOutline: "Enable Outline",
        outlineColor: "Outline Color",
        outlineWidth: "Outline Width",
        shadowStyleGlow: "Glow",
        shadowStyleDrop: "Drop",
        shadowOffsetX: "Horizontal offset",
        shadowOffsetY: "Vertical offset",
        logo: "Logo",
        uploadLogo: "Upload Logo",
        logoUploaded: "Logo uploaded",
        logoPosition: "Logo Position",
        logoOpacity: "Opacity",
        logoSize: "Size",
        hMargin: "H. Margin",
        vMargin: "V. Margin",
        unsavedChanges: "unsaved changes",
        applying: "Applying...",
        applyToSelected: "Apply to {{count}} selected",
        selectedClipsCount: "{{count}} clip(s) selected",
        selectClipsHint: "Select clips below to apply template",
        livePreview: "Live Preview",
      },
    },

    // Project page
    project: {
      title: "Project",
      back: "Back",
    },

    // Vertical Clip Card
    verticalClipCard: {
      clipNumber: "Clip #{{number}}",
      noPreview: "No Preview",
      clickToSelect: "Click to select",
      preview: "Preview",
      ready: "Ready",
      download: "Download",
      downloadingVideo: "Downloading video...",
      browserNotSupported: "Your browser does not support video playback.",
      showRendered: "Show rendered video",
      showPreview: "Show live preview",
      versions: "Versions",
    },

    // Share Clip
    shareClip: {
      share: "Share",
      scanToShare: "Share this clip",
      scanQrCode: "Scan this QR code with your phone to share the video.",
      shareFailed: "Failed to share the video.",
    },

    // Share Page
    sharePage: {
      share: "Share",
      download: "Download",
      noVideo: "No video to share.",
    },

    // Short link page
    shortLink: {
      notFound: "Link not found or expired.",
      goHome: "Go home",
    },

    // Project Editor Page
    editor: {
      coverImage: {
        title: 'Video cover',
        hint: 'This image becomes the first frame of the exported video. TikTok, Reels and Shorts use that frame as the cover.',
        captureFrame: 'Use current frame',
        chooseImage: 'Choose image',
        replace: 'Replace',
        remove: 'Remove',
        frameAt: 'Frame at {{time}}',
        capturing: 'Capturing frame...',
        uploading: 'Uploading image...',
        captureError: 'Could not capture the frame. Please try again.',
        uploadError: 'Could not upload the image. Please try again.',
        invalidImage: "This image can't be used as a cover (it must be a secure https link). Choose another image.",
        previewAlt: 'Video cover',
        badge: 'Cover',
        frameSource: {
          label: 'Frame source',
          title: 'Choose the cover frame',
          description: 'Compare the frame as it appears in the preview (with layout, subtitles and layers) with the original video frame.',
          preview: 'Preview',
          previewHint: 'Exactly as in the preview: layout, subtitles and layers.',
          video: 'Original video',
          videoHint: 'Only the video frame, without layout or subtitles.',
          unavailable: 'Unavailable',
          retry: 'Try again',
          cancel: 'Cancel',
          confirm: 'Use this frame',
        },
        ai: {
          button: 'Generate with AI',
          title: 'Generate cover with AI',
          useReference: 'Use the current frame as reference',
          promptLabel: 'Describe the cover',
          promptPlaceholder: 'Describe what you want on the cover, or pick suggestions below',
          presetsLabel: 'Suggestions (click to add or remove)',
          presets: {
            clickworthy: { label: 'Click-worthy', prompt: 'Click-worthy viral cover style' },
            dramaticCloseUp: { label: 'Dramatic close-up', prompt: 'Close-up of the face with an intense, dramatic expression' },
            bigTitle: { label: 'Big title', prompt: 'Short, big, readable title as the focus' },
            shocked: { label: 'Shocked reaction', prompt: 'Exaggerated shock or surprise expression' },
            vibrant: { label: 'Vibrant colors', prompt: 'Vibrant colors and high contrast' },
            cinematic: { label: 'Cinematic', prompt: 'Cinematic look with dramatic lighting' },
            highlightArrow: { label: 'Highlight arrow', prompt: 'Arrow or circle highlighting the key point' },
            minimal: { label: 'Minimal', prompt: 'Minimal composition with a clean background' },
          },
          quota: '{{used}} of {{limit}} generated today · resets at midnight',
          generate: 'Generate',
          generating: 'Generating… this can take up to 1 minute',
          useAsCover: 'Use as cover',
          generateAnother: 'Generate another',
          proDialog: {
            title: 'AI covers are PRO',
            body: 'Generate covers with AI from the current frame or a description. Available on PRO plans.',
            dismiss: 'Not now',
            upgrade: 'See plans',
          },
          errors: {
            pro_required: 'AI cover generation is available on PRO plans only.',
            daily_limit_reached: "You've reached today's AI cover limit. It resets at midnight.",
            invalid_prompt: 'Describe the cover or use the current frame as reference.',
            invalid_reference: "Couldn't use the current frame as reference. Please try again.",
            not_found: "This clip wasn't found. Reload the page and try again.",
            generation_failed: "Couldn't generate the cover. Please try again.",
            timeout: 'Generation took too long. The image may still show up in My Media.',
            unknown: 'Something went wrong generating the cover. Please try again.',
          },
        },
      },
    },
    editOnly: {
      title: "Edit it anyway",
      description: "Drag the start and end to pick a segment of up to 1 minute, then keep going in the editor with it. It will have no subtitles, since there is no speech to transcribe.",
      startLabel: "Segment start",
      endLabel: "Segment end",
      window: "Segment: {{start}} → {{end}} ({{seconds}} s)",
      projectCharge: "The full video ({{duration}}) will be charged to your processing time.",
      useSegment: "Use this segment",
      errorTitle: "Couldn't open the editor",
      error: "Try again in a moment. If it keeps happening, contact support.",
    },
    clipperRun: {
      saved: "Score saved on your account.",
      saving: "Saving your score.",
      local: "Score kept in this browser; server saving was unavailable.",
      label: "Clipper run, a jump game while you wait",
      hint: "Space or tap to jump. Down arrow ducks.",
      retry: "Game over. Space or tap to play again.",
      gameOver: "GAME OVER",
      score: "SCORE",
      best: "HI",
    },
    projectEditor: {
      originalVideoDownload: {
        triggerLabel: 'Download full original video',
        title: 'Download original video?',
        description:
          'This file contains the full original video ({{sourceDuration}}), not the current clip ({{clipDuration}}).',
        descriptionWithoutDurations:
          'This file contains the full original video, not the current clip.',
        exportHint: 'To download the clip, use Export Video.',
        cancel: 'Cancel',
        confirm: 'Download original video',
      },
      loadingProject: "Loading project...",
      errorLoadingProject: "Error loading project.",
      projectNotFound: "Project not found.",
      errorProcessingProject: "Error processing project.",
      newsPdfMismatch: "The rundown PDF doesn't match this video. Make sure the video and the PDF are from the same block, then create the project again.",
      sourceNoAudio: "This video has no audio, so it couldn't be transcribed. Export the video again with audio turned on, then create the project again.",
      transcriptEmpty: "We couldn't find any speech in this video. Autoclipper picks clips from what people say, so music-only or silent videos can't be clipped. Try a video with people talking, like a podcast, stream, or interview.",
      transcriptTooSparse: "This video has too little speech for us to pick clips from. Autoclipper picks clips from what people say, so try a video where people talk for most of it.",
      audioTrackUnavailable: "The chosen audio track is no longer available on this video. Import it again with another track.",
      projectExpired: "This project has expired and cannot be edited.",
      estimatedTime: "Estimated time: ~{{minutes}} min",
      processingDescription: "This page updates automatically.",
      backToProjects: "Back to projects",
      backToLibrary: "Back to library",
      // Toast messages
      quotaReached: "Clip limit reached",
      upgradeToExport: "You need to upgrade your plan to continue exporting or editing clips.",
      quotaReachedTitle: "You have reached the monthly clip limit. Upgrade your plan to continue.",
      minDuration: "Total segment duration must be at least 1 second",
      maxDuration: "Clip duration cannot exceed 20 minutes",
      thanksFeedback: "Thanks for the feedback!",
      feedbackRemoved: "Feedback removed",
      ratingRemoved: "Your rating has been removed.",
      ratingRegistered: "Your rating has been registered.",
      feedbackError: "Error registering feedback",
      feedbackErrorDesc: "An error occurred while registering your feedback. Please try again.",
      brandKitRequired: "Template required",
      disableSubtitlesFirst: "You need to disable subtitles before removing the template.",
      brandKitUpdated: "Template updated!",
      brandKitApplied: "Template has been applied to the project.",
      brandKitRemoved: "Template has been removed from the project.",
      brandKitUpdateError: "Error updating template",
      brandKitUpdateErrorDesc: "An error occurred while updating the template. Please try again.",
      autoClip: "Auto Clip",
      defaultClipDescription: "Default clip for free editing",
      exportStarted: "Export started successfully!",
      clipProcessing: "Clip \"{{clipName}}\" is being processed. You will be notified when ready.",
      exportError: "Error exporting video",
      unexpectedError: "An unexpected error occurred during export.",
      editStarted: "Edit started successfully!",
      clipEditProcessing: "Clip \"{{clipName}}\" is being processed for editing. You will be notified when ready.",
      editError: "Error editing video",
      unexpectedEditError: "An unexpected error occurred during editing.",
      // UI labels
      editing: "Editing...",
      autoCropPending:
        "Auto-crop is still processing — this 9:16 framing is centered for now and may change.",
      landscapeSwitch: {
        title: "Switch to 16:9?",
        description:
          "This layout only works in 9:16. Continuing will use the {{layout}} layout.",
        confirm: "Use {{layout}} in 16:9",
        cancel: "Cancel",
      },
      exporting: "Exporting...",
      exportVideo: "Export Video",
      clipsByViralization: "Clips by Viralization Sequence",
      feedbackQuestion: "Did the generated clips meet your expectations?",
      yesLiked: "Yes, I liked it",
      noDisliked: "No, I didn't like it",
      noClipsFound: "No clips were found for this project",
      noClipsExplanation: "This may have occurred because no speech was detected in the video. However, you can make clips freely in the editor.",
      clipNumber: "Clip #{{number}}",
      proOnlyFeature: "Feature available only for PRO users",
      downloadVideo: "Download video",
      skipBackward: "Go back {{seconds}} seconds",
      skipForward: "Go forward {{seconds}} seconds",
      lockVideoNavigation: "Lock navigation to selected scenes",
      unlockVideoNavigation: "Unlock navigation through the full video",
      subtitlesAndBrandKit: "Subtitles and Template",
      templatesSection: "Template",
      subtitlesSection: "Subtitles",
      subtitlesToggleLabel: 'Show subtitles',
      subtitlesOffHint: 'Turn on to burn subtitles into the exported video.',
      subtitleControlledByBrandKit: "Subtitle settings are controlled by the selected template.",
      selectBrandKitForStyles: "Select a template above to apply custom subtitle styles.",
      enableSubtitlesToApply: "Template selected. To include subtitles in your video, enable subtitles above.",
      selectBrandKit: "Select a template",
      noBrandKit: "No template",
      myBrandKits: "My Templates",
      default: "Default",
      publicBrandKits: "Public Templates",
      createCustomBrandKits: "Apply your personal templates with Pro",
      upgradeToPro: "Upgrade to PRO",
      updatingProject: "Updating project...",
      clipTranscription: "Clip Transcription",
      selectClipForTranscription: "Select a clip to see the transcription",
      noTranscription: "No transcription available for this clip",
      editTranscription: "Edit transcription",
      cancelEditTranscription: "Cancel",
      saveEditTranscription: "Save",
      clipSaved: "Clip saved successfully",
      transcriptionSaveError: "Error saving transcription",
      discardTranscriptionChanges: "Discard",
      revertToOriginalTranscription: "Revert clip to original",
      undoTranscriptionEdit: "Undo",
      redoTranscriptionEdit: "Redo",
      undoEdit: "Undo",
      redoEdit: "Redo",
      clickToEdit: "Click to edit",
      headlinePosition: { move: "Move headline — drag or use arrow keys" },
      insertWordBefore: "Insert word before",
      insertWordAfter: "Insert word after",
      deleteSelectedWords: "Delete {{count}} word(s)",
      deleteSubtitleOnly: "Delete subtitle only ({{count}})",
      deleteFromVideo: "Delete section from video ({{count}})",
      detectFillerWords: "Detect filler words",
      fillerWordsFound: "{{count}} filler word(s) found",
      noFillerWordsFound: "No filler words found in this clip.",
      decoupClip: "Decoup",
      decoupClipHint:
        "Trim silent sections and keep only the spoken parts",
      decoupSilenceGapLabel: "Max silence between words (s)",
      decoupPaddingLabel: "Padding around each segment (s)",
      decoupClipApply: "Apply decoup",
      revertSegmentToOriginal: "Revert this segment to original",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      exportNClips: "Export {{count}} Clips",
      massExportStarted: "Mass export started!",
      massExportPreview: {
        title: 'Preview {{count}} clips',
        clipOf: 'Clip {{current}} of {{count}}',
        exportN: 'Export {{count}}',
      },
      previewQuality: {
        compressed: 'Fast',
        full: 'HD',
        compressedTitle: 'Compressed preview: lighter and faster to edit. Exports are always full quality.',
        fullTitle: 'Full quality: best visual fidelity, but heavier to load.',
        fullToastTitle: 'Full-quality preview',
        exportsAlwaysFull: 'Exports are always rendered in full quality, regardless of the preview.',
      },
      saveBrandKit: { title: 'Save as template', body: 'Stores the current subtitle, logo and layout options as a reusable template.', namePlaceholder: 'Template name', confirm: 'Save template', cta: 'Save as template', created: 'Template created!', driftHint: 'Your changes differ from the applied template — save them as a new template to reuse.' },
      brandKitApplyProTitle: 'Applying personal templates is PRO',
      brandKitApplyProBody: 'Public templates are available on the free plan. Applying a personal template you created requires PRO.',
      bulkExportProTitle: 'Bulk export is PRO',
      bulkExportProBody: 'On the free plan you export one clip at a time. Upgrade to select all clips and export them all at once.',
      massExportProcessing: "{{success}} clips are being processed. You will be notified when ready.",
      massExportPartial: "{{success}} clips exported, {{errors}} failed.",
      massExportError: "Error exporting clips",
      massExporting: "Exporting...",
      clipRated: "Clip rated!",
      clipRatingRemoved: "Clip rating removed",
      clipRatingError: "Error rating clip",
      modified: "Modified",
      saving: "Saving...",
      tour: {
        clipsSelection: "Here are the clips automatically generated by AI, sorted by viralization sequence. Click on a clip to view it.",
        videoPlayer: "In this area you can view the selected clip. Use the playback controls to watch and navigate the video.",
        subtitleControls: "Enable subtitles and select a template to customize the visual of your video. Templates allow you to add stylized subtitles and logos.",
        transcription: "Here you can see the transcription of the selected clip. Click on a word or segment to navigate directly to that moment in the video.",
        exportButton: "When you're satisfied with the clip, click here to export the video in horizontal or vertical formats.",
        helpButton: "Click here to see the project editor tour again.",
      },
      layers: {
        title: 'Layers',
        add: 'Add layer',
        addImage: 'Image',
        addVideo: 'Video',
        addAudio: 'Audio',
        addText: 'Text',
        motion: 'Animation',
        motionUnavailable: 'Animation unavailable',
        addClip: 'This clip',
        clipMirrorName: 'Clip view',
        empty: 'No layers yet. Drop an image or use “Add layer”.',
        dropHint: 'Drop image to add as a layer',
        opacity: 'Opacity',
        start: 'Start (s)',
        end: 'End (s)',
        volume: 'Volume',
        textDefaultName: 'Text',
        textContent: 'Text',
        font: 'Font',
        fontSize: 'Size',
        textColor: 'Color',
        background: 'Background',
        backgroundEnabled: 'Background color',
        backgroundColor: 'Color',
        backgroundOpacity: 'Opacity',
        borderRadius: 'Corner radius',
        paddingX: 'Padding X',
        paddingY: 'Padding Y',
        stroke: 'Stroke',
        strokeColor: 'Color',
        strokeWidth: 'Stroke width',
        shadow: 'Shadow',
        shadowColor: 'Shadow color',
        shadowBlur: 'Shadow blur',
        shadowOffsetX: 'Offset X',
        shadowOffsetY: 'Offset Y',
        align: 'Alignment',
        alignLeft: 'Left',
        alignCenter: 'Center',
        alignRight: 'Right',
        bold: 'Bold',
        italic: 'Italic',
        speed: 'Speed',
        style: 'Style',
        zoom: 'Zoom',
        reframe: 'Reframe',
        framing: 'Framing',
        fit: 'Fit',
        fill: 'Fill',
        resetCell: 'Reset position',
        deleteLayer: 'Delete layer',
        proRequiredTitle: 'PRO required to export with layers',
        proRequiredDescription: 'You can add and preview layers for free. Upgrade to PRO to export a clip that contains layers.',
        proExportDialogTitle: 'You used a PRO feature',
        proExportDialogBody: 'Media layers are free to add and preview, but exporting the final video with them is a PRO feature. Upgrade to export with layers — or remove the layers from this clip to export for free.',
        proExportDialogDismiss: 'Keep editing',
        proExportDialogUpgrade: 'Upgrade',
      },
      stockMedia: {
        titleVideo: 'Add a stock video',
        titleImage: 'Add a stock image',
        searchPlaceholder: 'Search {{provider}}…',
        uploadInstead: 'Upload from computer',
        loadMore: 'Load more',
        loading: 'Searching…',
        noResults: 'No results. Try a different search.',
        error: 'Search failed. Please try again.',
        retry: 'Retry',
        providedBy: 'Media provided by {{provider}}',
        libraryTab: 'My library',
      },
      transitionsProTitle: 'Transitions are a PRO feature',
      transitionsProBody: 'You can add and preview transitions for free, but exporting a clip with transitions requires the PRO plan. Remove the transitions or upgrade to export.',
    },

    // Project Clips Page
    projectClips: {
      source: {
        preparing: {
          title: 'Your clip suggestions are ready',
          description: 'The video is still being prepared. Preview, editing and export will become available here automatically.',
        },
        failed: {
          title: 'The video could not be prepared',
          description: 'Your suggestions are saved. Retry the import or contact support to prepare the video for export.',
        },
        expired: {
          title: 'The source video has expired',
          description: 'Import the video again to preview, edit and export these clips.',
        },
      },
      loading: "Loading...",
      loadingSteps: {
        title: "Loading your clips...",
        library: "Loading library data",
        clips: "Loading clips",
        sceneDetection: "Loading scene detection",
        transcription: "Loading transcription",
      },
      clipsReady: "Your clips are ready!",
      clipsOptimized: "{{count}} clips optimized for social media",
      deselectAll: "Deselect All",
      selectAll: "Select All",
      selectedOf: "{{selected}} of {{total}} selected",
      configureSubtitles: "Configure Subtitles",
      selectBrandKit: "Select Template",
      applyBrandKit: "Apply Template",
      applyingBrandKit: "Applying...",
      noBrandKits: "No templates",
      downloadSRT: "Download SRT",
      downloadPDF: "Download PDF",
      titlesGenerated: "Titles generated",
      titlesGeneratedCopyAgain: "Titles have been generated. Click the button again to copy them.",
      copyAllTitles: "Copy All Titles",
      downloadTitles: "Download Titles",
      downloadAll: "Download All ({{count}})",
      downloading: "Downloading...",
      downloadingVideos: "Downloading videos...",
      export: "Export",
      exportSelected: "Export Selected ({{count}})",
      exporting: "Exporting...",
      exportingVideos: "Queuing clips for export...",
      ofTotal: "{{current}} of {{total}}",
      failedToLoadClips: "Failed to load clips.",
      noClipsFound: "No clips found for this project.",
      loadingMore: "Loading more...",
      editVideo: "Edit Video",
      rendering: "Rendering...",
      previewClips: "Preview Clips",
      styleConfig: {
        subtitlesToggle: "Subtitles",
        stylize: "Style",
        emptyKits: "You don't have any templates yet.",
        emptyKitsCta: "Create a template",
      },
      speakerLayout: {
        title: "Layout",
        detected: "{{count}} speakers detected",
        single: "Single",
        speakers: "{{count}} Speakers",
        twitterLayout: "Model X",
        twitterAvatarUrl: "Avatar URL",
        twitterDisplayName: "Display Name",
        twitterHandle: "Handle (@username)",
        twitterTweetText: "Post Text",
      },
      enforcedLayout: {
        notice: 'Layout set by the campaign',
        subtitleMarginLocked: 'Margin set by the campaign',
      },
      postLayouts: {
        title: 'Post Layout',
        none: 'None',
        upload: 'Upload',
        uploading: 'Uploading…',
        common: { image: 'Image', headline: 'Headline', accent: 'Accent color', headlineColor: 'Text color', headlineFont: 'Font', headlineSize: 'Text size' },
        choquei: {
          label: 'Choquei',
          image: 'Image',
          brandName: 'Brand name',
          headline: 'Headline',
          logo: 'Logo URL',
          accent: 'Accent color',
        },
        breakingNews: { label: 'Breaking News', channel: 'Channel name', tag: 'Tag', logo: 'Logo URL' },
        newspaper: { label: 'Newspaper', source: 'Source name', kicker: 'Kicker / date' },
        instagram: { label: 'Instagram', handle: 'Handle', caption: 'Caption', likes: 'Likes', avatar: 'Avatar URL' },
        factQuote: { label: 'Fact / Quote', textColor: 'Text color', scrim: 'Scrim color' },
        newsPost: {
          label: 'News Post',
          style: 'Style',
          styleChoquei: 'Gossip',
          styleBreaking: 'Breaking',
          styleNewspaper: 'Newspaper',
          styleInstagram: 'Instagram',
          brandName: 'Brand / source name',
          tag: 'Tag',
          kicker: 'Kicker / date',
          likes: 'Likes',
        },
        fofoca: {
          label: 'Gossip',
          image: 'Image',
          filler: 'Filler videos',
          storyMedia: 'Story media',
          mediaImage: 'Image',
          mediaVideo: 'Video',
          avatar: 'Profile photo',
          profileName: 'Profile name',
          caption: 'Post text',
          badgeImage: 'Badge image',
          badgeBorderRadius: 'Badge roundness',
          assetReuseHint: 'Profile and badge uploads are saved to My Media. Save this style as a Template to reuse both images.',
          videoTitle: 'Video title',
          videoTitleFont: 'Title font',
          videoTitleFontSize: 'Title size',
          handle: 'Handle over the video',
          portraitOnly: 'The Gossip layout only uses the 9:16 format',
          accent: 'Accent color',
          useCurrentFrame: 'Use current video frame',
          capturingFrame: 'Capturing frame…',
          captureFrameError: 'Could not capture this frame. Try another moment or upload an image.',
          sectionMedia: 'Story media',
          sectionProfile: 'Profile',
          sectionBadge: 'Badge',
          sectionTitle: 'Title',
          clipPosition: 'Clip position',
          clipOnRight: 'Clip on right',
          clipOnLeft: 'Clip on left',
        },
        cortes: {
          label: 'Cortes',
          background: 'Background image',
          photo1: 'Top left media',
          photo2: 'Top right media',
          photo3: 'Bottom left media',
          photo4: 'Bottom right media',
          handle: 'Handle',
          boxColor: 'Headline box color',
          boxWidth: 'Box width',
          headlineColor: 'Headline color',
          headlineFont: 'Headline font',
          headlineSize: 'Headline size',
          presets: {
            caixaVermelha: 'Text Box',
            barraBranca: 'Text Bar',
          },
          importCapcut: 'Import from CapCut (.zip)',
          importing: 'Importing…',
          importNotice: 'Styles and positions imported. Some images were missing from the file — upload them manually.',
          importErrorTitle: 'Import failed',
          importErrors: {
            invalid_zip: 'The file is not a valid .zip.',
            no_draft_content: 'The .zip has no CapCut draft_content.json. Zip the whole preset folder.',
            invalid_json: 'The draft_content.json is corrupt or in an unsupported format.',
            no_content: 'The preset has no importable photos or texts.',
            upload_failed: 'Uploading the preset images failed. Try again.',
          },
        },
        circulo: {
          label: 'Circle',
          cima: 'Circle top',
          baixo: 'Circle',
          arc: 'Caption arc',
          arcUpper: 'Upper',
          arcLower: 'Lower',
          sectionBackground: 'Background',
          backgroundColor: 'Background color',
          backgroundMedia: 'Background media',
          mediaImage: 'Image',
          mediaVideo: 'Video',
          still: 'Background image',
          filler: 'Filler videos',
        },
        satisfatorio: {
          label: 'Split Screen',
          filler: 'Filler video',
          myUploads: 'My videos',
          title: 'Title',
          titleFrame: 'Title frame',
          frameNone: 'None',
          framePill: 'Pill',
          frameDark: 'Dark',
          frameAccent: 'Accent',
          frameOutline: 'Outline',
          frameBar: 'Full bar',
          speed: 'Filler speed',
          titleColor: 'Title color',
          clipPosition: 'Clip position',
          clipOnTop: 'Clip on top',
          clipOnBottom: 'Clip on bottom',
          ratio: 'Clip size',
          noPresets: 'No preset videos yet — upload your own below.',
          dialogTitle: 'Filler video library',
          searchPlaceholder: 'Search videos…',
          allTags: 'All',
          noResults: 'No videos match your search.',
          browseAll: 'See all ({{count}})',
          carouselPrevious: 'Previous filler videos',
          carouselNext: 'Next filler videos',
          useFrameAtSeconds: 'Use a frame of the video at {{seconds}} seconds',
          customVideo: 'Custom video',
          sectionVideo: 'Filler video',
          sectionTitle: 'Title',
          sectionLayout: 'Layout',
          selectedCount: '{{count}} selected',
          clearSelection: 'Clear',
          confirmSelection: 'Confirm ({{count}})',
          playlistLabel: 'Video sequence ({{count}})',
          allVideosLabel: 'All videos',
          removeFromPlaylist: 'Remove from sequence',
          removeSelectedVideo: 'Remove video',
          autoFillRandom: 'Auto-fill random',
          fitVideo: 'Fit',
          fillVideo: 'Fill',
          positionTopFirst: 'Show top',
          positionCenter: 'Show center',
          positionBottomFirst: 'Show bottom',
        },
        tripleSplit: {
          label: 'Triple Split',
          fillerTop: 'Top filler video',
          fillerBottom: 'Bottom filler video',
          title: 'Top headline',
          title2: 'Bottom headline',
        },
        binds: {
          clipTitle: 'clip title',
          channel: 'channel',
          clipTitleHint: "Use each clip's title",
          useClipTitle: 'Use Clip Title',
          channelNameHint: 'Use the YouTube channel name',
          channelAvatarHint: 'Use the YouTube channel photo',
          useChannelAvatar: 'Use video channel avatar',
          useChannelName: 'Use video channel name',
          useChannelWhenAvailable: 'Used when the video has a channel',
          useMyAvatar: 'Use my avatar',
          useMyName: 'Use my name',
        },
      },
      detectionInProgress: {
        title: "Scene and face detection is running in the background",
        description: "You can edit your videos while it's processing. Once finished, the 9:16 preview will be fully available for your clips. Exported videos are always in 9:16 format.",
      },
      sceneDetectionUnavailable: {
        title: "Scene detection preview is temporarily unavailable",
        description: "Your clips are still usable, but smart preview framing may be limited until scene detection loads again.",
        timeoutDescription: "Scene detection took too long to load. Your clips are still usable, but smart preview framing may be limited for now.",
      },
      translationFailed: "The transcript could not be translated. Subtitles and titles are in the audio language.",
      transcriptionUnavailable: {
        title: "Transcription preview is temporarily unavailable",
        description: "Your clips are still usable, but subtitle preview features may be limited until transcription loads again.",
        timeoutDescription: "Transcription took too long to load. Your clips are still usable, but subtitle preview features may be limited for now.",
      },
      deleteSelected: "Delete ({{count}})",
      deleting: "Deleting...",
      toast: {
        downloadCompleted: "Download completed",
        videosDownloaded: "{{success}} video(s) downloaded successfully{{failed}}.",
        failed: ", {{count}} failed",
        downloadError: "Download error",
        couldNotDownload: "Could not download selected videos.",
        srtDownloaded: "SRT subtitles downloaded successfully.",
        noTranscription: "No transcription available for this project.",
        exportStarted: "Export started",
        exportingClips: "{{count}} clip(s) queued for export.",
        exportPartial: "Partial export",
        exportingWithErrors: "{{success}} clip(s) queued, {{errors}} failed.",
        exportError: "Export error",
        couldNotExport: "Could not export selected clips.",
        deleteCompleted: "{{count}} clip(s) deleted successfully.",
        deleteError: "Failed to delete {{count}} clip(s).",
      },
      tour: {
        pageTitle: "This page displays all exported clips from this specific project.",
        clipsGrid: "Here you see all clips that were created from this project. Click on a clip to download, edit or manage the video.",
        helpButton: "Click here to see the project clips page tour again.",
      },
    },

    // Brand Kits New/Edit Page
    brandKitsNew: {
      newBrandKit: "New Template",
      editBrandKit: "Edit Template",
      brandKitName: "Template Name",
      brandKitNamePlaceholder: "Enter a name for your template",
      previewSubtitleText: "This is a subtitle example",
      sampleClipTitle: "How the best creators grow so fast",
      tabs: {
        colors: "Colors",
        typography: "Typography",
        logo: "Logo",
        subtitles: "Subtitles",
      },
      colors: {
        title: "Color Palette",
        description: "Define the colors that represent your brand",
        noColors: "No colors added yet.",
        addColorTip: "Click on \"Add Color\" to start building your palette.",
        addColor: "Add Color",
      },
      typography: {
        title: "Typography",
        description: "Define the fonts used in your brand",
        titlesFont: "Titles Font",
        titlesFontSize: "Titles Font Size",
        bodyFont: "Body Font",
        bodyFontSize: "Body Font Size",
      },
      logo: {
        title: "Logo",
        description: "Upload your brand logo",
        noLogo: "No logo uploaded",
        selectFile: "Select file",
        uploadingLogo: "Uploading...",
        logoUploaded: "Logo uploaded",
        clickToRemove: "Click the button next to remove",
        pleaseWait: "Please wait...",
        position: "Position",
        opacity: "Opacity",
        size: "Size",
        horizontalMargin: "Horizontal Margin",
        verticalMargin: "Vertical Margin",
      },
      subtitles: {
        title: "Subtitles",
        description: "Customize how your subtitles appear",
        font: "Subtitle Font",
        fontSize: "Font Size",
        textColor: "Text Color",
        textAlign: "Text Alignment",
        alignLeft: "Align Left",
        alignCenter: "Center",
        alignRight: "Align Right",
        maxWordsPerLine: "Max Words Per Line",
        highlight: "Highlight",
        highlightEnabled: "Highlight Enabled",
        highlightColor: "Highlight Color",
        highlightBox: "Highlight Box",
        highlightBoxEnabled: "Highlight Box Enabled",
        highlightBoxColor: "Highlight Box Color",
        highlightBoxBorderRadius: "Box Border Radius",
        highlightBoxPaddingX: "Box Horizontal Padding",
        highlightBoxPaddingY: "Box Vertical Padding",
        background: "Background",
        backgroundEnabled: "Background Enabled",
        backgroundColor: "Background Color",
        backgroundOpacity: "Background Opacity",
        backgroundWidth: "Background Width",
        backgroundHeight: "Background Height",
        shadow: "Shadow",
        shadowEnabled: "Shadow Enabled",
        shadowColor: "Shadow Color",
        shadowSize: "Shadow Size",
        animation: "Animation",
        selectAnimation: "Select animation",
        position: "Position",
        verticalPosition: "Vertical Position",
        top: "Top",
        middle: "Middle",
        bottom: "Bottom",
        horizontalPosition: "Horizontal Position",
        left: "Left",
        center: "Center",
        right: "Right",
        marginVertical: "Vertical Margin",
        marginHorizontal: "Horizontal Margin",
      },
      preview: {
        title: "Preview",
        landscape: "Landscape (16:9)",
        portrait: "Portrait (9:16)",
        showSafeZone: "Show Safe Zone",
        safeZonePortraitOnly: "Safe zone available only in portrait mode",
        noVideoAvailable: "No video available for preview",
      },
      positions: {
        topLeft: "Top Left",
        topCenter: "Top Center",
        topRight: "Top Right",
        centerLeft: "Center Left",
        center: "Center",
        centerRight: "Center Right",
        bottomLeft: "Bottom Left",
        bottomCenter: "Bottom Center",
        bottomRight: "Bottom Right",
      },
      toast: {
        loadError: "Error loading template. Check if the ID is valid.",
        loadDataError: "Error loading template data",
        created: "Template created successfully!",
        createError: "Error creating template. Please try again.",
        updated: "Template updated successfully!",
        updateError: "Error updating template. Please try again.",
        uploadError: "Error uploading logo",
        uploadFailed: "Upload error: {{error}}",
        nameRequired: "Please enter a name for the template.",
        logoRemoved: "Logo removed",
        colorRemoved: "Color removed",
      },
      save: "Save Template",
      saving: "Saving...",
      tour: {
        nameInput: "Start by giving your template a name. This name helps identify the template when applying it to your videos.",
        tabs: "Use these tabs to navigate between different settings: Colors, Typography, Logo, and Subtitles.",
        sidePanel: "Edit the palette, layout, logo, and subtitles here. Changes show up live in the preview.",
        preview: "Here you can see a real-time preview of how your template will look applied to a video.",
        saveButton: "When you're satisfied with the settings, click here to save your template and apply it to your videos.",
        helpButton: "Click here to see the template creation tour again.",
      },
    },

    // Admin Pages
    admin: {
      aiUsage: {
        title: 'AI assistant usage',
        subtitle: "Tokens and estimated cost per user. Cost uses each model's public API price.",
        from: 'From',
        to: 'To',
        presets: { d7: '7 days', d30: '30 days', d90: '90 days' },
        brlRate: 'USD→BRL rate',
        search: 'Search by name or email',
        exportCsv: 'Export CSV',
        exportError: "Couldn't export the CSV.",
        loadError: "Couldn't load the report.",
        retry: 'Try again',
        empty: 'No usage in this period.',
        unpriced: '{{count}} calls without a configured price',
        kpis: {
          activeUsers: 'Active users',
          messages: 'Messages',
          tokens: 'Tokens (input / output)',
          cost: 'Estimated cost',
          costPerMessage: 'Cost per message',
          costPerUser: 'Cost per active user',
          failedCalls: 'Failed calls',
        },
        byDay: 'By day',
        byModel: 'By model',
        users: 'Users',
        columns: {
          user: 'User',
          plan: 'Plan',
          messages: 'Messages',
          calls: 'Calls',
          promptTokens: 'Input',
          completionTokens: 'Output',
          cost: 'Cost',
          costPerMessage: 'Cost/msg',
          lastUsed: 'Last used',
          model: 'Model',
          purpose: 'Use',
          day: 'Day',
        },
        purpose: { chat: 'Chat', vision: 'Vision' },
        paid: 'Paid',
        free: 'Free',
        page: 'Page {{page}} of {{pages}}',
      },
      contacts: {
        description: "Every form submission appears here. Repeat requests from an existing contact are marked as duplicates.",
        requestCount_one: "{{count}} request",
        requestCount_other: "{{count}} requests",
        duplicate: "Duplicate",
        original: "New",
        requestType: "Request type",
        duplicateHint: "A new request from an existing contact. Follow-up continues in the original conversation.",
        origins: {
          label: "Filter by origin",
          all: "All",
          app: "App",
          site: "autoclipper.live",
          marcas: "marcas.autoclipper.live",
          other: "Other",
        },
      },
      resultados: {
        title: "Results & Metrics",
        subtitle: "Consolidated view of user journey and platform performance",
        tabs: {
          overview:  "Overview",
          users:     "Users",
          campaigns: "Campaigns",
          partners:  "Partners",
        },
        vsLastMonth: "vs. last month",
        vsLastWeek: "vs. last week",
        kpi: {
          users: "Registered users",
          clips: "Clips created",
          downloads: "Downloads completed",
          projects: "Projects created",
          ownBrand: "My Brand",
          otherChannels: "Other Channels",
          periodLabel: "Change:",
          period_7d: "Week",
          period_30d: "Month",
        },
        conversion: {
          title: "Free → Paid Conversion",
          rate: "Conversion rate",
          totalFree: "Free users",
          totalPaid: "Paid users",
          tooltip: "Users created in the selected period, split between free plans and active paid plans.",
        },
        chart: {
          newUsers: "New users per day",
          clipsCreated: "Clips created per day",
          users: "Users",
          clips: "Clips",
        },
        funnel: {
          steps: {
            signup: "Signup",
            onboarding: "Onboarding",
            first_project: "1st Project",
            first_clip: "1st Clip",
            first_download: "1st Download",
            first_curation: "1st Curation",
            first_export: "1st Export",
          },
          creator: {
            title: "Funnel — Content Creator",
            subtitle: "User journey for 'My Brand' objective",
          },
          clipper: {
            title: "Funnel — Clipper",
            subtitle: "User journey for 'Other Channels' objective",
          },
        },
        sources: {
          sectionTitle: "Project sources",
          creator: "My Brand — project sources",
          clipper: "Other Channels — project sources",
          youtube: "YouTube Link",
          local: "Local Upload",
          acervo: "Library",
        },
        retention: {
          sectionTitle: "Retention after 1st Export",
          subtitle: "Users who exported ≥ 1 clip and returned to the platform",
          tooltip: "Measures how many users returned to create or export clips after their first export, split by flow.",
          chartLabel: "Return",
          creator: "Content Creator (My Brand)",
          clipper: "Clipper (Other Channels)",
          source: "Source: backend — exported clip activity",
        },
        campaigns: {
          title: "Earn with Clips — Campaigns",
          subtitle: "Clipper participation in CPM campaigns",
          enrolled: "Enrolled",
          submitted: "Submitted clips",
          approved: "Approved clips",
          earnings: "Total paid to creators",
          clipperToPaid: "Clippers who subscribed after participating",
          clipperToPaidTooltip: "Clippers with at least 1 campaign participation and an active paid plan in the selected period.",
          subscriberToCampaign: "Subscribers participating in campaigns",
        },
        nwc: {
          title: "NWC Partnership — Networking Cortes",
          subtitle: "Users who registered via the Networking Cortes partnership link (?affiliate=nwc)",
          total: "Users via NWC",
          paidPct: "Conversion to paid",
          campaignPct: "Campaign participation",
          retentionTitle: "NWC vs Organic Retention",
          retentionTooltip: "Percentage of users who returned to export at least 1 clip after their first use, by time window. NWC in blue, organic in gray.",
          organic: "Organic",
          retentionNote: "Retention measured: users who exported at least 1 clip after their first use.",
        },
        campaignPerformance: {
          title: "Performance by Campaign",
          subtitle: "Real data per CPM campaign — submitted clips and budget usage",
          submissions: "clips",
          spent: "used",
          viewDetail: "View details",
          noCampaigns: "No campaigns found.",
        },
      },
      cpmLeads: {
        title: "CPM leads",
        subtitle: "Brand leads and their WhatsApp thread with Lara.",
        searchPlaceholder: "Search by name, email, phone or company",
        loading: "Loading…",
        empty: "No leads yet.",
        pickLead: "Select a lead to read the conversation.",
        back: "Back to leads",
        noMessages: "No WhatsApp messages stored for this lead yet.",
        loadError: "Could not load leads.",
        lara: "Lara",
        lead: "Lead",
        team: "Team",
        replyPlaceholder: "Reply on WhatsApp",
        send: "Send",
        sending: "Sending…",
        sendFailed: "Not sent",
        sendError: "Could not send the reply.",
        restart: "Restart",
        restarting: "Restarting…",
        restartConfirm: "Lara clears this briefing and resends the form summary, as if the person had just submitted it. Continue?",
        restartError: "Could not restart the briefing.",
        briefTitle: "Briefing",
        briefMissing: "Gaps",
        diagnosisTitle: "Questions for Gerson",
        form: {
          profile: "Profile",
          objective: "Objective",
          content: "Content",
          platforms: "Platforms",
          budget: "Budget",
          company: "Company",
          email: "Email",
          phone: "Phone",
          website: "Website",
          social: "Social",
        },
        budgets: {
          range_1k_5k: "R$ 1,000–5,000",
          range_5k_10k: "R$ 5,000–10,000",
          range_10k_50k: "R$ 10,000–50,000",
          range_50k_100k: "R$ 50,000–100,000",
          range_100k_plus: "R$ 100,000+",
          undecided: "Still deciding",
          range_5k_20k: "R$ 5,000–20,000",
          range_10k_20k: "R$ 10,000–20,000",
          range_20k_50k: "R$ 20,000–50,000",
          range_50k_150k: "R$ 50,000–150,000",
          range_150k_plus: "Above R$ 150,000",
        },
        states: {
          captured: "Captured",
          contacted: "Contacted",
          briefing: "Briefing",
          brief_complete: "Brief done",
          diagnosed: "Diagnosed",
          meeting_link_sent: "Scheduling",
          meeting_booked: "Meeting booked",
          meeting_held: "Meeting held",
          opted_out: "Opted out",
          human_handoff: "Handoff",
          lost: "Lost",
        },
      },
      botConversations: {
        title: "Bot Conversations",
        subtitle: "Audit every Telegram/WhatsApp conversation users had with the bot.",
        searchPlaceholder: "Search by identity, name, email or phone",
        allChannels: "All channels",
        allLinks: "All",
        linkedOnly: "Linked",
        unlinkedOnly: "Unlinked",
        hasErrors: "With errors only",
        columnChannel: "Channel",
        columnIdentity: "Identity",
        columnUser: "Account",
        columnMessages: "Messages",
        columnLastSeen: "Last activity",
        unlinked: "Unlinked",
        noConversations: "No conversations found.",
        backToList: "Back to conversations",
        backToUser: "Back to user",
        perUserTitle: "Bot Conversations",
        userNoConversations: "This user hasn't chatted with the bot yet.",
        memorySummary: "AI memory summary",
        memoryUpdatedAt: "Updated",
        noMemory: "No memory summary yet.",
        firstSeen: "First seen",
        lastSeen: "Last seen",
        totalMessages: "Messages",
        inbound: "User",
        outbound: "Bot",
        intent: "intent",
        source: "source",
        flow: "flow",
        model: "model",
        mediaOnly: "[media]",
        startOfConversation: "Beginning of conversation",
        entryButton: "Bot Conversations",
      },
      common: {
        total: "Total",
        page: "Page",
        of: "of",
        noResults: "No results found",
        error: "Error loading data",
        chartTotal: "Total",
        chartSuccess: "Success",
        chartFailure: "Failed",
      },
      stats: {
        platformOverview: "Platform Overview",
        totalUsers: "Total Users",
        confirmedUsers: "Confirmed",
        adminUsers: "Admins",
        blockedUsers: "Blocked",
        usersByPlan: "Users by Plan",
        entityStats: "Platform Activity",
        projects: "Projects",
        clips: "Clips",
        downloads: "Downloads",
        total: "Total",
        success: "Success",
        processing: "Processing",
        queued: "Queued",
        failure: "Failed",
      },
      users: {
        title: "Users",
        subtitle: "Manage all platform users",
        list: "Users List",
        searchPlaceholder: "Search by name, email or phone...",
        filterByPlan: "Filter by plan",
        allPlans: "All plans",
        name: "Name",
        email: "Email",
        phone: "Phone",
        whatsapp: "WhatsApp",
        country: "Country",
        plan: "Plan",
        provider: "Provider",
        createdAt: "Created at",
        usersOnPlan: "users",
        usage: "Usage",
        currentUsage: "Current Usage",
        usagePreview: "Usage Preview",
        current: "Current",
        afterChanges: "After changes",
        used: "used",
        library: "Library",
        payments: "Payments",
        ltv: "LTV",
        actions: "Actions",
        editUser: "Edit User",
        editUserDesc: "Edit subscription for {{name}}",
        reliability: {
          title: "Account reliability",
          column: "Reliability",
          scorePart: "{{platform}} {{score}}",
          platforms: {
            instagram: "Instagram",
            tiktok: "TikTok",
            youtube: "YouTube",
          },
        },
        userType: "Type",
        selectUserType: "Select user type",
        ownBrand: "My Brand",
        otherChannels: "Other Channels",
        utmSource: "UTM Source",
        utmSources: "Filter by UTM source",
        selectPlan: "Select a plan",
        currentMonthSeconds: "Current Month Processing (seconds)",
        currentMonthClips: "Current Month Clips",
        currentMonthLibrarySeconds: "Current Month Library Time (seconds)",
        currentMonthLibraryExports: "Current Month Library Exports",
        currentMonthLibraryCurations: "Current Month Library Curations",
        saving: "Saving...",
        partnerToggle: "Partner",
        partnerToggleHint: "The billing system will never move this partner back to the Free plan. Grants are free of charge.",
        leaderboardHide: "Hide from Clip & Pix ranking",
        leaderboardHideHint: "This clipper stays in the app but does not appear on the public ranking on /community-library and /earn.",
        leaderboardHideReason: "Reason (optional)",
        leaderboardHideReasonPlaceholder: "e.g. Banned from campaigns",
        leaderboardHiddenBadge: "Hidden from ranking",
        planPartnerOnly: "Enable Partner to change the plan.",
        partnerExpiresAt: "Partner access until",
        partnerExpiresAtHint: "Protected until this date; afterward normal billing rules resume.",
        partnerExpiresInvalid: "Enter a valid date as DD/MM/YYYY.",
        partnerIndefinite: "No date = indefinite (never expires).",
        partnerNote: "Note (optional)",
        partnerNotePlaceholder: "e.g. Influencer partnership — granted by Nihey",
        partnersOnly: "Partners only",
        partnerUntil: "Partner until {{date}}",
        partnerIndefiniteBadge: "Partner",
        partnerExpired: "Partner (expired)",
        dailyRegistrations: "Daily Registrations",
        impersonate: "Impersonate user",
        impersonating: "You are impersonating a user",
        stopImpersonating: "Return to admin",
        toast: {
          updated: "User updated",
          updatedDesc: "User subscription was updated successfully.",
          updateError: "Update failed",
          updateErrorDesc: "Failed to update user subscription. Try again.",
          impersonateError: "Impersonation failed",
          impersonateErrorDesc: "Failed to impersonate user. Try again.",
        },
        funnel: {
          title: "User Funnels",
          ownBrand: "My Brand",
          otherChannels: "Other Channels",
          signed_up: "Signed Up",
          created_project: "Created Project",
          created_library: "Created Library",
          created_clip: "Generated Clip",
          users: "users",
        },
        affiliateRates: {
          title: 'Affiliate rates',
          payment: 'Subscriptions (%)',
          course: 'Course (%)',
          cpm: 'Clip & Pix (%)',
          placeholderDefault: '{{value}} (default)',
          note: 'Reason / deal',
          notePlaceholder: 'e.g. NWC deal, agreed 07/2026',
          hint: 'Leave blank to use the default rate. 0 means no commission on that product.',
          cpmWarning: 'Heads up: changing the Clip & Pix rate recalculates this affiliate’s historical commission — up or down — at their next earnings sync.',
          save: 'Save rates',
          saved: 'Rates updated',
          error: 'Could not save the rates.',
          invalid: 'Use a whole number from 0 to 100.',
        },
        customRatesBadge: 'Custom rates',
        aiAssistantToggle: "AI assistant",
        aiAssistantToggleHint: "Show the AI assistant sidebar to this user (beta release). Applies on their next page load.",
        aiAssistantBadge: "AI",
        facebookConnectionsToggle: "Facebook connections",
        facebookConnectionsToggleHint: "Lets this user connect Facebook Pages before Meta approves the app.",
        facebookConnectionsBadge: "Facebook",
      },
      projects: {
        title: "Projects",
        subtitle: "View all platform projects",
        list: "Projects List",
        searchPlaceholder: "Search by project name...",
        filterByStatus: "Filter by status",
        allStatuses: "All statuses",
        name: "Name",
        user: "User",
        status: "Status",
        duration: "Duration",
        language: "Language",
        createdAt: "Created at",
        dailyChart: "Daily Project Creation",
      },
      clips: {
        title: "Clips",
        subtitle: "View all platform clips",
        list: "Clips List",
        searchPlaceholder: "Search by clip name...",
        filterByClippingStatus: "Filter by clipping status",
        filterByRenderingStatus: "Filter by rendering status",
        allStatuses: "All statuses",
        name: "Name",
        project: "Project",
        user: "User",
        clippingStatus: "Clipping Status",
        renderingStatus: "Rendering Status",
        duration: "Duration",
        createdAt: "Created at",
        updatedAt: "Updated at",
        videos: "Videos",
        clippedVideo: "Clipped Video",
        renderedVideo: "Rendered Video",
        videoPreview: "Video Preview",
        noVideoAvailable: "No video available",
        dailyChart: "Daily Clip Creation",
      },
      downloads: {
        title: "Downloads",
        subtitle: "View all YouTube downloads",
        list: "Downloads List",
        searchPlaceholder: "Search by video ID...",
        videoId: "Video ID",
        status: "Status",
        provider: "Provider",
        language: "Language",
        priority: "Priority",
        createdAt: "Created at",
        linkedProjects: "Linked Projects",
        dailyChart: "Daily Download Creation",
      },
      userDetail: {
        title: "User Details",
        subtitle: "View user projects and clips",
        backToUsers: "Back to users",
        userInfo: "User Information",
        projects: "Projects",
        clips: "Clips",
        restoreExpired: "Restore All Expired",
        restoring: "Restoring...",
        restore: "Restore",
        restoreSuccess: "Expired items restored",
        restoreSuccessDesc: "Restored {{projects}} project(s) and {{clips}} clip(s).",
        restoreError: "Restore failed",
        restoreErrorDesc: "Failed to restore expired items. Try again.",
        projectRestored: "Project restored successfully",
        clipRestored: "Clip restored successfully",
        retry: "Retry",
        retryError: "Retry failed",
        projectRetried: "Project queued for retry",
        clipRetried: "Clip queued for retry",
      },
      library: {
        title: "Library",
        subtitle: "Manage video library from YouTube channels",
        addChannel: "Add Channel",
        channelUrlPlaceholder: "Enter YouTube channel URL or handle...",
        fetchVideos: "Fetch Videos",
        addedChannels: "Library Items",
        channelName: "Name",
        videoCount: "Videos",
        dateAdded: "Date Added",
        noChannels: "No library items yet.",
        videos: "videos",
        addSelected: "Add Selected ({{count}})",
        fetchError: "Failed to fetch channel videos. Check the URL and try again.",
        addSuccess: "{{count}} video(s) added to the library successfully!",
        addError: "Failed to add videos to the library.",
        submitting: "Adding...",
        selectAll: "Select All",
        deselectAll: "Deselect All",
        settings: "Settings",
        format: "Format",
        language: "Language",
        prompt: "Prompt",
        promptPlaceholder: "Describe how the clips should be curated...",
        status: "Status",
        duration: "Duration",
        createdAt: "Created At",
        noItems: "No library items found.",
        modal: {
          title: "Select Videos",
          subtitle: "Choose the videos you want to add to the library",
        },
        promptOptions: {
          viralClips: "Viral Clips",
          memorableQuotes: "Memorable Quotes",
          topicClips: "Topic Clips",
          productAds: "Product Ads",
          testimonials: "Testimonials",
          other: "Other",
        },
        deleteSuccess: "Library item deleted successfully",
        deleteError: "Failed to delete library item",
        retrySuccess: "Library item queued for retry",
        retryError: "Failed to retry library item",
        restoreSuccess: "Library item restored successfully",
        restoreError: "Failed to restore library item",
        dailyChart: "Daily Library Item Creation",
      },
      coupons: {
        assignedUser: "Restrict to one user (optional)",
        assignedUserPlaceholder: "Search by name or email",
        assignedUserClear: "Remove restriction",
        assignedUserBadge: "Exclusive: {{user}}",
        errors: {
          assigned_user_not_found: "User not found.",
        },
        title: "Coupons",
        subtitle: "Manage discount coupons",
        list: "Coupons List",
        searchPlaceholder: "Search by code...",
        createCoupon: "Create Coupon",
        createCouponDesc: "Fill in the details for the new discount coupon",
        editCoupon: "Edit Coupon",
        editCouponDesc: "Update the discount coupon details",
        deleteCoupon: "Delete Coupon",
        deleteConfirm: "Are you sure you want to delete the coupon \"{{code}}\"? This action cannot be undone.",
        code: "Code",
        type: "Type",
        typePercentage: "Percentage",
        typeFlat: "Flat",
        quantity: "Quantity",
        expiryDate: "Expiry Date",
        expired: "Expired",
        monthlySettings: "Monthly Settings",
        monthCycles: "Month Cycles (-1 = forever)",
        monthDiscount: "Month Discount",
        yearlySettings: "Yearly Settings",
        yearCycles: "Year Cycles (-1 = forever)",
        yearDiscount: "Year Discount",
        createdAt: "Created at",
        updatedAt: "Updated at",
        actions: "Actions",
        creating: "Creating...",
        saving: "Saving...",
        deleting: "Deleting...",
        selectType: "Select type",
        toast: {
          created: "Coupon created successfully",
          updated: "Coupon updated successfully",
          deleted: "Coupon deleted successfully",
          createError: "Failed to create coupon",
          updateError: "Failed to update coupon",
          deleteError: "Failed to delete coupon",
        },
      },
      liveWatches: {
        title: "Live Watches",
        subtitle: "Monitor live streams and map them to library channels",
        list: "Configured watches",
        create: "Create watch",
        edit: "Edit watch",
        formDescription: "Paste a live URL. Platform and library channel are inferred from it.",
        liveUrlPlaceholder: "https://www.twitch.tv/channel",
        searchPlaceholder: "Search watches...",
        channelSearchPlaceholder: "Search library channels...",
        channelsLoading: "Loading channels...",
        channelsEmpty: "No channels found.",
        identityPlaceholder: "Channel login",
        channelMatching: "Finding the library channel...",
        channelWillCreate: "A library channel will be created for {{name}}.",
        empty: "No live watches configured.",
        saving: "Saving...",
        detailTitle: "Live watch",
        detailSubtitle: "Watch configuration and session history",
        configuration: "Configuration",
        sessions: "Sessions",
        sessionsEmpty: "No sessions recorded.",
        loadError: "Could not load this live watch.",
        sessionsLoadError: "Could not load the sessions.",
        stopSession: "Stop",
        back: "Back to live watches",
        previous: "Previous",
        next: "Next",
        windows: "Windows",
        windowsEmpty: "No windows yet.",
        ingestStatuses: {
          idle: "Idle",
          running: "Recording",
          stopped: "Stopped",
          failed: "Ingest failed",
        },
        windowStatuses: {
          pending: "Pending",
          curating: "Curating",
          published: "Published",
          empty: "No clips",
          failed: "Failed",
        },
        errors: {
          ingest_dropped: "Recording dropped",
          hls_unresolved: "Could not open the live stream",
          max_concurrent: "Waiting for a recording slot",
          cut_failed: "Could not cut this window",
          curate_failed: "Could not curate this window",
        },
        fields: {
          platform: "Platform",
          kind: "Watch type",
          channel: "Mapped library channel",
          enabled: "Enabled",
          currentStatus: "Current session",
          actions: "Actions",
          sourceUrl: "Live URL",
          platformChannelId: "YouTube channel ID",
          platformLogin: "Platform channel login",
          windowMinutes: "Window (minutes)",
          retentionDays: "Retention (days)",
          overlapSeconds: "Overlap (seconds)",
          identity: "Source identity",
          status: "Status",
          platformLiveId: "Platform live ID",
          startedAt: "Started at",
          endedAt: "Ended at",
          lastError: "Last error",
          ingestStatus: "Ingest",
          heartbeatAt: "Heartbeat",
          retentionExpiresAt: "Raw expires",
          windowRange: "Range in recording",
          library: "Library",
        },
        kinds: {
          channel: "Channel",
          url: "URL",
        },
        statuses: {
          none: "No session",
          pending: "Pending",
          live: "Live",
          ended: "Ended",
          failed: "Failed",
        },
        validation: {
          channelRequired: "Select a mapped library channel.",
          identityRequired: "Enter the required platform identity or live URL.",
        },
        toast: {
          created: "Live watch created.",
          updated: "Live watch updated.",
          saveError: "Could not save the live watch.",
          enabledUpdated: "Live watch state updated.",
          enabledError: "Could not update the live watch state.",
          stopped: "Live session stopped.",
          stopError: "Could not stop the live session.",
        },
      },
      emailFlows: {
        title: 'Email Flows',
        new: 'New flow',
        search: 'Search flows...',
        fields: {
          name: 'Name', slug: 'Slug', description: 'Description', trigger: 'Trigger',
          isActive: 'Active', isTransactional: 'Transactional', isEditable: 'Editable',
          audience: 'Audience',
        },
        audience: {
          all: 'All users',
          ownBrand: 'Own-brand creators',
          otherChannels: 'Community curators',
        },
        managedBySeedWarning: 'This flow is managed by code. Its content is refreshed on every backend boot. Toggle "Editable" and save to take ownership and stop overwrites.',
        table: { steps: 'Steps' },
        inFlightWarning: 'Editing or deleting steps does not cancel emails already scheduled for in-flight runs.',
        steps: {
          title: 'Steps', add: 'Add step', edit: 'Edit', delete: 'Delete',
          delayMinutes: 'Delay (minutes)',
          delayHelper: '0 = send immediately after the previous step (or immediately on trigger for step 1).',
          tabPt: 'Portuguese', tabEn: 'English (optional, falls back to PT)',
          subject: 'Subject', body: 'Body (HTML)',
          preview: 'Preview',
          previewSubject: 'Preview subject',
          variablesAvailable: 'Available variables (click to copy)',
          copied: 'Copied to clipboard',
        },
        testSend: {
          title: 'Send test email', email: 'Recipient email', locale: 'Language', send: 'Send test',
          success: 'Test email sent', failure: 'Test send failed',
        },
        runs: {
          title: 'Recent runs', user: 'User', started: 'Started', status: 'Status', sends: 'Sends',
          empty: 'No runs yet.',
          statuses: { scheduled: 'Scheduled', running: 'Running', completed: 'Completed', failed: 'Failed', cancelled: 'Cancelled' },
        },
        delete: { confirm: 'Delete this flow? This cannot be undone.', success: 'Flow deleted' },
      },
      payouts: {
        title: "Payouts",
        renewalLabel: "Renewal",
        searchPlaceholder: "Search by email or name...",
        registerButton: "Register payout",
        empty: "No payouts recorded.",
        confirmDeleteTitle: "Remove payout?",
        confirmDeleteBody: "The clipper's balance will reflect this amount again.",
        deleteAction: "Remove",
        cancelAction: "Cancel",
        toastCreated: "Payout recorded.",
        toastDeleted: "Payout removed.",
        toastError: "Could not save.",
        columns: {
          user: "Clipper",
          amount: "Amount",
          currency: "Currency",
          paidAt: "Paid at",
          note: "Note",
          createdBy: "Created by",
          actions: "Actions",
        },
        dialog: {
          title: "Register payout",
          userLabel: "Clipper",
          userPlaceholder: "Search clipper...",
          amountLabel: "Amount (R$)",
          paidAtLabel: "Paid at",
          noteLabel: "Note (optional)",
          availableHint: "Available balance: {{amount}}",
          submit: "Save",
          cancel: "Cancel",
          overBalance: "Amount exceeds available balance.",
        },
        userWallet: {
          sectionTitle: "CPM Payouts",
          totalEarned: "Total earned",
          totalPaidOut: "Total paid",
          available: "Available",
        },
      },
      affiliateEarnings: {
        title: 'Commissions and royalties',
        searchPlaceholder: 'Search by email or name...',
        recipient: 'Recipient',
        counterparty: 'Referral or course',
        kindLabel: 'Commission type',
        kindAll: 'All types',
        kindAffiliate: 'Affiliate',
        kindProducer: 'Producer',
        payment: 'Payment',
        commission: 'Amount',
        provider: 'Source',
        sourcePayment: 'Plan',
        sourceCourse: 'Course',
        sourceCpm: 'CPM',
        date: 'Date',
        status: 'Status',
        actions: 'Actions',
        reverse: 'Reverse',
        reverseTitle: 'Reverse commission or royalty?',
        reverseDescription:
          'Use this when the underlying payment was refunded or the earning was disqualified. The amount is removed from the recipient’s wallet. This cannot be undone.',
        reverseNotePlaceholder: 'Reason (optional)',
        confirmReverse: 'Confirm reversal',
        cancel: 'Cancel',
        reversed: 'Commission or royalty reversed.',
        empty: 'No commissions or royalties found.',
        statusPending: 'On hold',
        statusAvailable: 'Released',
        statusReversed: 'Reversed',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        loading: 'Loading commissions and royalties...',
        loadError: 'Could not load commissions and royalties.',
        retry: 'Try again',
        total: '{{total}} total',
      },
      courseRevenueShares: {
        title: 'Course co-producers',
        description:
          'Control who participates in each course sale and audit the resulting royalty balances.',
        add: 'Add co-producer',
        course: 'Course',
        producer: 'Producer',
        rate: 'Percentage',
        active: 'Active',
        inactive: 'Inactive',
        note: 'Note',
        accrued: 'Accrued',
        pending: 'Pending',
        available: 'Available',
        reversed: 'Reversed',
        actions: 'Actions',
        edit: 'Edit',
        deactivate: 'Deactivate',
        activate: 'Activate',
        createTitle: 'Add co-producer',
        createDescription:
          'Choose a course and producer. This identity cannot be changed after creation.',
        editTitle: 'Edit co-producer',
        editDescription:
          'Adjust the royalty percentage, state, or internal note. Course and producer remain locked.',
        selectCourse: 'Select a course',
        selectProducer: 'Select a producer',
        coursesLoading: 'Loading courses...',
        coursesLoadError: 'Could not load courses.',
        retryCourses: 'Retry courses',
        noCourses: 'No courses are available.',
        searchProducer: 'Search producers',
        searchProducerPlaceholder: 'Search by name or email',
        producersLoading: 'Loading producers...',
        producersLoadError: 'Could not load producers.',
        retryProducers: 'Try again',
        noProducers: 'No producers found for this search.',
        identityLocked: 'Course and producer identity cannot be changed.',
        rateValidation: 'Enter a whole percentage from 0 to 100.',
        rateHint: 'Whole number from 0 to 100.',
        notePlaceholder: 'Internal context for this agreement',
        save: 'Save share',
        create: 'Create share',
        cancel: 'Cancel',
        close: 'Close',
        loading: 'Loading co-producers...',
        loadError: 'Could not load course co-producers.',
        empty: 'No course co-producers yet',
        emptyDescription: 'Add an agreement to begin sharing paid course sales.',
        deactivateTitle: 'Deactivate co-producer?',
        deactivateDescription:
          'Future paid sales will stop generating royalties. Existing earnings remain in the ledger.',
        confirmDeactivate: 'Confirm deactivation',
        created: 'Co-producer added.',
        updated: 'Co-producer updated.',
        activated: 'Co-producer activated.',
        deactivated: 'Co-producer deactivated.',
        errors: {
          producer_share_total_exceeds_100:
            'Producer shares cannot exceed 100% for a course.',
          generic: 'Something went wrong. Review the agreement and try again.',
          activate: 'Could not activate this co-producer.',
          deactivate: 'Could not deactivate this co-producer.',
          refresh: 'The change was saved, but the list could not be refreshed.',
        },
        errorTitles: {
          save: 'Could not save co-producer',
          activate: 'Could not activate co-producer',
          deactivate: 'Could not deactivate co-producer',
          refresh: 'List needs refreshing',
        },
      },
      channels: {
        title: "YouTube Channels",
        subtitle: "Manage which channels are Autoclipper Partners",
        list: "Channels List",
        searchPlaceholder: "Search by name, handle, or channel ID...",
        partnerOnly: "Partners only",
        thumbnail: "Thumbnail",
        name: "Name",
        handle: "Handle",
        subscribers: "Subscribers",
        category: "Category",
        partner: "Partner",
        actions: "Actions",
        partnerYes: "Partner",
        partnerNo: "Not partner",
        toast: {
          updated: "Channel updated",
          updateError: "Failed to update channel",
        },
        importDrive: "Import from Google Drive",
        importModal: {
          title: "Import from Google Drive — {{channel}}",
          subtitle: "Paste one Drive URL per line. Folders are walked recursively. Up to 50 URLs per submit.",
          placeholder: "https://drive.google.com/drive/folders/...\nhttps://drive.google.com/file/d/.../view",
          submit: "Import",
          cancel: "Cancel",
          importMore: "Import more",
          close: "Close",
          status: {
            queued: "Queued",
            linked_existing: "Linked existing",
            already_linked: "Already linked",
            error: "Error",
          },
          summary: "{{queued}} queued · {{linked}} linked · {{alreadyLinked}} already linked · {{errors}} error(s)",
          column: {
            input: "Input URL",
            fileName: "File name",
            status: "Status",
            error: "Error",
          },
          toast: {
            failed: "Import failed",
          },
        },
      },
      challenges: {
        title: "Challenges",
        subtitle: "Manage championship challenges",
        list: "Challenges List",
        searchPlaceholder: "Search by challenge name...",
        createChallenge: "Create Challenge",
        createChallengeDesc: "Fill in the details for the new challenge",
        editChallenge: "Edit Challenge",
        editChallengeDesc: "Update the challenge details",
        deleteChallenge: "Delete Challenge",
        deleteConfirm: "Are you sure you want to delete the challenge \"{{name}}\"? This action cannot be undone.",
        name: "Name",
        description: "Description",
        startDate: "Start Date",
        endDate: "End Date",
        prizePool: "Prize Pool",
        warningMessage: "Warning Message",
        rulesAllowed: "Rules Allowed",
        rulesForbidden: "Rules Forbidden",
        rulesAttention: "Rules Attention / Warning",
        isAcceptingParticipants: "Accepting participants",
        isAcceptingParticipantsHint: "When disabled, users will no longer be able to join this challenge",
        rankings: "Rankings",
        rankingsFor: "Rankings for {{name}}",
        addRanking: "Add ranking",
        editRanking: "Edit ranking",
        rankingName: "Ranking name",
        rankingTimezone: "Timezone",
        rankingConsolidationTime: "Consolidation date/time",
        rankingConsolidationTimeHint: "Enter in the local time of the timezone selected above",
        consolidated: "Consolidated",
        pending: "Pending",
        pendingValidation: "Pending validation",
        validated: "Validated",
        validate: "Validate",
        unvalidate: "Revoke validation",
        rankingValidation: "Ranking validation",
        rankingValidated: "Ranking validated and published!",
        rankingUnvalidated: "Ranking validation revoked.",
        rankingNotConsolidated: "This ranking has not been consolidated yet.",
        partialRankingHint: "Live partial ranking — data may change until consolidation.",
        consolidatedNotValidated: "Consolidated ranking — pending admin validation before publishing.",
        validateConfirmTitle: "Validate ranking?",
        validateConfirmDescription: "This will publish the ranking \"{{name}}\" and make it visible to all users.",
        unvalidateConfirmTitle: "Revoke validation?",
        unvalidateConfirmDescription: "This will hide the ranking \"{{name}}\" from users until it is validated again.",
        rankingCreated: "Ranking created successfully!",
        rankingUpdated: "Ranking updated successfully!",
        rankingDeleted: "Ranking deleted successfully!",
        audit: "Audit",
        auditParticipant: "Audit participant",
        auditClips: "Participant clips",
        approvalReason: "Reason for disapproval",
        approvalReasonPlaceholder: "Describe the reason for disapproval (optional)...",
        disapproveConfirm: "Set disapproval reason",
        requiredHashtags: "Required Hashtags",
        captionExamples: "Caption Examples",
        prizeData: "Prize Data",
        onePerLine: "One item per line",
        jsonFormat: "JSON format",
        prizeBuilder: {
          addTab: "Add ranking / period",
          tabName: "Tab name (e.g. Week 1)",
          prizes: "Prizes",
          position: "Position (e.g. 1st place)",
          prize: "Prize (e.g. R$ 3,000)",
          addPrize: "Add prize",
          bonus: "Bonus (gift row)",
          bonusPlaceholder: "e.g. PRO Plan + Mentorship",
          footer: "Footer note",
          footerPlaceholder: "e.g. Each competitor can only be awarded in one ranking.",
          preview: "Live preview",
          viewJson: "View / Import JSON",
          copy: "Copy",
          applyJson: "Apply JSON",
          jsonInvalid: "Invalid JSON — check the format and try again.",
          startDate: "Start date/time",
          endDate: "End date/time",
          timezone: "Timezone",
          timezonePlaceholder: "Select timezone",
          timezoneSearch: "Search timezone...",
          timezoneNotFound: "No timezone found.",
        },
        viewChallenge: "View challenge page",
        viewClips: "View all clips",
        approval: "Approval",
        approvalNeutral: "Neutral",
        approvalApprove: "Approved",
        approvalDisapprove: "Disapproved",
        approvalFilter: "Filter by approval",
        approvalAll: "All",
        approvalSet: "Approval updated!",
        approvalError: "Failed to update approval",
        hashtagValidation: "Hashtags",
        hashtagValidated: "Validated",
        hashtagInvalidated: "Invalidated",
        hashtagNeutral: "Pending",
        hashtagValidationSet: "Hashtag validation updated!",
        hashtagValidationError: "Failed to update hashtag validation",
        manualViews: "Set views manually",
        manualViewsConfirm: "Manually record views for this clip (creates or overwrites today's entry)",
        manualViewsLabel: "Views",
        manualViewsSave: "Save views",
        manualViewsSaved: "Views saved!",
        manualViewsError: "Failed to save views",
        manualViewsInvalid: "Please enter a valid number",
        forceUpdateAllViews: "Force Update All Views",
        forceUpdateAllViewsConfirm: "This will re-fetch views from all platforms for every clip in this challenge. Continue?",
        forceUpdateAllViewsSuccess: "View update dispatched for {{count}} clips",
        forceUpdateAllViewsError: "Failed to dispatch view update",
        syncMissingViews: "Sync Missing Only",
        syncMissingViewsConfirm: "This will only fetch views for clips that have no data for today. Continue?",
        syncMissingViewsSuccess: "Missing view sync dispatched for {{count}} clips",
        syncMissingViewsError: "Failed to dispatch missing view sync",
        syncMissingViewsNone: "No clips are missing data for today",
        forceUpdateClipView: "Force update views",
        forceUpdateClipViewSuccess: "View update dispatched for this clip",
        forceUpdateClipViewError: "Failed to dispatch clip view update",
        hashtagValidationFilter: "Filter by hashtag validation",
        participant: "Participant",
        participants: "Participants",
        participantCount: "Participants",
        addParticipant: "Add Participant",
        addParticipantDesc: "Enter the user's email to add them as a participant",
        participantEmail: "User Email",
        importParticipants: "Import Participants",
        importParticipantsDesc: "Upload a CSV or XLSX file with an \"email\" column to bulk-add participants.",
        selectFile: "Select File",
        importSummary: "Import Summary",
        importAdded: "Added",
        importSkipped: "Already participating",
        importCreated: "Account created (password reset email sent)",
        importing: "Importing...",
        importDone: "Import completed",
        importNoEmails: "No valid emails found in the file",
        removeParticipant: "Remove Participant",
        removeParticipantConfirm: "Are you sure you want to remove {{name}} from this challenge?",
        totalViews: "Total Views",
        clipCount: "Clips",
        active: "Active",
        ended: "Ended",
        upcoming: "Upcoming",
        createdAt: "Created at",
        actions: "Actions",
        creating: "Creating...",
        saving: "Saving...",
        deleting: "Deleting...",
        adding: "Adding...",
        removing: "Removing...",
        status: "Status",
        disqualified: "Disqualified",
        qualified: "Active",
        disqualify: "Disqualify",
        requalify: "Requalify",
        disqualifyConfirm: "Are you sure you want to disqualify {{name}} from this challenge?",
        requalifyConfirm: "Are you sure you want to requalify {{name}} in this challenge?",
        disqualificationReason: "Reason for disqualification",
        disqualificationReasonPlaceholder: "Explain why this participant is being disqualified...",
        disqualifying: "Updating...",
        noParticipants: "No participants yet",
        usage: "Usage",
        resetUsage: "Reset Usage",
        resetAllUsage: "Reset All Usage",
        resetUsageConfirm: "Are you sure you want to reset the usage for {{name}}? This will set all current month counters to zero.",
        resetAllUsageConfirm: "Are you sure you want to reset the usage for all participants in this challenge? This will set all current month counters to zero.",
        resettingUsage: "Resetting...",
        usageReset: "Usage reset successfully",
        allUsageReset: "All participants usage reset successfully",
        usageResetError: "Failed to reset usage",
        forceStartSnapshot: "Force Start Snapshot",
        forceConsolidation: "Force Consolidation",
        forceStartSnapshotConfirmTitle: "Force start snapshot?",
        forceStartSnapshotConfirmDescription: "This will snapshot the current views for all clips in ranking \"{{name}}\". This cannot be undone.",
        forceConsolidationConfirmTitle: "Force consolidation?",
        forceConsolidationConfirmDescription: "This will consolidate ranking \"{{name}}\" using the current views as end snapshot. This cannot be undone.",
        forceStartSnapshotSuccess: "Start snapshot created successfully!",
        forceConsolidationSuccess: "Ranking consolidated successfully!",
        forceStartSnapshotError: "Failed to create start snapshot",
        forceConsolidationError: "Failed to consolidate ranking",
        snapshotAlreadyExists: "Start snapshot already exists",
        alreadyConsolidated: "Ranking is already consolidated",
        snapshotAudit: "Snapshot Audit",
        snapshotAuditFor: "Snapshot audit for \"{{name}}\"",
        startSnapshot: "Start Snapshot",
        endSnapshot: "End Snapshot",
        snapshotViews: "Snapshot Views",
        clipUrl: "Clip URL",
        platform: "Platform",
        views: "Views",
        editViews: "Edit views",
        saveViews: "Save",
        viewsUpdated: "Views updated successfully!",
        viewsUpdateError: "Failed to update views",
        noSnapshots: "No snapshot records",
        delta: "Delta",
        partialRankingExtract: "Extract Partial Ranking",
        partialRankingExtractDesc: "Select a date range to compute a partial ranking based on the closest available view snapshots.",
        partialRankingResults: "Partial Ranking Results",
        partialRankingPeriod: "Period: {{start}} to {{end}}",
        partialRankingNoResults: "No participants with views in this period.",
        partialRankingClipsWithoutViews: "{{count}} clip(s) had no view data for this period",
        partialRankingClipsWithoutViewsDetail: "The following clips had no view snapshots available:",
        partialRankingMissingStart: "missing start snapshot",
        partialRankingMissingEnd: "missing end snapshot",
        partialRankingMissingBoth: "missing both snapshots",
        partialRankingError: "Failed to fetch partial ranking",
        syncAllViews: "Sync All Views",
        syncingViews: "Syncing views...",
        copyToClipboard: "Copy",
        copiedToClipboard: "Copied!",
        viewsGrowthChart: "Views Growth & New Clips (Last 30 Days)",
        newClips: "New Clips",
        summaryTotalViews: "Total Views",
        summaryTotalClips: "Total Clips",
        summaryAvgViewsPerClip: "Avg Views/Clip",
        summaryNewClipsToday: "New Clips Today",
        toast: {
          created: "Challenge created successfully",
          updated: "Challenge updated successfully",
          deleted: "Challenge deleted successfully",
          createError: "Failed to create challenge",
          updateError: "Failed to update challenge",
          deleteError: "Failed to delete challenge",
          participantAdded: "Participant added successfully",
          participantAddError: "Failed to add participant",
          participantRemoved: "Participant removed successfully",
          participantRemoveError: "Failed to remove participant",
          participantDisqualified: "Participant disqualified successfully",
          participantRequalified: "Participant requalified successfully",
          disqualifyError: "Failed to update disqualification status",
        },
      },
      clipperSeasons: {
        title: "Clipper seasons",
        subtitle: "Manage the season windows used for clipper rankings.",
        list: "All seasons",
        create: "Create season",
        createDescription: "Define the name and date window for a new season.",
        edit: "Edit season",
        editDescription: "Update the season name or its dates before the start snapshot.",
        loading: "Loading…",
        empty: "No seasons yet.",
        forceSnapshot: "Force start snapshot",
        forceConsolidate: "Force consolidate",
        datesLockedHelp: "Season dates are locked after the start snapshot.",
        columns: {
          name: "Name",
          window: "Window",
          status: "Status",
          actions: "Actions",
        },
        fields: {
          name: "Name",
          startsAt: "Starts at",
          endsAt: "Ends at",
        },
        status: {
          scheduled: "Scheduled",
          active: "Active",
          consolidated: "Consolidated",
        },
        errors: {
          overlap: "This season overlaps another season.",
          datesLocked: "Season dates are locked after its start snapshot.",
          generic: "Couldn't update clipper seasons",
        },
        toast: {
          created: "Season created",
          updated: "Season updated",
          snapshotted: "Start snapshot completed",
          consolidated: "Season consolidated",
        },
      },
      campaigns: {
        title: "CPM Campaigns",
        subtitle: "Manage cost-per-mille campaigns and clip submissions.",
        allCampaigns: "All campaigns",
        allStatuses: "All statuses",
        newCampaign: "New campaign",
        empty: "No campaigns yet.",
        loading: "Loading…",
        submissionsCount_one: "{{count}} submission",
        submissionsCount_other: "{{count}} submissions",
        perThousandViews: "per 1,000 views",
        backToList: "Back to list",
        viewSubmissions: "View submissions",
        rankMinFinishedRenders: "Minimum finished clips for ranks",
        rankMinFinishedRendersHint: "A clipper must finish at least this many clips in the campaign for it to count on the Content Mercenary track. Leave blank to use the default.",
        status: {
          draft: "Draft",
          active: "Active",
          paused: "Paused",
          ended: "Ended",
          scheduled: "Scheduled",
        },
        statusDescriptions: {
          draft: "Only the team can see it — nothing shows to clippers yet.",
          active: "Live: shows in the active campaigns list and can be joined.",
          paused: "Temporarily off the active list, nothing is deleted — comes back once switched to Active again.",
          ended: "Ended — drops off the active list and shows as social proof in the ended campaigns list.",
          scheduled: "Shows to clippers in Coming Soon. A start date is shown when set; without one the card stays dateless. Can't be joined yet. Switch to Active manually once it opens — without a start date the campaign never auto-activates.",
        },
        edit: {
          cpmPerPlatformErrors: {
            cpm_platform_rate_invalid: "Use a value above zero. To stop a network from paying, untick it in Allowed platforms.",
            cpm_platform_rate_duplicate: "The same network appears twice in the network rates.",
            cpm_platform_rate_platform_not_allowed: "There is a rate for a network the campaign does not accept. Tick it in Allowed platforms or clear the rate.",
          },
          newTitle: "New campaign",
          editTitle: "Edit campaign",
          newSubtitle: "Create a new CPM campaign.",
          editSubtitle: "Update campaign details, rules, and targets.",
          detailsCard: "Campaign details",
          economicsCard: "Economics",
          rulesCard: "Rules",
          targetsCard: "Targets & auditors",
          liveImport: {
            title: "Automatic new lives",
            description: "When the channel finishes a live with these words, it joins the library and this campaign, and participants get an email.",
            enabled: "Turn on automatic lives",
            channel: "YouTube channel",
            channelPlaceholder: "Channel link, @handle or a video link",
            channelHint: "Paste the channel link or any of its videos. Only finished lives are added; Shorts and regular videos are not.",
            words: "Words the live must contain",
            wordsPlaceholder: "type and press Enter…",
            wordsHint: "Searched in the title and description. Case, accents and spaces are ignored.",
            removeWord: "Remove",
            processing: "How to process each live",
            format: "Clip length",
            language: "Language",
            formats: {
              max_30_sec: "Clips up to 30 s",
              max_1_min: "Clips up to 1 min",
              auto: "Automatic length",
            },
            languages: {
              "pt-BR": "Portuguese (BR)",
              "en-US": "English (US)",
              "es-ES": "Spanish",
            },
            promptPlaceholder: "Instructions for the AI to pick clips (optional)",
            notify: "Email participants",
            notifyHint: "One email per live, once it finishes processing. Only people who joined and did not leave.",
            save: "Save automatic lives",
            latestChecks: "Latest checks",
            lastCheck: "Last:",
            nextCheck: "next:",
            neverChecked: "Not checked yet. Checks every 30 min.",
            lastError: "Last check failed:",
            checkNow: "Check now",
            emptyLog: "No lives found yet.",
            status: {
              added_sent: "Added · email sent",
              added: "Added · processing",
              live: "Live now · added when it ends",
              ignored_no_keyword: "Skipped: no matching word",
              ignored_out_of_dates: "Skipped: outside campaign dates",
              ignored_before_enabled: "Skipped: before it was turned on",
              already_linked: "Already in the campaign",
              failed: "Processing failed",
            },
            errors: {
              title: "Could not finish",
              already_running: "A check is already running. Try again in a moment.",
              campaign_not_found: "Campaign not found.",
              channel_not_found: "We couldn't find that YouTube channel. Check the link.",
              channel_required: "Enter the YouTube channel to turn this on.",
              keywords_required: "Add at least one word to turn this on.",
              invalid_keywords: "Use at most 20 words, up to 60 characters each.",
              invalid_format: "Invalid clip length.",
              invalid_language: "Invalid language.",
              generic: "Something went wrong. Try again.",
            },
          },
          fields: {
            name: "Name",
            logo: "Campaign logo",
            banner: "Campaign banner (16:9)",
            categories: "Categories",
            description: "Description",
            status: "Status",
            currency: "Currency",
            startDate: "Start date",
            startDateScheduledHint: "Optional. Leave empty to announce the campaign as coming soon without a date. The campaign will not auto-activate until you switch it to Active.",
            endDate: "End date",
            cpmRate: "CPM rate per 1,000 views",
            cpmPerPlatform: "Different CPM per social network",
            cpmPerPlatformHint: "Blank means the network uses the CPM rate above. When you raise a rate, clips of that network still inside the paid-views window get the difference at the next update. For clips outside the window (Instagram stops updating them) or when you lower a rate, use Recalculate payouts.",
            budgetTotal: "Budget total",
            minViews: "Min views",
            minViewsHint: "Applies to new views automatically. To re-price clips that already earned (e.g. after raising this), use \"Recompute payouts\" below.",
            minPayout: "Min payout per clipper",
            maxPayout: "Max payout per clipper",
            maxPayoutPerClip: "Max payout per clip",
            rankMinFinishedRenders: "Minimum finished clips for ranks",
            rankMinFinishedRendersHint: "A clipper must finish at least this many clips in the campaign for it to count on the Content Mercenary track.",
            viewAccrualWindow: "Paid-view window (hours)",
            viewAccrualWindowHint: "Views earn payment only within this many hours after clip submission. 0 = unlimited. Views keep being tracked afterwards but stop being paid.",
            requiredHashtags: "Required hashtags",
            requiredMention: "Required mention",
            requiredMentionHint: "Profile the clip must tag/mention (e.g. @profile). Used by the automatic pre-approval gate. Leave empty if the campaign doesn't require a mention.",
            rulesAllowed: "Rules — allowed",
            rulesForbidden: "Rules — forbidden",
            rulesAttention: "Rules — attention",
            rulesWarning: "Rules — warning",
            captionExamples: "Caption examples",
            captionExamplesHelpIntro: "Use UPPERCASE headers followed by a colon to separate platforms. Example:",
            captionExamplesHelpExample: "TIKTOK:\nExample caption for TikTok...\n\nREELS:\nExample caption for Reels...\n\nSHORTS:\nExample caption for YouTube Shorts...\n\nDICA:\nTip for the clipper — appears as a highlighted block at the bottom of the examples card (e.g. \"tag the channel as a collaborator\").",
            captionExamplesHelpDica: "The DICA: section is rendered as a highlighted footer block, separate from the caption examples themselves.",
            channels: "YouTube channels",
            channelsPlaceholder: "Select channels…",
            channelsSearchPlaceholder: "Search channels by name…",
            videos: "Campaign videos",
            videosPlaceholder: "Select videos…",
            videosSearchPlaceholder: "Search videos by name…",
            addAllFromChannel: "Add all from a channel",
            addAllFromChannelHint: "Pick a channel to add every one of its videos.",
            admins: "Campaign auditors",
            adminsPlaceholder: "Select auditors…",
            adminsSearchPlaceholder: "Search users by name or email…",
            emptyResults: "No results",
            loading: "Loading…",
          },
          cpmOverride: {
            title: "Per-video CPM override",
            allow: "Allow per-video CPM override",
            allowHelp: "Campaign auditors will be able to change individual videos' CPM while auditing. The video's earnings are recomputed retroactively.",
            mode: "Allowed values",
            modePresets: "Preset values",
            modeFree: "Free input",
            presets: "Available CPM values",
            addPreset: "Add",
            removePreset: "Remove value",
            min: "Minimum CPM (optional)",
            max: "Maximum CPM (optional)",
          },
          preApproval: {
            cardTitle: "Automatic pre-approval (pilot)",
            cardHint: "Controls this campaign's automatic pre-approval pilot: the clipper's Analytics connection, engagement above the threshold, and the campaign's rules (hashtag, mention, and platform). Pre-approval never replaces the auditor's decision.",
            enabled: "Enable automatic pre-approval on this campaign",
            enabledHelp: "Turns the pilot on for this campaign. Clips that clear the gates show up as Pre-Approved until the audit confirms them.",
            minScore: "Minimum engagement score (0-100)",
            minScoreHint: "Clips with an engagement score below this value are not pre-approved. Default: 50.",
            allowedPlatforms: "Allowed platforms",
            allowedPlatformsHint: "None checked = all platforms are allowed. Checking one or more restricts pre-approval to those platforms.",
          },
          actions: {
            create: "Create",
            save: "Save",
            delete: "Delete",
          },
          recompute: {
            button: "Recompute payouts",
            running: "Recomputing…",
            dialogTitle: "Recompute all clip payouts?",
            dialogDescription: "Re-prices every approved clip in this campaign against the current settings (min views, CPM rate, caps). Clips that no longer qualify will have their payouts LOWERED and the amount refunded to the budget. Already-paid amounts are never clawed back — the difference nets against the clipper's future earnings. Save your changes first.",
            confirm: "Recompute",
            successTitle: "Payouts recomputed",
            successDescription: "{{changed}} clip(s) changed. Net budget change: {{delta}}.",
            errorTitle: "Couldn't recompute payouts",
          },
          deleteConfirm: "Delete this campaign?",
          forceDeleteConfirm: "Campaign has payouts. Force delete?",
          toast: {
            createSuccessTitle: "Campaign created",
            createSuccessDescription: "Your campaign is ready to be edited.",
            saveSuccessTitle: "Campaign saved",
            saveSuccessDescription: "Your changes are live.",
            saveErrorTitle: "Couldn't save campaign",
            deleteSuccessTitle: "Campaign deleted",
            deleteErrorTitle: "Couldn't delete campaign",
          },
          tabs: {
            edit: "Edit",
            submissions: "Submissions",
            participants: "Participants",
          },
          requiresChannelApproval: "Require channel approval before users can submit videos",
          requiresChannelApprovalHelp: "Users must register their channels and be approved by an admin before posting videos to this campaign.",
          restrictToListedVideos: "Only the listed videos participate",
          restrictToListedVideosHelp: "Attached channels are used only to show the campaign in the showcase — their other videos are not eligible.",
          excludedVideos: {
            title: "Videos removed from the campaign",
            help: "To remove a video (including ones an attached channel brings in), use the trash button on the video card on the campaign page.",
            empty: "No videos removed.",
            restore: "Restore",
            errorTitle: "Could not restore",
            error: "We could not restore the video. Please try again.",
          },
          inviteOnly: "Exclusive campaign (invite only)",
          inviteOnlyHelp: "Only users pre-approved by an admin or subscribed to any paid plan can submit clips. The card appears on the 'Earn with Clips' page but without navigation for users without access.",
          selectedOnly: {
            label: "Restrict to selected clippers",
            help: "Only the clippers picked here can join — neither a paid plan nor an approved channel grants access. Use this when the client wants a closed campaign just for clippers they (or Autoclipper) already picked, e.g. the top performers from a previous open campaign.",
            emptyListWarning: "No clipper picked yet. You can save like this and curate the list later, but until someone is on it the campaign is invisible — nobody can see or join it.",
            pickerLabel: "Selected clippers",
            pickerPlaceholder: "No clipper selected",
          },
          banner: {
            uploadLabel: "Upload campaign banner",
            uploadHint: "16:9 image shown at the top of the campaign cards. Recommended: 1600×900, PNG, JPG or WebP, no text.",
            uploading: "Uploading...",
            uploadErrorTitle: "Upload failed",
            uploadErrorFormat: "Only PNG, JPG and WebP images are accepted.",
            uploadErrorGeneric: "Could not upload the campaign banner.",
            removeButton: "Remove banner",
          },
          categories: {
            hint: "Pick up to 3. They show on the campaign cards.",
            errors: {
              invalid_category: "Invalid category. Reload the page and try again.",
              too_many_categories: "Pick at most 3 categories.",
            },
          },
          logo: {
            uploadLabel: "Upload campaign logo",
            uploadHint: "Shown instead of the channel avatar on campaign cards. Square PNG or JPG recommended.",
            uploading: "Uploading...",
            uploadErrorTitle: "Upload failed",
            uploadErrorFormat: "Only PNG and JPG images are accepted.",
            uploadErrorGeneric: "Could not upload the campaign logo.",
            removeButton: "Remove logo",
          },
          watermark: {
            cardTitle: "Watermark",
            uploadLabel: "Upload watermark image",
            uploadHint: "Recommended: transparent PNG. PNG or JPG.",
            uploading: "Uploading...",
            uploadErrorTitle: "Upload failed",
            uploadErrorFormat: "Only PNG and JPG images are accepted.",
            uploadErrorGeneric: "Could not upload the watermark image.",
            removeButton: "Remove watermark",
            anchorLabel: "Position",
            anchors: {
              "top-left": "Top left",
              "top-center": "Top center",
              "top-right": "Top right",
              "center-left": "Center left",
              center: "Center",
              "center-right": "Center right",
              "bottom-left": "Bottom left",
              "bottom-center": "Bottom center",
              "bottom-right": "Bottom right",
            },
            sizeLabel: "Size: {{value}}% of video height",
            opacityLabel: "Opacity: {{value}}%",
            marginXLabel: "Horizontal margin: {{value}}%",
            marginYLabel: "Vertical margin: {{value}}%",
            marginHelp: "Pushes the watermark inward from the anchor edge. Ignored for centered anchors.",
            previewLabel: "Preview",
            verticalFrame: "Vertical (9:16)",
            horizontalFrame: "Horizontal (16:9)",
          },
          enforcedLayout: {
            cardTitle: "Enforced Layout",
            description: "Force a post layout on every video exported for this campaign.",
            enable: "Enforce a layout",
            locked: "Locked",
            default: "Default",
          },
          editingAssets: {
            cardTitle: "Editing Assets",
            description: "Files offered for download to clippers who edit the campaign videos outside the platform (logos, fonts, overlays, project files).",
            upload: "Upload files",
            uploading: "Uploading…",
          },
          enforcedSubtitle: {
            cardTitle: "Subtitle Position",
            description: "Anchor and vertical margin for subtitles, just like the template. Overrides the template values. \"Default\" lets users change them; \"Locked\" enforces them.",
            enable: "Set the subtitle position",
            positionLabel: "Vertical position",
            marginLabel: "Vertical margin",
            previewLabel: "Preview",
          },
        },
        channelRequests: {
          tab: "Channel requests",
          tabWithCount: "Channel requests ({{count}})",
          invite: {
            title: "Add a user to this campaign",
            help: "Creates an approved channel request so the user can participate — useful for invite-only campaigns. Enter the user's channel / profile URL (required for YouTube channel matching).",
            emailPlaceholder: "User email",
            channelUrlPlaceholder: "Channel / profile URL",
            button: "Add user",
            success: "User added to the campaign.",
            missingFields: "Email and channel URL are required.",
          },
          empty: "No channel requests for this filter.",
          approve: "Approve",
          reject: "Reject",
          revoke: "Revoke",
          reasonPlaceholder: "Reason (required when rejecting)",
          approveReasonPlaceholder: "Reason / note for the user (optional)",
          confirmApprove: "Confirm approval",
          reasonLabel: "Reason",
          reasonRequired: "A reason is required when rejecting.",
          statusFilter: { pending: "Pending", approved: "Approved", rejected: "Rejected", all: "All" },
          totalLabel: "requests",
          previousPage: "Previous page",
          nextPage: "Next page",
          columns: {
            user: "User",
            platform: "Platform",
            channel: "Channel",
            submittedAt: "Submitted",
            status: "Status",
            reviewer: "Reviewer",
            actions: "Actions",
          },
        },
        accountDisqualification: {
          action: "Disqualify account",
          activeStatus: "Active",
          liftedStatus: "Lifted",
          restoredStatus: "Clips restored",
          reasonLabel: "Reason",
          reasonHint: "The reason is shown to the clipper.",
          reasonPlaceholder: "Explain why this account is being disqualified",
          disqualifiedBy: "By {{name}}",
          liftedBy: "Lifted by {{name}}",
          disqualifyTitle: "Disqualify {{account}}",
          disqualifyDescription: "Only the {{account}} account ({{platform}}) is disqualified. The user's other clips stay valid.",
          previewAffected: "Affected clips: {{count}}",
          previewReversed: "Amount reversed: {{amount}}",
          previewRefunded: "Returned to the budget: {{amount}}",
          previewRetained: "Retained (not returned): {{amount}}",
          confirmDisqualify: "Disqualify account",
          updateTitle: "Update the disqualification of {{account}}",
          updateDescription: "The {{account}} account ({{platform}}) is already disqualified in this campaign. Confirming replaces the reason and disqualifies this account's clips that still count.",
          confirmUpdate: "Update disqualification",
          successUpdated: "Disqualification updated.",
          liftAction: "Lift disqualification",
          liftTitle: "Lift disqualification of {{account}}",
          restoreAction: "Restore clips",
          restoreTitle: "Restore clips of {{account}}",
          restoreClips: "Also restore the clips and their money",
          restorableCount: "Restorable clips: {{count}}",
          skippedCount: "Skipped clips: {{count}}",
          restoreAmount: "Amount to restore: {{amount}}",
          budgetCharge: "Charged to the budget: {{amount}}",
          budgetRemaining: "Remaining budget: {{amount}}",
          forceCappedHint: "A full restore would exceed the limit by {{amount}}. Restore only up to the limit.",
          restoreWithCap: "Restore with limit",
          nothingToRestore: "There are no clips to restore for this account.",
          previewLoadError: "Could not load the preview. Close and try again.",
          filterWithAccount: "With disqualified account",
          filterWithAccountEmpty: "No clipper with a disqualified account.",
          blockers: {
            budget: "The remaining budget does not cover the restore. {{amount}} is missing.",
            userDisqualified: "The user is disqualified from the campaign. Lift that first to restore the clips.",
            rankingFinalized: "The ranking is already finalized. Accounts cannot be changed.",
          },
          confirmLift: "Lift",
          confirmRestore: "Restore",
          cancel: "Cancel",
          successDisqualified: "Account disqualified.",
          allAccountsLabel: "Disqualify all of {{user}}'s accounts in this campaign",
          allAccountsTitle: "Disqualify {{user}}",
          allAccountsDescription: "All of {{user}}'s accounts are disqualified in this campaign, and the user can't send new clips.",
          allAccountsNote: "All of the user's approved and pending clips stop counting. Their money goes back to the budget, except what the clipper already withdrew.",
          allAccountsNoteRanking: "All of the user's clips leave the ranking.",
          reasonPlaceholderUser: "Explain why the user is being disqualified",
          confirmDisqualifyUser: "Disqualify user",
          successUserDisqualified: "User disqualified from the campaign.",
          successLifted: "Disqualification lifted.",
          successRestored: "Clips restored.",
          errors: {
            cpm_account_unidentified: "The account of this clip could not be identified.",
            cpm_account_restore_cap_exceeded: "The restore would exceed the per-clipper limit by {{overCents}}.",
            cpm_account_restore_budget_insufficient: "The budget does not cover the restore. {{missingCents}} is missing.",
            cpm_account_restore_user_disqualified: "The user is disqualified from the campaign.",
            cpm_account_not_found: "Record not found.",
            cpm_account_forbidden: "You are not allowed to do this.",
            cpm_account_reason_required: "Enter the reason.",
            cpm_account_already_lifted: "This disqualification was already lifted.",
            cpm_account_already_restored: "This account's clips were already restored.",
            cpm_account_conflict: "Something else changed at the same time. Refresh and try again.",
            cpm_account_failed: "Could not complete the action. Please try again.",
            ranking_finalized: "The ranking is already finalized.",
          },
        },
        submissions: {
          reviewImages: {
            appealHint: 'Images are only sent with "Keep disapproval" or "Ask for more data". Remove them to accept the appeal.',
            label: "Images (optional)",
            hint: "Public images are shown to the clipper. Private images are visible to admins only.",
            add: "Add",
            public: "Public",
            private: "Private",
            remove: "Remove image",
            invalidType: "Only image files are accepted.",
            uploadFailed: "Image upload failed. Please try again.",
            maxReached: "Maximum of {{max}} images reached.",
            errors: {
              invalid_rejection_images: "One or more rejection images are invalid.",
              too_many_rejection_images: "Too many rejection images.",
              invalid_reviewer_images: "One or more reply images are invalid.",
              too_many_reviewer_images: "Too many reply images.",
            },
          },
          title: "Submissions",
          subtitle: "Review, approve, and disqualify clip submissions for this campaign.",
          empty: "No submissions match this filter.",
          filters: {
            all: "All",
            pending: "Pending",
            approved: "Approved",
            disapproved: "Disapproved",
            suspectedDuplicates: "Duplicates",
            platform: "Platform",
            aging: "Pending 72h+",
            hashtags: "Hashtags",
          },
          appeals: {
            tab: "Contests",
            pending: "Pending",
            accepted: "Accepted",
            kept: "Kept",
            needs_more_info: "Waiting on clipper",
            all: "All",
            accept: "Revert and approve",
            keep: "Keep disapproval",
            requestMore: "Ask for more data",
            keepReply: "Reply to clipper",
            observation: "Observation for the clipper",
            observationHint: "Optional on approve. Required to keep the disapproval or ask for more data.",
            contestingBadge: "Contesting",
            pendingToast: "There is a pending contest. Resolve it in the Contests tab.",
            empty: "No contests match this filter.",
            originalReason: "Original reason",
            argument: "Argument",
            extraUrl: "Extra link",
            photos: "Photos",
          },
          bulkApprove: "Approve {{count}}",
          bulkApproveConfirm: "Approve {{count}} selected pending submissions? Contested, grouped, or disqualified rows will be skipped.",
          bulkApproveResult: "{{approved}} approved, {{skipped}} skipped",
          reasonRequired: "Provide a reason before disapproving.",
          reasonChips: {
            video_from_unapproved_channel: "Unapproved channel",
            missing_hashtag: "Missing hashtag",
            off_brief: "Off brief",
            missing_watermark: "Missing watermark",
            other: "Other…",
          },
          disqualifiedBadge: "DISQUALIFIED",
          suspectedDuplicateBadge: "Suspected duplicate",
          preApproval: {
            badge: "Pre-approved",
            ineligibleBadge: "Warning",
            score: " · score {{score}}",
            tooltip: "Automatic result from the pre-approval gates (Analytics connection, engagement, and campaign rules). It does not replace the auditor's decision.",
          },
          reliability: {
            lowBadge: 'Low reliability · {{score}}',
            tooltip: '{{username}} · {{rate}}% engagement · {{views}} views · {{videos}} videos',
          },
          notDuplicate: "Not a duplicate",
          disqualifyDuplicate: "Disqualify",
          disqualifyDuplicateConfirm: "Disqualify this submission as a duplicate? Its payout will be zeroed.",
          resolveClearedSuccess: "Marked as not a duplicate",
          resolveDisqualifiedSuccess: "Submission disqualified as a duplicate",
          resolveFailed: "Could not resolve the flag. Try again.",
          views: "Views",
          earned: "Earned",
          cents: "cents",
          actions: {
            approve: "Approve",
            disapprove: "Disapprove",
            disqualify: "Disqualify",
            forceUpdate: "Force update views",
            disqualifyUser: "Disqualify user",
            undisqualifyUser: "Reinstate user",
            editObservation: "Add / edit observation",
          },
          forceUpdateQueued: "View update dispatched for this clip",
          forceUpdateError: "Failed to dispatch view update",
          forceUpdateAll: "Force Update All Views",
          forceUpdateAllConfirm: "This will re-fetch views from all platforms for every submission in this campaign. Continue?",
          forceUpdateAllQueued: "View update dispatched for {{count}} submissions",
          forceUpdateAllError: "Failed to dispatch view update",
          syncMissing: "Sync Missing Views",
          syncMissingConfirm: "This will fetch today's views only for submissions that don't have them yet. Continue?",
          syncMissingQueued: "View sync dispatched for {{count}} submissions",
          syncMissingNone: "All submissions already have today's views",
          syncMissingError: "Failed to dispatch missing view sync",
          countLabel: "submissions",
          filtersLabel: "Approval",
          searchPlaceholder: "Search URL or user…",
          reasonLabel: "Reason",
          reasonPlaceholder: "Explain why…",
          adminObservationLabel: "Admin observation",
          disapproveConfirm: "Provide a reason before disapproving this submission.",
          disqualifyConfirm: "Provide a reason before disqualifying this submission.",
          approvalSet: "Approval updated",
          approvalError: "Failed to update approval",
          reviewGroup: {
            link: "Link posts",
            selected: "{{count}} selected",
            selectColumn: "Select for linking",
            selectLabel: "Select {{url}} for linking",
            dialogTitle: "Link posts across platforms",
            approvalPrecedence: "Confirm only posts with the same content and owner. If one is already approved, approval will prevail for the whole group.",
            confirm: "Confirm link",
            success: "{{count}} posts linked",
            error: "Could not link the posts",
            badge: "Linked content",
            singleReviewError: "This submission belongs to linked content. Review the whole group to change its decision.",
            validation: {
              minimum: "Select at least two posts.",
              sameUser: "The posts must belong to the same user.",
              crossPlatform: "Select posts from at least two platforms.",
              alreadyGrouped: "One of the posts already belongs to a group.",
            },
          },
          disqualifySet: "Submission disqualified",
          disqualifyError: "Failed to disqualify submission",
          summary: {
            totalViews: "Total Views",
            totalSubmissions: "Total Submissions",
            avgViews: "Avg Views per Submission",
            totalEarnings: "Total Earnings",
            paidViews: "Paid views",
            paidViewsHint: "{{share}} of {{approved}} approved views",
            afterWindowViews: "Views after the {{hours}}h window",
            afterWindowViewsUnlimited: "Views after the window (unlimited)",
            afterWindowViewsHint: "Approved, but outside the paid window",
            effectiveCpm: "Effective CPM",
            effectiveCpmHint: "Nominal {{nominal}} · {{efficiency}} of nominal",
            effectiveCpmNominalPerPlatform: "Nominal per network:",
            paidCpm: "CPM on paid views",
            paidCpmHint: "Below nominal = per-clip cap or budget",
          },
          topEarning: {
            title: "Top earning clips",
            rank: "Rank",
            count: "{{count}} clips",
            downloadClip: "Download",
            downloading: "Downloading…",
            downloadFailed: "Download failed",
            downloadUnsupported: "This URL cannot be downloaded",
            expand: "Show top earning clips",
            pageOf: "Page {{page}} of {{pageCount}}",
            previousPage: "Previous page",
            nextPage: "Next page",
            loadFailed: "Could not load this ranking page. Please try again.",
            exportSpreadsheet: "Download full ranking",
            exporting: "Preparing spreadsheet…",
            exportProgress: "Preparing {{loaded}} of {{total}} clips…",
            exportErrorTitle: "Could not download spreadsheet",
            exportFailed: "Could not collect the complete ranking. The data may have changed during collection. Please try again.",
            currency: "Currency",
          },
          chart: {
            title: "Views & submissions over time",
            totalViews: "Total Views",
            newSubmissions: "New Submissions",
            approvedPaidViews: "Approved (paid)",
            approvedUnpaidViews: "Approved (after window)",
          },
          table: {
            platform: "Platform",
            url: "URL",
            submitter: "Submitter",
            views: "Total Views",
            cpm: "CPM",
            earned: "Earned",
            hashtags: "Hashtags",
            submittedAt: "Submitted",
            actions: "Actions",
          },
          hashtagValidated: "Hashtags validated",
          hashtagNeutral: "Hashtags pending",
          hashtagInvalidated: "Hashtags invalid",
          hashtagValidationSet: "Hashtag validation updated",
          hashtagValidationError: "Failed to update hashtag validation",
          prompts: {
            reviewReason: "Reason (optional)",
            disqualifyReason: "Disqualification reason (required)",
          },
          userDisqualifiedBadge: "User banned",
          banUserConfirm: "Disqualify this user from the campaign? Their pending submissions will be marked disqualified.",
          unbanUserConfirm: "Lift the ban for this user? Already-cascaded submissions will remain disqualified.",
          banUserSuccess: "User disqualified from campaign",
          banUserReclaimed: "Reclaimed {{amount}} back to the campaign budget",
          unbanUserSuccess: "User reinstated",
          banUserError: "Failed to disqualify user",
          unbanUserError: "Failed to reinstate user",
          observation: {
            title: "Admin observation",
            label: "Observation",
            placeholder: "Internal note about this approved clip…",
            save: "Save",
            remove: "Remove",
            saved: "Observation saved",
            cleared: "Observation removed",
            error: "Failed to save observation",
          },
          cpmOverride: {
            title: "Change this video's CPM",
            boundsHint: "Between {{min}} and {{max}}",
            save: "Save",
            resetToBase: "Use campaign default ({{value}})",
            saved: "CPM updated — earnings recomputed",
            error: "Failed to update CPM",
          },
        },
        participants: {
          title: "Participants",
          countLabel: "participants",
          searchPlaceholder: "Search by name or email...",
          filtersLabel: "Filters",
          filters: {
            all: "All",
            disqualified: "Disqualified only",
          },
          table: {
            user: "User",
            submissions: "Submissions",
            approved: "Approved",
            totalViews: "Total views",
            earnings: "Earnings",
            firstSubmitted: "First submitted",
            status: "Status",
            actions: "Actions",
          },
          statusActive: "Active",
          statusDisqualified: "Disqualified",
          actions: {
            disqualify: "Disqualify user",
            undisqualify: "Reinstate",
          },
          banReasonLabel: "Reason",
          banReasonPlaceholder: "Why is this user being disqualified?",
          banSuccess: "User disqualified from campaign",
          banReclaimed: "Reclaimed {{amount}} back to the campaign budget",
          unbanSuccess: "User reinstated",
          banError: "Failed to disqualify user",
          unbanError: "Failed to reinstate user",
          emptyTitle: "No participants yet",
          emptyDescription: "Submissions to this campaign will appear here.",
        },
      },
      templateSuggestions: {
        title: 'Template suggestions',
        searchPlaceholder: 'Search by name, link or user...',
        filterAll: 'All statuses',
        columns: {
          suggestion: 'Suggestion',
          author: 'Author',
          votes: 'Votes',
          status: 'Status',
          createdAt: 'Submitted',
          actions: 'Actions',
        },
        approve: 'Approve',
        reject: 'Reject',
        promote: 'Mark as produced',
        reopen: 'Reopen',
        rejectTitle: 'Reject suggestion',
        rejectDescription: 'The record is kept; state the reason for rejection.',
        reasonLabel: 'Reason',
        promoteTitle: 'Mark as produced',
        promoteDescription: 'Optional: the id of the template (brand kit) built from this suggestion.',
        brandKitLabel: 'Template id',
        confirm: 'Confirm',
        cancel: 'Cancel',
        empty: 'No suggestions found.',
        loadError: 'Could not load the suggestions. This does not mean the queue is empty.',
        retry: 'Try again',
        saved: 'Suggestion updated.',
        error: 'Could not update the suggestion.',
      },
      communityCuration: {
        title: 'Community curation',
        subtitle: 'Every day at 09:00 (Brasília time), Clippinho adds each niche\'s trending videos to the community library.',
        loadError: 'Could not load the curation setup. That does not mean there are no niches.',
        retry: 'Try again',
        enabled: 'Daily curation on',
        enabledHint: 'While off, the daily run and "Run now" create nothing. Simulate and adding a single video still work.',
        curator: 'Curator',
        curatorMissing: 'Curator account not configured. Run cli/create-community-curator.js on the backend.',
        addedToday: '{{count}}/{{cap}} added today',
        globalDailyCap: 'Global daily cap',
        youtubeQuotaBudget: 'YouTube API budget per run (units)',
        estimatePerRun: 'Estimate per run: ~{{estimated}} units',
        budgetDraftBelow: 'Below the estimate ({{estimated}}): runs would be held.',
        budgetWarningTitle: 'Runs are held',
        budgetWarning: 'The YouTube API budget ({{budget}} units) is below the estimate for the active niches ({{estimated}}). No run happens, the daily one included, until you raise the budget or remove keywords.',
        save: 'Save',
        saved: 'Settings saved.',
        runNow: 'Run now',
        simulate: 'Simulate',
        addVideo: 'Add video',
        running: 'Running…',
        runStarted: 'Run started.',
        simulationStarted: 'Simulation started.',
        runFinished: 'Run finished: {{added}} added, {{skipped}} skipped, {{failed}} failed.',
        simulationFinished: 'Simulation finished: {{added}} would be added.',
        runFailed: 'The run failed. See Runs for details.',
        tabs: {
          niches: 'Niches',
          runs: 'Runs',
        },
        niches: {
          new: 'New niche',
          empty: 'No niches yet. Create one to get started.',
          columns: {
            name: 'Niche',
            region: 'Region',
            sources: 'Keywords and channels',
            dailyLimit: 'Per day',
            enabled: 'On',
            actions: 'Actions',
          },
          channelsCount_one: '+ {{count}} seed channel',
          channelsCount_other: '+ {{count}} seed channels',
          edit: 'Edit niche',
          delete: 'Delete',
          deleteTitle: 'Delete niche',
          deleteDescription: 'The niche "{{name}}" will no longer be used. Videos it already picked stay in the history and in the community.',
          saved: 'Niche saved.',
          deleted: 'Niche deleted.',
        },
        regions: {
          BR: 'Brazil (Portuguese)',
          US: 'US (English)',
        },
        form: {
          createTitle: 'New niche',
          editTitle: 'Edit niche',
          description: 'Each keyword becomes a YouTube search; seed channels always contribute their recent uploads.',
          name: 'Name',
          region: 'Region and curation language',
          keywords: 'Keywords',
          keywordsHint: 'One per line (up to 10). Each costs 100 YouTube API units per run.',
          seedChannels: 'Seed channels',
          seedChannelsHint: 'One per line (up to 10): @handle, channel link or UC… id',
          needsSource: 'Add at least one keyword or seed channel.',
          minDuration: 'Minimum length (min)',
          maxDuration: 'Maximum length (min)',
          lookbackHours: 'Published in the last (hours)',
          dailyLimit: 'Videos per day',
          enabled: 'Niche on',
          submit: 'Save',
          cancel: 'Cancel',
        },
        runs: {
          columns: {
            startedAt: 'Started',
            trigger: 'Source',
            status: 'Status',
            result: 'Result',
            units: 'Units',
          },
          empty: 'No runs yet.',
          loadError: 'Could not load the runs.',
          view: 'View',
          dryRun: 'Simulation',
          result: '{{added}} added · {{skipped}} skipped · {{failed}} failed',
          resultDryRun: '{{added}} would be added · {{skipped}} skipped',
          heldBudget: 'Held: budget {{budget}} < estimated {{estimated}} units',
        },
        triggers: {
          cron: 'Daily',
          admin: 'Admin page',
          mcp: 'Claude (MCP)',
          manual: 'Manual',
        },
        statuses: {
          running: 'Running',
          success: 'Finished',
          failed: 'Failed',
          held: 'Held',
        },
        pickStatuses: {
          added: 'Added',
          skipped: 'Skipped',
          failed: 'Failed',
          dry_run: 'Would be added',
        },
        reasons: {
          already_in_community: 'Already has a library on the platform',
          already_picked: 'Picked before',
          duplicate_in_run: 'Picked by another niche',
          niche_limit: 'Niche daily limit',
          global_cap: 'Global daily cap',
          out_of_duration: 'Outside the length range',
          live_or_upcoming: 'Live or scheduled',
          music_category: 'Music category',
          wrong_language: 'Different language from the niche',
          create_error: 'Could not create the library',
          quota_error: 'Curator quota limit',
          unknown: 'Other reason',
        },
        runDialog: {
          title: 'Run from {{date}}',
          units: '{{count}} API units',
          loadError: 'Could not load this run.',
          niches: 'Niches',
          nicheSummary: '{{searches}} searches · {{candidates}} candidates · {{added}} added',
          noteQuotaBudget: 'API budget spent: the following niches were not searched.',
          noteYoutubeQuota: 'YouTube daily quota exceeded.',
          showing: '{{shown}} of {{total}} videos',
          filterAll: 'All',
          columns: {
            video: 'Video',
            niche: 'Niche',
            views: 'Views',
            velocity: 'Views/hour',
            status: 'Status',
          },
          velocity: '{{value}}/h',
          empty: 'No videos in this run.',
          libraryStatus: 'Library: {{status}}',
        },
        addVideoDialog: {
          title: 'Add video',
          description: 'Adds one YouTube video to the community as Clippinho, outside the daily limits. Videos that already have a library are skipped.',
          url: 'YouTube link',
          niche: 'Niche (optional)',
          noNiche: 'No niche',
          region: 'Curation language',
          submit: 'Add',
          added: 'Video added. It shows up in the community once processing finishes.',
          skipped: 'Video skipped: {{reason}}.',
          failed: 'Could not add the video. See Runs for details.',
        },
        errors: {
          title: 'Could not finish',
          ok: 'Ok',
          alreadyRunning: 'A run is already in progress. Wait for it to finish.',
          disabled: 'Daily curation is off. Turn it on or use Simulate.',
          curatorMissing: 'The curator account is not configured.',
          notFound: 'Not found. Reload the page.',
          invalid: 'Invalid data.',
          invalidField: 'Invalid value in: {{field}}.',
          generic: 'Something went wrong. Please try again.',
          budgetBelowEstimate: 'Run held: the YouTube API budget ({{budget}} units) is below the estimate for the active niches ({{estimated}}). Raise the budget or remove keywords.',
        },
        fields: {
          name: 'Name',
          enabled: 'On',
          region: 'Region',
          keywords: 'Keywords',
          seed_channels: 'Seed channels',
          min_duration_minutes: 'Minimum length',
          max_duration_minutes: 'Maximum length',
          lookback_hours: 'Published in the last (hours)',
          daily_limit: 'Videos per day',
          global_daily_cap: 'Global daily cap',
          youtube_quota_budget: 'YouTube API budget',
        },
      },
    },

    // Contact Support
    contact: {
      support: "Contact Support",
      title: "Contact Support",
      chooseMethod: "Choose how you'd like to contact us",
      describeIssue: "Describe your issue and we'll help you",
      whatsapp: "WhatsApp",
      whatsappDescription: "Chat with us instantly",
      email: "Email",
      emailDescription: "Send us a message",
      placeholder: "What's happening? Describe your issue here...",
      sendWhatsApp: "Send to WhatsApp",
      sendEmail: "Send Email",
    },

    // Invoice page
    invoice: {
      title: "PIX Invoice",
      subtitle: "Complete your PIX payment to activate your subscription",
      loadingUserData: "Loading user data...",
      generatePixCode: "Generate PIX code",
      noPendingPayment: "No Pending Payment",
      noPendingPaymentDescription: "No pending PIX payment was found on your account.",
      loadingPaymentData: "Loading payment data...",
      paymentLoadError: "Error Loading Payment",
      tryAgain: "Try Again",
      paymentStatus: "Payment Status",
      amount: "Amount",
      createdAt: "Created at",
      expiresAt: "Expires at",
      qrCodeTitle: "PIX QR Code",
      qrCodeAlt: "PIX QR Code",
      qrCodeInstructions: "Scan the QR Code with your bank app or copy the PIX code below",
      pixCodeTitle: "PIX Code",
      copyPixCode: "Copy PIX Code",
      pixCodeCopyHint: "Paste this code in your bank app under \"PIX Copy and Paste\"",
      howToPay: "How to Pay",
      howToPayStep1: "Open your bank app",
      howToPayStep2: "Go to the PIX option",
      howToPayStep3: "Choose \"Scan QR Code\" or \"PIX Copy and Paste\"",
      howToPayStep4: "Scan the QR Code or paste the PIX code",
      howToPayStep5: "Confirm the payment",
      howToPayNote: "The payment will be processed automatically after confirmation. Your subscription will be activated in a few minutes.",
      paymentConfirmed: "Payment Confirmed!",
      paymentConfirmedDescription: "Your PIX payment was processed successfully. Your subscription has been activated and you can now enjoy all features.",
      goToProjects: "Go to Projects",
      autoCheckingStatus: "Automatically checking payment status...",
      autoCheckPaused: "Automatic verification paused. Click to check manually.",
      checkStatus: "Check Status",
      copied: "Copied!",
      pixCodeCopied: "PIX code copied to clipboard",
      pixCodeCopyError: "Could not copy PIX code",
      pixPaymentError: "Error loading PIX payment data",
      timeLimitReached: "Time Limit Reached",
      timeLimitDescription: "We stopped checking automatically. You can refresh manually.",
      paymentConfirmedToastTitle: "Payment Confirmed!",
      paymentConfirmedToastDescription: "Your PIX payment was processed successfully. Your subscription has been activated.",
      statusWaitingPayment: "Waiting for Payment",
      statusPaid: "Paid",
      statusExpired: "Expired",
      statusCanceled: "Canceled",
    },

    // Pro-only route
    proOnlyRoute: {
      title: "PRO Feature Required",
      locked: "This feature is available only for PRO users",
      description: "API features (keys, requests, and documentation) are part of our PRO plan. Upgrade to access advanced integration features.",
      upgradeButton: "Upgrade to PRO",
      backToProjects: "Back to Projects",
    },

    couponLanding: {
      title: "Your AutoClipper coupon",
      description: "Choose where to continue with your coupon.",
      openApp: "Open in app",
      continueWebsite: "Continue on website",
    },

    // Auth messages (toasts)
    auth: {
      loginSuccess: "Login successful",
      welcomeBack: "Welcome back!",
      loginFailed: "Login failed",
      loggedOut: "Logged out",
      loggedOutDescription: "You have been successfully disconnected.",
      backendUnavailable: {
        title: "We're having trouble reaching Autoclipper",
        description: "Your account is still signed in. Check your connection or try again in a moment.",
      },
      connectionLost: {
        title: "Can't reach Autoclipper",
        description: "Your changes are still on screen. Trying to reconnect…",
      },
      profileUpdated: "Profile updated",
      profileUpdatedDescription: "Your profile has been updated successfully.",
      profileUpdateFailed: "Update failed",
      profileUpdateError: "Failed to update profile",
      passwordChanged: "Password changed",
      passwordChangedDescription: "Your password has been changed successfully.",
      passwordChangeError: "Error changing password",
      authError: "Authentication error",
      processingLogin: "Processing login",
      processingAuthWait: "Please wait while we process your authentication...",
      authProviderFailed: "Authentication with {{provider}} failed",
      authTokenNotFound: "Authentication token not found",
      authProcessingError: "Error processing authentication",
      backToLogin: "Back to login",
      loginWithGoogle: "Sign in with Google",
    },

    // Login/Register modal
    loginRegisterModal: {
      title: "Log in or create your account",
      loginTab: "Log in",
      registerTab: "Create Account",
      emailLabel: "Email",
      emailPlaceholder: "Enter your email",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter your password",
      forgotPassword: "Forgot your password?",
      loggingIn: "Logging in...",
      loginButton: "Log in",
      nameLabel: "Name",
      namePlaceholder: "Enter your name",
      roleLabel: "Role",
      rolePlaceholder: "Choose your role",
      phoneLabel: "Phone",
      confirmPasswordLabel: "Confirm Password",
      confirmPasswordPlaceholder: "Enter your password again",
      creatingAccount: "Creating account...",
      createAccountButton: "Create Account",
      invalidCredentials: "Invalid email or password",
      passwordMismatch: "Passwords do not match.",
      registrationError: "Registration error. Please try again.",
      emailTaken: "Email already registered.",
      invalidEmail: "Invalid email.",
    },

    // Clip status texts
    clipStatus: {
      queuedProcessing: "Waiting for processing...",
      exportingVideo: "Exporting video...",
      videoReady: "Video ready",
      processingError: "Processing Error",
      expired: "Expired",
      waitingSceneDetection: "Waiting for scene detection...",
      detectingScenes: "Detecting scenes...",
      readyForEditing: "Video ready for editing",
      waitingGeneration: "Waiting for generation...",
      generatingFinalVideo: "Generating final video...",
      loading: "Loading...",
      preparingVideo: "Preparing video...",
      cuttingVideo: "Cutting video...",
      generatingVideo: "Generating video...",
    },

    // Coupon errors
    couponErrors: {
      notFound: "Coupon not found",
      expired: "Coupon expired",
      noUsesRemaining: "Coupon has no uses remaining",
      invalidForPlan: "Coupon is not valid for this plan",
      invalidForRecurrency: "Coupon is not valid for this recurrency",
    },

    renewalCoupon: {
      toggle: "Have a coupon?",
      placeholder: "Coupon code",
      apply: "Apply",
      applying: "Applying…",
      appliedTitle: "Coupon {{code}} applied",
      appliedPercent_one: "{{discount}}% off your next renewal",
      appliedPercent_other: "{{discount}}% off for {{count}} renewals",
      appliedFlat_one: "{{amount}} off your next renewal",
      appliedFlat_other: "{{amount}} off for {{count}} renewals",
      appliedPercentUnlimited: "{{discount}}% off every renewal",
      appliedFlatUnlimited: "{{amount}} off every renewal",
      planPrice: "Plan price",
      couponDiscount: "Coupon {{code}}",
      couponDiscountNoCode: "Coupon discount",
      cyclesLeft_one: "{{count}} discounted renewal",
      cyclesLeft_other: "{{count}} discounted renewals",
      cyclesUnlimited: "on every renewal",
      unsupportedTitle: "Coupon not available for your plan",
      unsupportedDescription: "Renewal coupons work for plans you renew manually with PIX or wallet balance.",
      errors: {
        not_eligible: "Your plan can't use renewal coupons.",
        renewal_payment_pending: "You have a renewal payment in progress. Cancel it to use a coupon.",
        coupon_not_found: "Coupon not found.",
        coupon_expired: "This coupon has expired.",
        coupon_exhausted: "This coupon has no uses left.",
        coupon_invalid_for_plan: "This coupon isn't valid for your plan.",
        coupon_invalid_for_recurrency: "This coupon isn't valid for your billing cycle.",
        coupon_not_assigned: "This coupon belongs to another account.",
        coupon_already_used: "You've already used this coupon.",
        coupon_not_better: "Your current discount is already better than this coupon.",
        coupon_invalid: "This coupon can't be applied.",
        generic: "We couldn't apply the coupon. Try again.",
      },
    },

    // Phone input
    phoneInput: {
      label: "Phone",
      other: "Other",
      selectCountry: "Select a country...",
      searchCountry: "Search country...",
      noCountryFound: "No country found.",
    },

    // Clip editor
    clipEditor: {
      backgroundMusic: "Background Music",
      copy: " (copy)",
      undoAction: "Undo last action",
      redoAction: "Redo last action",
    },

    // Tutorial card
    tutorialCard: {
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      clickToWatch: "Click to watch on YouTube",
    },

    // Timeline
    timeline: {
      sourceDuration: "Video duration: {{time}}",
      clipSequence: "Clip",
      fullVideo: "Full video",
      clipSequenceHint: "Rearrange scenes",
      fullVideoHint: "Select and extend footage from the full video",

      focusPreview: "Current scene framing",
      playhead: "Playhead",
      trimStart: "Trim scene {{number}} start",
      trimEnd: "Trim scene {{number}} end",
      frameTrimHint: "Left/Right: adjust by one frame (30 fps)",
      moveSceneToStart: "Move scene to start",
      moveSceneToEnd: "Move scene to end",
      reorderScene: "Scene {{number}}. Alt + Left or Right to reorder.",
      duration: "Clip duration: {{time}}",
      sceneNumber: "Scene #{{number}}",
      seekDetectedScene: "Seek to detected scene at {{time}}",
      addIntervalAfterCurrent: "Add interval after current",
      addIntervalAtCurrentTime: "Add interval at current time",
      undo: "Undo",
      redo: "Redo",
      split: "Split at {{time}}",
      splitScene: "Split scene at playhead",
      splitSceneHere: "Split the scene at {{time}}",
      addCopyHere: "Add a copy of this part (5s)",
      playheadInsideScene: "The playhead is inside a scene.",
      zoomLabel: "Timeline Zoom",
    },

    // Clip titles
    clipTitlesHook: {
      generationFailed: "Failed to generate titles",
      generationRequestError: "Error requesting title generation",
    },

    // Upload modal extras
    uploadModalExtra: {
      whatYouLookFor: "What you're looking for in the video",
      describeWhatYouLookFor: "Describe what you're looking for in the video",
      customPromptPlaceholder: "For example: 'Extract funny moments', 'Find parts about digital marketing', 'Create clips with practical tips'...",
      customPromptHint: "Be specific about what you want to extract from the video for better results.",
      videoExtentLabel: "How much of the video to process",
      selectExtension: "Select the extent",
      fullVideo: "Full video",
      videoSegment: "Video Segment",
    },

    // News PDF upload modal
    newsPdfUpload: {
      defaultPrompt: "Create viral clips from the provided video and PDF.",
    },

    // Header
    headerExtra: {
      defaultUser: "User",
    },

    // Plans
    plansExtra: {
      whatsappMessage: "Hello! I'd like to learn more about AutoClipper plans and get a custom plan.",
    },

    // Project status
    projectStatus: {
      preQueued: "Downloading video",
      queued: "Waiting for Processing...",
      processing: "Processing...",
      transcribing: "Transcribing...",
      segmenting: "Segmenting...",
      trimming: "Trimming...",
      curating: "Curating...",
      success: "Ready!",
      failure: "Error",
      expired: "Expired",
    },

    // Delete project hook
    deleteProject: {
      success: "Project removed",
      successDescription: "The project was removed successfully.",
      error: "Error removing project",
      errorDescription: "An error occurred while trying to remove the project. Please try again.",
    },

    // Auto editor
    autoEditor: {
      editClip: "Edit Clip: {{name}}",
      startingGeneration: "Starting generation...",
      generateClip: "Generate Clip",
      loadingClip: "Loading clip...",
      renderSuccess: "Your clip is being rendered",
      renderError: "An error occurred while rendering the clip",
    },

    // Target objectives
    targetObjectives: {
      ownContent: "Create clips from my own content",
      ownContentExample: "(e.g., podcasts, lives, YouTube videos, etc.)",
      serviceProvider: "Provide clip editing services for other people or companies",
      serviceProviderExample: "(e.g., work as a freelancer or agency)",
      revenueGeneration: "Generate new revenue streams through digital content creation",
      revenueGenerationExample: "(e.g., social media monetization, product sales, partnerships, etc.)",
      other: "Other",
    },

    // Font selector
    fontSelector: {
      loadingFonts: "Loading fonts...",
      loadingFont: "Loading font...",
      selectFont: "Select Font",
      chooseFontPlaceholder: "Choose a font...",
      noFamily: "No Family",
      errorLoadingFonts: "Error loading fonts",
      noFontsAvailable: "No fonts available",
      noFontsFound: "No fonts found",
      tryDifferentSearch: "Try a different search term",
      noResultsFound: "No results found",
      fontsFound_one: "{{count}} font found",
      fontsFound_other: "{{count}} fonts found",
      fontPreview: "Font Preview",
      blackText: "Black text",
      whiteText: "White text",
      fontFile: "Font file",
      downloadFont: "Download font",
    },

    // Contact support
    contactSupport: {
      emailSubject: "Autoclipper Support",
    },

    // Account settings
    accountSettings: {
      cancelWhatsappMessage: "Hello, I would like to cancel my Autoclipper plan.",
      emailMarketingOptIn: "Receive product updates and tips by email",
    },

    // Upload modal extras (batch 3)
    uploadModalExtra2: {
      createBrandKit: "Create Template",
      createBrandKitTitle: "Create your first Template",
      createBrandKitDescription: "Customize your videos with your brand's colors, logos, and fonts. Templates ensure visual consistency across all your clips.",
      loadingUsageData: "Loading usage data...",
      processingTime: "Processing Time",
      clipsCreated: "Clips Created",
      upgradeToPro: "Upgrade to PRO",
      videoWillConsume: "This video will consume: {{duration}}",
      processingSelectedSegment: "(Processing only the selected segment: {{duration}})",
      insufficientTime: "Insufficient time: this project requires {{required}} and you have {{available}} available this month.",
      considerUpgrading: "Consider upgrading your plan for more processing time.",
      upgradePlan: "Upgrade Plan",
      createProjectError: "Error creating project: {{error}}",
      creating: "Creating...",
      waitingUpload: "Waiting for upload...",
      createProject: "Create Project",
      timeInputHint: "Enter only numbers (e.g.: 123456 = 12:34:56)",
      captureTimeHint: "Use the buttons to capture the current video time, or enter only numbers in HH:mm:ss format",
    },

    // News PDF upload modal extras
    newsPdfUploadExtra: {
      defaultProjectName: "New Project",
    },

    // Timeline extras
    timelineExtra: {
      removeInterval: "Remove interval",
    },

    // Crop center editor
    cropCenter: {
      sceneTime: "Scene time",
      previousFrame: "Previous frame",
      nextFrame: "Next frame",
      frameNumber: "Frame {{number}} / {{total}}",

      editPosition: "Adjust framing at {{time}}",
      thisSceneOnly: "This scene only",
      segment: "Segment",
      delete: "Remove this section (uses the neighboring framing in the scene)",
      applyToAllScenes: "Copy to every scene",
      applyToAllScenesConfirm: "This replaces the framing and zoom of every scene in the clip with this one.",
      applyToAllScenesAction: "Apply to all",
      addAtPlayhead: "Split here",
      dragHint: "Drag the frame to reposition the crop",
    },

    // Reframe modal
    reframeModal: {
      trigger: "Reframe",
      title: "Reframe video",
      keyframes: "Keyframes",
      addAtPlayhead: "Split at playhead",
      empty: "No crop data for this clip yet.",
      outsideScene: "Move the playhead onto a scene of the clip to adjust its framing.",
      selectHint: "Select a keyframe to edit.",
      zoomTrigger: "Zoom on focused subject",
      zoomLabel: "Zoom",
      zoomSceneOnly: "Zoom for this scene",
      zoomEmpty: "Move the playhead onto a scene of the clip.",
    },

    // Earn page
    campaignCategories: {
      label: "Categories",
      business: "Business & entrepreneurship",
      marketing: "Marketing & sales",
      finance: "Finance",
      personal_development: "Personal development",
      health: "Health & wellness",
      news: "News & politics",
      sports: "Sports",
      entertainment: "Entertainment",
      technology: "Technology",
      education: "Education",
      products: "Products & brands",
      podcast: "Podcasts & interviews",
    },
    // Compact cards: the full name abbreviated to fit three chips in a row.
    campaignCategoriesShort: {
      business: "Business",
      marketing: "Marketing",
      finance: "Finance",
      personal_development: "Personal dev.",
      health: "Health",
      news: "News",
      sports: "Sports",
      entertainment: "Entertainment",
      technology: "Technology",
      education: "Education",
      products: "Products",
      podcast: "Podcasts",
    },
    earnPage: {
      activeBadge: "{{count}} campaigns paying now",
      heroTitle: "Earn money with",
      heroTitleHighlight: "clips",
      heroSubtitle: "Choose a campaign, generate AI clips and publish on TikTok, Instagram or Shorts with the required tags. Submit the video link and get paid per view.",
      howItWorksTitle: "How It Works",
      howItWorksSubtitle: "5 simple steps to start earning",
      step1Title: "Choose a video",
      step1Desc: "Browse eligible videos for the campaign",
      step2Title: "Create a clip",
      step2Desc: "Generate a viral clip with AutoClipper AI",
      step3Title: "Post on social media",
      step3Desc: "Publish on TikTok, Instagram or YouTube with the required tags",
      step4Title: "Submit the link",
      step4Desc: "On the campaign page, paste the published post link in the \"Submit clip\" field",
      step5Title: "Earn by views",
      step5Desc: "Get paid for every 1,000 verified views",
      campaignsTitle: "Campaigns paying now",
      otherCampaignsTitle: "Other campaigns paying now",
      showLeaderboard: "Show the active-campaigns ranking",
      hideLeaderboard: "Hide the active-campaigns ranking",
      myCampaignsTitle: "My campaigns",
      myCampaignsSubtitle_one: "You are in {{count}} campaign. Send your clips and track what they earn.",
      myCampaignsSubtitle_other: "You are in {{count}} campaigns. Send your clips and track what they earn.",
      minViewsPerClip: "At least {{views}} views per clip to earn",
      noMinViewsPerClip: "No minimum views: every view counts",
      campaignsSubtitle: "Choose a channel, create clips and earn per view.",
      payUpTo: "Earn up to",
      perThousandViews: "/ 1,000 views",
      remainingBudget: "Remaining budget",
      budgetExhausted: "Budget exhausted",
      earnWithCampaign: "Earn with this campaign",
      noCampaigns: "No active campaigns at the moment. Check back soon!",
      inviteOnly: {
        ctaLabel: "Exclusive to Subscribers",
        popoverTitle: "Exclusive Campaign",
        popoverText: "This campaign is exclusive to paid plan subscribers. Subscribe to any paid plan to join.",
        tickerLabel: "Exclusive campaign for subscribers",
      },
      proExclusive: {
        badge: "SUBSCRIBER",
        tooltip: "You have access to this exclusive campaign because you're a paid plan subscriber.",
      },
      selectedOnly: {
        badge: "SELECTED",
        exclusiveBadge: "PICKED",
        exclusiveTooltip: "You have access to this campaign because you were picked to join.",
        ctaLabel: "Invite-only",
        popoverTitle: "Selected Campaign",
        popoverText: "This campaign is restricted to selected clippers. It can't be joined via subscription or invite.",
        tickerLabel: "Campaign for selected clippers only",
      },
      proLocked: {
        partnerName: "Exclusive Partner",
        ctaLabel: "Unlock PRO Access",
        popoverTitle: "Available on PRO Plan",
        popoverText: "Unlock exclusive campaigns and earn more per view with our partners.",
        upgradeButton: "Upgrade now",
      },
      joinedBadge: "Joined",
      freeLimit: {
        cta: "Upgrade to join more campaigns",
        note: "Free plan: you can participate in 1 campaign at a time.",
      },
      partnersTitle: "Earn with Partners",
      partnersSubtitle: "Partner brand campaigns — exclusive access for PRO subscribers.",
      endedCampaignsTitle: "Ended Campaigns",
      endedCampaignsSubtitle: "See how much has already been paid to clippers in past campaigns.",
      endedSummary: {
        description: "See how much has already been paid to clippers in past campaigns. Earnings are released to the wallet after the views audit and can be withdrawn via PIX.",
        totalPaid: "Total paid to clippers",
        walletNote: "Campaign earnings released to wallets",
        totalDistributed: "Total distributed",
        closedCycles_one: "{{count}} completed cycle",
        closedCycles_other: "{{count}} completed cycles",
        average: "Average / campaign",
        perCycle: "Per content cycle",
        largest: "Largest distribution",
        myEarnings: "My Earnings",
        myEarningsNote: "Lifetime earnings on the platform",
        earningsUnavailable: "Unable to load your earnings",
      },
      endedBadge: "Ended",
      paidLabel: "paid",
      scheduledCampaignsTitle: "Coming Soon",
      scheduledCampaignsSubtitle: "Campaigns already confirmed, not yet open for participation.",
      scheduledBadge: "Coming soon",
      scheduledBudgetLabel: "Total budget",
      scheduledStartsAt: "Starts on {{date}}",
      scheduledStartsSoon: "Date to be announced",
      vitrine: {
        title: "Partnership Showcase",
        subtitle: "Partners selected by AutoClipper to boost your journey as a clipper.",
        officialPartner: "official partner",
        badgeExternal: "PRO",
        badgeAcervo: "PRO",
        ctaExternal: "Check opportunities",
        ctaAcervo: "Check opportunities",
      },
      earnPerView: "Earn per view",
      cpmTooltip: "CPM = amount paid per 1,000 valid views",
      paymentBar: {
        approval72h: "Clip approval within",
        approval72hBold: "72h",
        views72h: "Views counted for up to",
        views72hBold: "72h after submitting the link to the campaign",
        payment48h: "Payment within",
        payment48hBold: "48h after audit",
        minWithdrawal: "Minimum withdrawal:",
        minWithdrawalValue: "R$ 20",
        viewDetails: "See details",
      },
      faq: {
        title: "Payment FAQ",
        q1: "How does approval and view counting work?",
        a1: "After submitting the clip link, it goes through an approval audit within 72h. Eligible views are counted during the first 72h after the link is submitted to the campaign. Only real, unique views from valid accounts are considered.",
        q2: "When do I receive payment?",
        a2: "After the views audit, the amount is added to your wallet on the platform. To receive it, you need to manually request a withdrawal via the \"Request withdrawal\" button — available once your balance reaches the minimum of R$ 20. Payment is then processed within 48h.",
        q3: "What is the minimum withdrawal amount?",
        a3: "The minimum amount to request a withdrawal is R$ 20. Amounts below this limit accumulate for the next payment.",
        q4: "Can I participate in multiple campaigns at the same time?",
        a4: "Yes! You can join as many active campaigns as you like. Each submitted clip is evaluated individually by the corresponding campaign.",
        q5: "What happens if a clip is rejected?",
        a5: "If the clip does not follow the campaign rules (required tags, minimum quality), it may be rejected and not generate payment. Always check the instructions before publishing.",
      },
    },

    cpmLeaderboard: {
      title: "Ranking the clippers",
      tickerSubtitle: "Most views on active campaigns",
      views: "{{views}} views",
      videos: "{{count}} videos",
      remainAnonymous: "Remain anonymous",
      remainAnonymousHint: "Hide your name and photo from the ranking. Your views still count.",
      anonymousName: "Clipper",
      anonymousAria: "Anonymous clipper, {{views}} views",
      upgradeTitle: "Remain anonymous on the ranking",
      upgradeBody: "Hiding your name and photo from the Clip & Pix ranking is available on paid plans.",
      upgradeCta: "Upgrade",
      upgradeDismiss: "Not now",
      privacySaved: "Ranking privacy updated",
      privacyError: "Could not update ranking privacy",
      rank: "#{{rank}}",
      you: "You",
      yourPosition: "You are #{{rank}} of {{total}}",
      unranked: "You are not on the ranking.",
      unrankedRank: "??",
      gap: "…",
      ranksLink: "View ranks",
      rankingLink: "View ranking",
    },

    ranks: {
      title: "Rankings",
      yours: "Your ranks",
      hall: "Hall of fame",
      fullRankingLink: "View full ranking",
      link: "View ranks",
      emptyTrack: "No progress on this track yet",
      tracks: {
        views: "Viralizer",
        campaign_money: "Bounty Hunter",
        affiliate: "Relentless Seller",
        campaigns: "Content Mercenary",
        renders: "Clip Machine",
        season: "Season Legend",
      },
      metrics: {
        views: "Views",
        campaign_money: "Money",
        affiliate: "Money",
        campaigns: "Number of campaigns",
        renders: "Number of clips",
        season: "Season views",
      },
      units: {
        views: "views",
        campaigns: "campaigns",
        clips: "clips",
      },
      requirements: {
        views: "Reached {{metric}}",
        money: "Earned {{metric}}",
        campaigns: "Joined {{metric}}",
        clips: "Exported {{metric}}",
        affiliateBronze: "Made the first referred sale",
        seasonExact: "Finished #{{placement}} in a season ranking",
        seasonExactNamed: "Finished #{{placement}} in {{season}}",
        seasonRange: "Finished #{{from}}–#{{to}} in a season ranking",
        seasonRangeNamed: "Finished #{{from}}–#{{to}} in {{season}}",
      },
      tierTooltip: "{{name}}: {{requirement}}",
      lifetime: "Lifetime ranking",
      tabs: {
        season: "Season",
        lifetime: "Lifetime",
      },
      tiers: {
        views: {
          bronze: "Reach Bronze",
          silver: "Reach Silver",
          gold: "Reach Gold",
          platinum: "Viral Platinum",
          master: "Viral Master",
          legend: "Viral Legend",
        },
        campaign_money: {
          bronze: "Bronze",
          silver: "Silver",
          gold: "Gold",
          black: "Black Card",
        },
        affiliate: {
          bronze: "Affiliate Bronze",
          silver: "Affiliate Silver",
          gold: "Affiliate Gold",
          six_digits: "Six-Figure Club",
        },
        campaigns: {
          bronze: "Beginner",
          silver: "Specialist",
          gold: "Niche Dominator",
        },
        renders: {
          bronze: "Operator",
          silver: "Hardcore Editor",
          gold: "Content Factory",
          diamond: "Human Processor",
        },
        season: {
          emperor: "Season Emperor",
          elite: "Season Elite",
          master: "Season Master",
          veteran: "Season Veteran",
        },
      },
      ladder: {
        show: "View levels",
        hide: "Hide levels",
        title: "{{track}} levels",
        stripLabel: "Levels in this rank",
        current: "Current",
        earned: "Earned",
        locked: "Locked",
        affiliateBronze: "First referred sale",
      },
      progress: "{{metric}} / {{next}}",
      rankStartsAt: "This rank starts at {{next}}",
      rankEndsAt: "This rank ends at {{next}}",
      placement: "#{{placement}}",
      seasonActive: "Season in progress. Titles are awarded when it ends.",
      seasonActiveUntil: "In progress until {{date}}",
      seasonEndedOn: "Ended {{date}}",
      seasonActiveRange: "Starts {{start}} · Ends {{end}}",
      seasonEndedRange: "Started {{start}} · Ended {{end}}",
      loadError: "Couldn't load ranks. Please try again.",
      loadMore: "Load more",
    },

    // Monthly earnings chart — /earn/wallet
    walletMonthlyEarnings: {
      title: "Monthly earnings",
      range: { label: "Chart period", last6: "Last 6 months", last12: "Last 12 months" },
      periodTotal: "Total in this period: {{amount}}",
      bestMonth: "Best month: {{month}} ({{amount}})",
      total: "Total",
      current: "in progress",
      sources: {
        clips: "Clip & Pix",
        affiliate: "Referral commissions",
        producer: "Course royalties",
      },
      tableCaption: "Earnings by month",
      footnote: "Clips count in the month they were sent; commissions and royalties, in the month of the sale. The current month (striped bar) is still in progress.",
      empty: "No earnings in this period yet. Send clips to Clip & Pix campaigns to see your progress here.",
    },

    // Wallet statement — /earn/wallet, /affiliates, /course-royalties
    walletStatement: {
      title: "Statement",
      walletTitle: "Wallet statement",
      withdrawHistoryLink: "See statement",
      period: { label: "Statement period", last30: "Last 30 days" },
      upcoming: {
        title: "Upcoming releases",
        hint: "Amounts on hold that join your balance at the date and time shown.",
      },
      today: "Today",
      dayClosing: "End-of-day balance",
      currentBalance: "Current balance",
      openingBalance: "Balance before this period",
      noSnapshot: "Balance not recorded",
      snapshotsStarted: "The end-of-day balance is recorded since {{date}}. Earlier days show movements only.",
      snapshotsPending: "The end-of-day balance starts being recorded at midnight. Until then, the statement shows movements only.",
      empty: "No movements in this period.",
      error: "Couldn't load the statement.",
      retry: "Try again",
      withdrawable: { label: "Available to withdraw", link: "See wallet statement" },
      lines: {
        cpmDaily: "Clip & Pix earnings for the day",
        cpmToday: "Clip & Pix earnings today (so far)",
        cpmSince: "Clip & Pix earnings since {{date}}",
        cpmAdjustment: "Clip & Pix earnings adjustment",
        commissionRelease: {
          payment: "Commission released · Plan",
          course: "Commission released · Course",
          cpm: "Commission released · Clip & Pix",
        },
        royaltyRelease: "Royalty released",
        commissionReversal: "Commission reversed",
        royaltyReversal: "Royalty reversed",
        fromReferred: "Referral: {{name}}",
        course: "{{course}}",
        payout: {
          pix_withdrawal: "PIX withdrawal",
          plan_redemption: "Plan paid with balance",
          minutes_redemption: "Minutes paid with balance",
        },
        payoutCancellation: "Amount returned (payment cancelled)",
        adjustment: "Adjustments",
        adjustmentHint: "Balance corrections that have no entry of their own.",
        unknown: "Movement",
      },
      reversalReason: {
        recalculated: "Recalculated after a change in the referral's earnings",
        forfeited: "Forfeited when the program was suspended",
        refunded: "Payment refunded",
        chargeback: "Payment disputed",
        other: "Manual reversal",
      },
      payoutStatus: {
        pending: "Under review",
        paid: "Paid",
        paidOn: "Paid on {{date}}",
        cancelled: "Cancelled",
      },
    },

    // Affiliates page
    affiliates: {
      title: 'Refer & Earn',
      subtitle: 'Earn {{payment}}% of everything your referrals pay, {{course}}% of the Viralize em 4 Semanas course, plus {{cpm}}% of their Clip & Pix earnings',
      join: {
        heading: 'Join the affiliate program',
        bullet1: 'You earn {{payment}}% of every payment made by users who sign up through your link',
        bulletCourse: 'Special commission: {{course}}% on every Viralize em 4 Semanas course sale made through your link',
        bulletCpm: 'Plus {{cpm}}% of everything your referrals earn from Clip & Pix campaigns',
        bullet2: 'Forever — valid for all of your referral’s payments, with no time limit',
        bullet3: 'Earnings land in your wallet and can be withdrawn via PIX',
        termsTitle: 'Program terms',
        termsBody:
          'By joining you agree that: (1) the commission is {{payment}}% of all confirmed payments from users who registered through your link, with no time limit; (2) you also earn {{cpm}}% of your referrals’ Clip & Pix earnings; (3) Viralize em 4 Semanas course sales pay a {{course}}% commission and are attributed to the link used at purchase; (4) each commission becomes withdrawable 30 days after it is recorded, as chargeback protection; (5) commissions from refunded payments or disqualified Clip & Pix earnings are reversed; (6) self-referral, spam, and bidding on the Autoclipper brand in paid ads are prohibited and may lead to removal from the program; (7) the program may change or end with prior notice.',
        accept: 'I have read and accept the terms',
        button: 'Join the program',
        joining: 'Joining...',
      },
      link: {
        title: 'Your referral links',
        copy: 'Copy',
        copied: 'Link copied!',
        appLabel: 'Autoclipper link',
        appPerPayment: '{{payment}}% of subscriptions',
        appPerCpm: '{{cpm}}% of Clip & Pix',
        hint: 'Share this link. Anyone who signs up through it becomes your referral.',
        viralizeLabel: 'Viralize em 4 Semanas course link',
        viralizePerSale: '{{course}}% per sale',
        viralizeHint:
          'Goes straight to the course sales page, where checkout needs no account. Every purchase made through this link pays you a {{course}}% commission.',
        customize: 'Customize link',
        customHint: '3–30 characters: lowercase letters, digits and hyphens (no leading/trailing hyphen).',
        customWarning: 'Changing your custom code frees the previous one — it stops working. Your original link keeps working.',
        customSave: 'Save',
        customCancel: 'Cancel',
        customSaving: 'Saving...',
        customSaved: 'Custom link saved!',
        customTaken: 'This code is already taken. Pick another one.',
        customInvalid: 'Invalid code. Use 3–30 characters: lowercase letters, digits and hyphens (no leading/trailing hyphen).',
        alsoWorks: 'Your original link also keeps working:',
      },
      materials: {
        title: 'Promo materials',
        description:
          'Ready-to-post Viralize em 4 Semanas videos for your social accounts. Download them, publish, and put your course link in the caption or bio.',
        download: 'Download videos',
      },
      stats: {
        referred: 'Referrals',
        earned: 'Total earned',
        pending: 'On hold (30 days)',
        available: 'Released (all time)',
        breakdown: 'Plans {{payment}} · Course {{course}} · Clip & Pix {{cpm}}',
      },
      earnings: {
        title: 'Your commissions',
        empty: 'No commissions yet. Share your link to start earning.',
        date: 'Date',
        referredUser: 'Referral',
        source: 'Source',
        sourcePayment: 'Plan',
        sourceCourse: 'Course',
        sourceCpm: 'Clip & Pix',
        paymentAmount: 'Payment',
        commission: 'Commission',
        releasesAt: 'Release',
        status: 'Status',
        statusPending: 'On hold',
        statusAvailable: 'Released',
        statusReversed: 'Reversed',
        showMore: 'Show more',
      },
      referred: {
        title: 'Your referrals',
        empty: 'Nobody has signed up through your link yet.',
        name: 'Referral',
        signedUp: 'Signed up',
        status: 'Status',
        earned: 'You earned',
        paid: 'Paying',
        pendingPayment: 'Awaiting payment',
        showingRecent: 'Showing your 100 most recent referrals',
        detailsTitle: '{{name}}’s payments',
        detailsEmpty: 'No commission-generating payments yet.',
      },
      wallet: {
        hint: 'Your earnings add up in your wallet, together with campaign earnings.',
        goToWallet: 'Go to wallet',
        affiliateBreakdown: 'Affiliates: {{amount}}',
      },
      blocked: {
        title: 'Your affiliate program participation is suspended',
        body:
          'You can no longer refer new users or earn new commissions. Commissions already released remain available to withdraw.',
        reason: 'Reason: {{reason}}',
      },
      error: 'Something went wrong. Please try again.',
      loadError: 'Could not load your affiliate data. Please reload the page.',
    },

    // Tutorials page
    tutorialsPage: {
      tutorial1: "Get to Know AutoClipper in 3 Minutes (Complete Beginner's Guide)",
      tutorial2: "Transform 1 Video into MULTIPLE Viral Clips with AI (Very Fast)",
      tutorial3: "How to Create Video Clips from Your Computer (Step by Step)",
      tutorial4: "How to Export Your Finished Cuts for TikTok, Reels, and Shorts",
      tutorial5: "Discover AutoClipper's Co-pilot Mode (Create Professional AI Cuts)",
      tutorial6: "Paste a YouTube Link and Generate Automatic Clips with AI",
      tutorial7: "The AutoClipper Library: Use Ready-Made Videos to Create Clips",
      tutorial8: "My Brand vs. Other Channels: Which One to Use in AutoClipper?",
    },
    course: {
      badge: "Course",
      freeLessonBadge: "1 free lesson",
      freeLabel: "Free",
      lockedMessage: "Content available for subscribers",
      subscribePrompt: "Exclusive content for subscribers",
      subscribeBody: "Subscribe to a plan to unlock 100% of the course.",
      subscribeButton: "View subscription plans",
      ctaButton: "Start now — free",
      pilotUnlocked: "Pilot lesson unlocked",
      weeksLabel: "4 weeks",
      modulesCount: "{{count}} modules",
      duration: "~3h of content",
      completed: "Completed",
      progressLabel: "{{percent}}% completed",
      notFound: "Course not found",
      back: "Back",
      courseCompleted: "Course completed",
      previousLesson: "Previous lesson",
      nextLesson: "Next lesson",
      continueLesson: "Continue lesson",
      startNow: "Start now",
      completedCount: "{{done}} / {{total}} completed",
      videoPlayer: {
        label: "Lesson player: {{title}}",
        play: "Play video",
        pause: "Pause video",
        seek: "Video position",
        mute: "Mute",
        unmute: "Unmute",
        volume: "Volume",
        playbackRate: "Playback speed",
        fullscreen: "Full screen",
        subtitlesOn: "Turn subtitles on",
        subtitlesOff: "Turn subtitles off",
        errorTitle: "This lesson could not be loaded",
        errorBody: "Check your connection and try loading the video again.",
        retry: "Try again",
      },
      lessonResources: {
        title: "Lesson resources",
        subtitle: "Summary, chapters, and transcript",
        overviewTab: "About this lesson",
        transcriptTab: "Transcript",
        chapters: "Chapters",
        loading: "Loading transcript…",
        error: "The transcript could not be loaded. Please try again.",
      },
    },
    coursePurchase: {
      buyCta: "Buy the course for {{price}}",
      lockedBanner: "Buy the course to unlock every lesson — includes 1 month of the STARTER plan.",
      confirmedTitle: "Purchase confirmed!",
      confirmedBody: "The course has been unlocked and your STARTER plan bonus is active.",
      title: "Complete your purchase",
      subtitle: "Go Viral in 4 Weeks — lifetime access + 1 month of the STARTER plan",
      includedTitle: "What's included",
      includedCourse: "Lifetime access to every lesson in the course",
      includedPlan: "1 month of the STARTER plan included",
      payWithPix: "Pay with PIX",
      payWithCard: "Pay with card",
      alreadyOwned: "You already own this course.",
      purchaseError: "Could not start the purchase. Please try again.",
      couponInvalid: "Invalid coupon",
      couponExpired: "This coupon has expired.",
      couponExhausted: "This coupon has no uses remaining.",
      couponNotValid: "This coupon is not valid for this course.",
      backToCourse: "Back to course",
    },
    challengeBanner: {
      text: "Autoclipper Challenge: compete for over R$10,000 creating clips with AI",
      cta: "Join now",
    },
    challenge: {
      title: "Challenge",
      titleSuffix: ": Earn Money with Social Media",
      subtitle: "Submit your videos and track your participation in the championship",
      warningPrefix: "🚨 Hey clipper,",
      noActiveChallenge: "No active championship",
      checkBackLater: "Check back soon for the next challenge!",
      rules: {
        allowed: "ALLOWED",
        forbidden: "NOT ALLOWED",
        attention: "ATTENTION",
        warning: "WARNING",
      },
      requiredHashtags: "Required hashtags",
      hashtagsDescription: "Copy and use these hashtags in your video descriptions",
      copyHashtags: "Copy hashtags",
      hashtagsCopied: "Hashtags copied!",
      validateHashtags: "Validate hashtags",
      hashtagsValid: "Hashtags found",
      hashtagsMissing: "Missing: {{tags}}",
      hashtagsInvalid: "Hashtags not found in description",
      hashtagsValidationError: "Could not validate — try again or submit anyway",
      hashtagsValidating: "Validating hashtags...",
      checkingViews: "Checking views...",
      instagramMustBeReel: "Instagram link must be a Reel (instagram.com/reel/...)",
      urlAlreadySubmitted: "This video has already been submitted",
      urlDuplicate: "This URL appears more than once in the list",
      captionExamples: "Caption examples",
      watermarkRequired: "Watermark required",
      downloadWatermark: "Download watermark",
      freeDescription: "Free description allowed",
      hashtagsRequired: "Hashtags required",
      quickWarning: "QUICK WARNING",
      prizePool: "Championship Prizes",
      prizePoolSubtitle: "See how much you can win by participating",
      joinTitle: "Join the Championship!",
      joinDescription: "Enter the challenge and compete for prizes by creating amazing clips",
      joinButton: "Join now",
      joined: "You joined the championship!",
      notAcceptingParticipants: "Registration closed",
      submissionsClosed: "Submissions closed",
      joinConsentTitle: "Challenge Rules",
      joinConsentCheckbox: "I have read and agree to all the rules",
      joinConsentButton: "Confirm and join",
      submitConsentTitle: "Confirm the Rules before submitting",
      submitConsentCheckbox: "I confirm that I have read and agree to all the challenge rules",
      submitConsentButton: "I agree, submit video",
      myVideos: "My Videos",
      submitVideo: "Submit video",
      submitVideoTitle: "Submit video for counting",
      submitVideoSubtitle: "Make sure the video follows all the rules before submitting",
      video: "Video",
      invalidUrl: "Unrecognized URL. Supported: TikTok, Instagram, YouTube",
      addAnotherVideo: "Add another video",
      duplicateWarning: "The same video can only be submitted once per platform",
      watermarkWarning: "Videos must contain watermark and required hashtags",
      confirmTitle: "I confirm that:",
      confirmItem1: "I have read and accept the rules",
      confirmItem2: "The video follows the guidelines",
      confirmItem3: "Contains watermark and hashtags",
      submitting: "Submitting...",
      submitButton: "Submit video",
      videosSubmitted: "Videos submitted successfully!",
      submissionFailed: "Submission failed. Check the errors highlighted above.",
      noVideosYet: "No videos submitted yet. Submit your first video!",
      ranking: "Ranking",
      views: "views",
      clip: "video",
      clips: "videos",
      anonymous: "Anonymous",
      participationDisqualified: "Your participation has been disqualified",
      participationDisqualifiedReason: "Reason: {{reason}}",
      clipSubmittedAt: "Submitted on {{date}}",
      clipDisqualified: "Rejected",
      clipDisqualifiedReason: "Reason: {{reason}}",
      clipPendingValidation: "Pending Validation",
      clipApproved: "Approved",
      clipHashtagsValidated: "Hashtags Validated",
      clipHashtagsInvalidated: "Hashtags Invalid",
      clipHashtagsPending: "Hashtags Pending",
      viewsUpdatedDaily: "Views are updated daily.",
      prizePoolRanking: "Partial Ranking",
      prizePoolRankingLive: "Live",
      prizePoolRankingNotStarted: "This ranking period has not started yet.",
      rankings: {
        consolidated: "Consolidated",
        countdown: "Consolidates in {{time}}",
        startsIn: "Starts in {{time}}",
        consolidating: "Consolidating...",
        timeRemaining: "Time remaining",
        pendingDescription: "The ranking has not been consolidated yet. Wait for the deadline to see the results.",
      },
    },

    // API Getting Started
    apiGettingStarted: {
      title: "Getting Started with Autoclipper API",
      subtitle: "Learn how to integrate video clipping into your applications",
      prerequisites: "Prerequisites",
      prerequisitesDescription: "Before you start, make sure you have the following:",
      apiKey: "API Key",
      apiKeyDescription: "You'll need an active API key from your Autoclipper dashboard",
      getApiKey: "Get API Key",
      videoContent: "Video Content",
      videoContentDescription: "A public video URL (YouTube, Vimeo, or direct link)",
      httpClient: "HTTP Client",
      httpClientDescription: "Any tool that can make HTTP requests (curl, Postman, etc.)",
      formatAuto: "Auto",
      formatAutoDescription: "AI determines optimal clip length based on content",
      formatMax1Min: "Max 1 Minute",
      formatMax1MinDescription: "Clips will be up to 60 seconds long",
      formatMax30Sec: "Max 30 Seconds",
      formatMax30SecDescription: "Clips will be 15 to 30 seconds long",
      authentication: "Authentication",
      authDescription: "All API requests require authentication using your API key",
      authInstructions: "Include your API key in the Authorization header with every request:",
      authorization: "Authorization",
      authHeader: "Authorization Header",
      securityWarning: "Keep your API key secure and never expose it in client-side code. Store it as an environment variable.",
      createFirstProject: "Create Your First Project",
      createFirstProjectDescription: "Submit a video for processing by creating a new project",
      createProjectInstructions: "Send a POST request to create a new project. Here are the required and optional parameters:",
      requestParameters: "Request Parameters:",
      required: "Required",
      optional: "Optional",
      paramBaseVideoUrl: "URL of the video to process",
      paramName: "Human-readable name for your project",
      paramFormat: "Output format for clips (see options below)",
      paramLanguage: 'Language code: "pt-BR", "en-US", or "es-ES"',
      paramWebhookUrl: "URL to receive completion notifications",
      paramPrompt: "Additional guidance for clip generation",
      paramBrandKitId: "Template ID for subtitle styles, logo, and colors. Falls back to account default, then public 'Basic' template.",
      formatOptions: "Format Options:",
      exampleRequest: "Example Request",
      exampleResponse: "Example Response",
      monitorProgress: "Monitor Processing Progress",
      monitorProgressDescription: "Check the status of your project and retrieve clips when ready",
      monitorInstructions: "Video processing typically takes a few minutes. You can check the status by retrieving the project:",
      checkStatus: "Check Project Status",
      statusValues: "Processing Status Values:",
      statusProcessing: "Video is being analyzed and clips are being generated",
      statusCompleted: "Processing finished successfully, clips are ready",
      statusFailed: "Processing failed due to an error",
      responseWhenCompleted: "Response When Completed",
      proTip: "Pro tip: Use webhooks to get notified automatically when processing completes instead of polling for status updates.",
      understandingWebhooks: "Understanding Webhooks",
      webhookDescription: "Receive automatic notifications when your projects are completed",
      webhookInstructions: "When you provide a webhook_url in your project creation request, Autoclipper will send a POST request to that URL when processing finishes — both on success and failure.",
      webhookDetailsTitle: "Webhook Details:",
      method: "Method",
      methodDescription: "POST request to your webhook URL",
      contentType: "Content-Type",
      success: "Success",
      successDescription: 'Sent when all clips finish rendering — process_status: "completed" with clips array',
      failure: "Failure",
      failureDescription: 'Sent when processing fails — process_status: "failed" with empty clips array',
      retries: "Retries",
      retriesDescription: "Up to 3 attempts if your server does not return a 2xx response",
      successPayloadExample: "Success Payload Example",
      webhookImportant: "Important: Your webhook endpoint must respond with a 2xx status code to acknowledge receipt. If it doesn't, Autoclipper will retry up to 3 times. After 3 failed attempts, no further retries will be made. You can always poll GET /api/v1/project/{id} to check the status.",
      whatsNext: "What's Next?",
      whatsNextDescription: "Explore more advanced features and integrations",
      tryPlayground: "Try the Playground",
      tryPlaygroundDescription: "Test endpoints interactively",
      exploreReference: "Explore API Reference",
      exploreReferenceDescription: "Detailed documentation for all endpoints",
      monitorUsage: "Monitor API Usage",
      monitorUsageDescription: "Track your API requests and usage",
    },

    // API Reference
    apiReference: {
      title: "API Reference",
      subtitle: "Complete documentation for all Autoclipper API endpoints",
      baseUrlAuth: "Base URL & Authentication",
      baseUrl: "Base URL",
      authentication: "Authentication",
      authDescription: "All requests require an API key in the Authorization header:",
      getApiKey: "Get API Key",
      openApiSpec: "OpenAPI Spec",
      tabs: {
        overview: "Overview",
        parameters: "Parameters",
        examples: "Examples",
      },
      summary: "Summary",
      responseCodes: "Response Codes",
      requestBodyTitle: "Request Body",
      queryParameters: "Query Parameters",
      curlRequest: "cURL Request",
      responseBody: "Response Body",
      parameter: "Parameter",
      type: "Type",
      required: "Required",
      description: "Description",
      yes: "Yes",
      no: "No",
      webhooks: "Webhooks",
      webhooksDescription: "Automatic notifications sent when project processing completes or fails",
      howWebhooksWork: "How Webhooks Work",
      webhookExplanation: "When you provide a webhook_url during project creation, Autoclipper will send a POST request to that URL when processing finishes. The webhook is triggered in two scenarios:",
      success: "Success",
      failure: "Failure",
      webhookSuccessItem: "all clips have been rendered. The payload includes process_status: \"completed\" and the full clips array with download URLs.",
      webhookFailureItem: "video processing or clip curation failed. The payload includes process_status: \"failed\" and an empty clips array.",
      webhookDetails: "Webhook Details",
      method: "Method",
      contentType: "Content-Type",
      trigger: "Trigger",
      triggerDescription: "When all clips finish rendering (success) or when processing fails",
      expectedResponse: "Expected Response",
      expectedResponseDescription: "2xx status code to acknowledge receipt",
      retries: "Retries",
      retriesDescription: "Up to 3 attempts if your server does not return a 2xx response",
      successPayload: "Success Payload",
      successPayloadDescription: "Sent when all clips have been successfully rendered. The clips array contains each clip with its rendered_video_url (final video with subtitles and effects):",
      failurePayload: "Failure Payload",
      failurePayloadDescription: "Sent when video processing or clip curation fails. The process_status will be \"failed\" and the clips array will be empty:",
      retryBehavior: "Retry Behavior",
      retryBehaviorDescription: "If your webhook endpoint does not return a 2xx status code, Autoclipper will retry the delivery up to 3 times. After 3 failed attempts, the notification is marked as delivered and no further retries will be made. You can always check the project status by polling the GET /api/v1/project/{id} endpoint.",
      dataModels: "Data Models",
      dataModelsDescription: "Schema definitions for request and response objects",
      property: "Property",
      endpoints: {
        createProject: {
          summary: "Create a new project",
          description: "Creates a new video project for processing. The project will start processing the provided video URL and generate clips based on the specified parameters.",
          response200: "Project created successfully",
          response400: "Invalid request parameters or template not found",
          response401: "Authentication failed",
        },
        listProjects: {
          summary: "List projects",
          description: "Retrieves a paginated list of all projects for the authenticated user.",
          response200: "List of projects retrieved successfully",
          response401: "Authentication failed",
        },
        getProject: {
          summary: "Get project by ID",
          description: "Retrieves detailed information about a specific project, including all generated clips if the project is completed.",
          response200: "Project details retrieved successfully",
          response401: "Authentication failed",
          response404: "Project not found",
        },
        listCommunityLibraries: {
          summary: "List community libraries",
          description: "Browse the community library — videos already downloaded and curated within Autoclipper that you can remix. Supports text search, channel/tag filtering, and several sort orders.",
          response200: "List of community libraries",
          response401: "Authentication failed",
        },
        getCommunityLibrary: {
          summary: "Get a community library",
          description: "Fetch a single community library by id. The returned video_url is the canonical source URL — pass it as base_video_url to POST /v1/project, or call the /remix shortcut.",
          response200: "Community library details",
          response401: "Authentication failed",
          response404: "Community library not found",
        },
        listCommunityChannels: {
          summary: "List community channels",
          description: "Discover channels whose videos are available in the community library. Returns the id values used by channel_id on list community libraries.",
          response200: "List of community channels",
          response401: "Authentication failed",
        },
        listCommunityTags: {
          summary: "List community tags",
          description: "Discover tags applied to community library videos. Returns the id values used by tag_id on list community libraries. Tags appearing on fewer than 5 downloads are hidden.",
          response200: "List of community tags",
          response401: "Authentication failed",
        },
        remixCommunityLibrary: {
          summary: "Remix a community library",
          description: "Create a new project from a community library. Resolves the source URL and runs the same flow as POST /v1/project. All fields are optional — omitted ones inherit from the source library. Defaults auto_export to false.",
          response200: "Project created from community library",
          response401: "Authentication failed",
          response404: "Community library not found",
          response422: "Community library has no resolvable source URL",
        },
        createProjectClip: {
          summary: "Create a clip from a project",
          description: "Manually create a clip on an existing project by specifying start_time and end_time (in seconds, relative to the source video). Project must have curation_status: success. When auto_render is true (default) the clip is queued for rendering immediately.",
          response201: "Clip created",
          response400: "Invalid times or brand_kit_id not found",
          response401: "Authentication failed",
          response402: "Monthly clip quota exceeded",
          response404: "Project not found",
          response409: "Project curation not finished yet",
        },
        renderClip: {
          summary: "Render an existing clip",
          description: "Queue rendering for a clip that was curated but not rendered (e.g. when the project was created with auto_export: false). Idempotent — returns the existing URL if the clip is already rendered.",
          response200: "Clip is rendered, rendering, or queued",
          response400: "brand_kit_id not found",
          response401: "Authentication failed",
          response402: "Monthly clip quota exceeded",
          response404: "Clip not found",
        },
        getCommunityChannel: {
          summary: "Get a community channel",
          description: "Fetch a single community channel by id. Returns 404 if the channel has no eligible community videos.",
          response200: "Community channel details",
          response401: "Authentication failed",
          response404: "Community channel not found",
        },
        listCommunityChannelLibraries: {
          summary: "List a channel's community videos",
          description: "Browse videos from a single channel. Same filters and sort options as list community libraries, with channel_id fixed to the path id.",
          response200: "List of channel videos",
          response401: "Authentication failed",
          response404: "Community channel not found",
        },
        checkCommunityLibrary: {
          summary: "Check if a URL is in the community library",
          description: "Given a video URL (YouTube, Vimeo, etc.), returns the matching community library record if Autoclipper already has it curated. Useful to decide whether to remix an existing library or submit a fresh project.",
          response200: "Matching community library",
          response400: "Missing url query parameter",
          response401: "Authentication failed",
          response404: "No community library matches that URL",
        },
      },
    },

    // Scene transitions (per-cut badge + picker popover in the timeline)
    transitions: {
      title: 'Transition',
      duration: 'Duration (s)',
      direction: 'Direction',
      remove: 'Remove',
      applyAll: 'Apply to all',
      addToAllScenes: 'Add to all scenes',
      randomize: 'Randomize',
      randomizeHint: 'Pick the presets to draw from and roll one per cut.',
      auto: 'Auto',
      autoHint: "Reads the video's audio and motion signals and places transitions at the real scene cuts and energy peaks.",
      autoUnavailable: 'Not available for this project — it was processed before automatic video analysis.',
      autoLoading: 'Reading video signals…',
      autoError: 'Video signals are unavailable for this project.',
      autoNoSuggestions: 'No transitions suggested for this content.',
      autoContentType: 'Detected: {{type}}',
      contentTypes: {
        soccer: 'Football',
        gameplay: 'Gameplay',
        vlog: 'Vlog',
        podcast: 'Podcast',
        unknown: 'Undetermined',
      },
      kinds: {
        'camera-move': 'Camera move',
        'zoom-in': 'Zoom in',
        'zoom-out': 'Zoom out',
        'whip-pan': 'Whip pan',
        'dip-to-black': 'Dip to black',
        'dip-to-white': 'Flash to white',
        blur: 'Blur',
        crossfade: 'Crossfade',
        slide: 'Slide',
        wipe: 'Wipe',
      },
    },

    // Clip publishing (TikTok drafts and direct YouTube publishing)
    publishQueues: {
      eyebrow: 'Publishing automation',
      title: 'Publishing queues',
      subtitle: 'Set a recurring schedule once, then send clips into an organized publishing flow.',
      create: 'New queue',
      edit: 'Edit',
      delete: 'Delete queue',
      active: 'Active',
      inactive: 'Inactive',
      schedule: 'Weekly schedule',
      card: {
        calendarHint: 'Click or tap a day to see its exact times.',
        dayDetails: 'View times for {{day}}',
        publishingOrder: 'Publishing order: {{position}}',
        noAccounts: 'No accounts available in this queue.',
        noSchedule: 'No times configured.',
      },
      accounts: '{{count}} account',
      accounts_other: '{{count}} accounts',
      gap: 'Minimum gap: {{minutes}} min',
      spacingBadge: 'Spaces against everything on its accounts',
      upcoming: {
        title: 'Upcoming posts',
        empty: 'No posts scheduled in this queue.',
        showAll: 'Show all ({{count}})',
        showLess: 'Show less',
        untitled: 'Untitled clip',
        otherQueue: '{{name}} queue',
        manual: 'Scheduled manually',
        loadError: 'Could not load the scheduled posts.',
      },
      loadError: 'We could not load your publishing queues.',
      retry: 'Try again',
      mode: {
        crossPost: 'Cross-post',
        roundRobin: 'Round robin',
      },
      send: {
        action: 'Send to queue',
        titleDialog: 'Send clip to a publishing queue',
        descriptionDialog: 'Review the copy, then add this clip to your recurring schedule.',
        queue: 'Publishing queue',
        queuePlaceholder: 'Select a queue',
        noQueues: 'Create an active publishing queue before sending a clip.',
        title: 'YouTube title',
        description: 'YouTube description',
        caption: 'Caption (not used for YouTube)',
        generate: 'Generate with AI',
        generating: 'Generating…',
        cancel: 'Cancel',
        submit: 'Send to queue',
        submitting: 'Sending…',
        success: 'Scheduled for {{times}}.',
      },
      errors: {
        queueNotFound: 'This publishing queue is no longer available.',
        queueNoAccounts: 'This queue has no usable social accounts.',
        invalidCopy: 'Add the required title and caption for this queue.',
        clipNotRendered: 'Render this clip before sending it to a queue.',
        clipNotFound: 'This clip is no longer available.',
        connectionReconnectRequired: 'Reconnect one of the queue accounts before continuing.',
        publishingDisabled: 'Publishing is temporarily unavailable.',
        unknown: 'We could not send this clip to the queue. Try again.',
      },
      empty: {
        title: 'Create your first publishing rhythm',
        description: 'Choose accounts and weekly time slots. Clips added to this queue will use that schedule.',
        cta: 'Create queue',
      },
      form: {
        createTitle: 'Create publishing queue',
        editTitle: 'Edit publishing queue',
        description: 'Define the accounts, order, and recurring slots used by this queue.',
        name: 'Queue name',
        namePlaceholder: 'e.g. Daily highlights',
        accounts: 'Connected accounts',
        accountsHint: 'Selection order is used by round-robin queues.',
        hiddenAccounts: {
          note: 'These accounts stay in the queue but cannot be changed here right now. Saving keeps them as they are.',
        },
        noAccounts: 'No active social accounts are connected.',
        moveAccountUp: 'Move account up',
        moveAccountDown: 'Move account down',
        mode: {
          label: 'Publishing mode',
          crossPost: 'Cross-post',
          crossPostHint: 'Publish each clip to every selected account.',
          roundRobin: 'Round robin',
          roundRobinHint: 'Alternate clips across accounts in the selected order.',
        },
        gapMinutes: 'Minimum gap (minutes)',
        gapHint: 'Videos will always be published at least this interval apart.',
        spacing: {
          label: 'Post spacing',
          queue: 'Only this queue\'s posts',
          queueHint: 'The minimum gap applies between this queue\'s posts. Other queues and one-off schedules on the same accounts are ignored.',
          account: 'Everything scheduled on the accounts',
          accountHint: 'The minimum gap also respects posts from other queues and one-off schedules on the same accounts.',
        },
        timezone: 'Timezone',
        slots: 'Weekly schedule',
        addSlot: 'Add slot',
        weekday: 'Weekday',
        startTime: 'Start time',
        endTime: 'End time',
        weekPreview: 'Weekly time windows',
        dragHint: 'Drag a block to move it or its edges to adjust the start and end in 5-minute steps. Drag empty space to add a range. Arrow keys also adjust the focused block, and Delete removes it (or use the × on the block). Esc cancels.',
        resizeStart: 'Adjust start: {{range}}',
        resizeEnd: 'Adjust end: {{range}}',
        deleteSlot: 'Delete {{range}}',
        searchTimezone: 'Search city or timezone…',
        searchWeekday: 'Search weekday…',
        searchTime: 'Search or type HH:mm…',
        noResults: 'No results found.',
        rangeHint: 'Each video is scheduled within an available window, respecting the minimum gap. Click a block to edit its times.',
        scheduleHelp: {
          title: 'How queue scheduling works',
          description: 'Windows define when videos can be scheduled, in your selected timezone.',
          selection: 'For each added video, the queue chooses a random available minute in the first window that can still accommodate it. Overlapping windows are allowed: on the same day, the window that starts earlier takes priority.',
          spacing: 'The next video must respect the minimum gap after the latest video already scheduled in this queue. This rule applies across overlapping windows too.',
          overflow: 'If the minimum gap rules out a window, the queue tries the next one. If no window that day can accommodate the video, it moves to the next day with an available time.',
          capacity: 'A window can hold several videos if there is room for the minimum gap. Overlapping windows do not create extra publications.',
          exampleTitle: 'Example with overlapping windows',
          exampleDescription: 'Windows of 09:00–11:20 and 10:55–11:55 on the same day, with a 60-minute minimum gap.',
          previous: 'Latest scheduled video',
          next: 'Possible time for the next',
          nextWindow: 'Next available window or day',
          close: 'Got it',
        },
        exactTimeHint: 'Use the same start and end for an exact time. For an overnight range, add a separate window on each day.',
        removeSlot: 'Remove slot',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving…',
      },
      validation: {
        name_required: 'Enter a queue name.',
        slots_required: 'Add at least one weekly slot.',
        accounts_required: 'Select at least one connected account.',
        invalid_slot: 'Enter valid times with the end at or after the start on the same day.',
        gap_invalid: 'Enter a whole number of minutes, at least 5.',
      },
      deleteDialog: {
        title: 'Delete publishing queue?',
        description: '“{{name}}” will be removed. Posts already scheduled from it are not deleted.',
        cancel: 'Keep queue',
        confirm: 'Delete queue',
        deleting: 'Deleting…',
      },
      toasts: {
        created: 'Publishing queue created',
        updated: 'Publishing queue updated',
        deleted: 'Publishing queue deleted',
        saveError: 'We could not save this publishing queue.',
        deleteError: 'We could not delete this publishing queue.',
      },
      calendar: {
        badge: 'Queue: {{name}}',
      },
    },
    templateIdeas: {
      eyebrow: 'Community',
      title: 'Template ideas',
      subtitle: 'Send the link to a post whose format we should turn into a template. We produce the most voted ones.',
      suggest: 'Suggest a template',
      empty: 'No approved ideas yet. Be the first to send one.',
      votes_one: '{{count}} vote',
      votes_other: '{{count}} votes',
      vote: 'Vote',
      voted: 'Voted',
      promotedTitle: 'Already templates',
      promotedBadge: 'Already a template',
      mineTitle: 'My suggestions',
      mineEmpty: "You haven't suggested a template yet.",
      loadError: 'Could not load the idea ranking.',
      mineLoadError: 'Could not load your suggestions.',
      retry: 'Try again',
      openPost: 'View original post',
      noPreview: 'No preview available',
      status: {
        pending: 'In moderation',
        public: 'Published',
        promoted: 'Became a template',
        rejected: 'Rejected',
      },
      form: {
        url: 'Post link',
        urlPlaceholder: 'https://www.tiktok.com/@handle/video/...',
        title: 'Format name',
        titlePlaceholder: 'e.g. red bar with zoom',
        useCase: 'What it is for',
        useCasePlaceholder: 'e.g. podcast cuts, football campaign...',
        note: 'Note (optional)',
        notePlaceholder: 'Anything we should know about this format',
        submit: 'Send suggestion',
        cancel: 'Cancel',
      },
      toast: {
        submitted: 'Suggestion sent! It goes through moderation before reaching the ranking.',
        voted: 'Vote recorded.',
        unvoted: 'Vote removed.',
      },
      duplicate: {
        notice: 'That post was already suggested. Vote on the existing suggestion.',
        noticePromoted: 'That post was already suggested and became a template.',
        noticePending: 'That post was already suggested and is in moderation.',
        noticeRejected: 'That post was already suggested and was rejected.',
        action: 'View and vote',
        hidden: 'That post was already suggested and is still in moderation.',
      },
      errors: {
        invalid_url: "That link doesn't look valid. Paste the full post address.",
        missing_field: 'Fill in the link, the name and what it is for.',
        not_votable: 'This suggestion is not open for votes.',
        generic: 'Could not complete. Please try again.',
      },
    },
    publishing: {
      post: 'Post',
      platforms: {
        tiktok: 'TikTok',
        instagram: 'Instagram',
        youtube: 'YouTube',
        facebook: 'Facebook',
      },
      sendToTikTok: 'Send to TikTok',
      dialogTitle: 'Send to TikTok',
      dialogDescription:
        'The clip goes to your TikTok drafts. Open TikTok to write the caption and post it.',
      accountLabel: 'TikTok account',
      captionLabel: 'Caption to copy',
      captionHelp:
        'TikTok does not let us set the caption for drafts. Copy it here and paste it in the app.',
      captionCopied: 'Caption copied',
      copyCaption: 'Copy',
      send: 'Send to drafts',
      sending: 'Sending…',
      sent: 'Sent to your TikTok drafts',
      quotaRemaining: '{{remaining}} of {{limit}} drafts left today',
      quotaExceededTitle: 'TikTok draft limit reached',
      quotaExceededBody:
        'TikTok allows 5 pending drafts per account every 24 hours. Publish some drafts in the TikTok app, then come back.',
      reconnectTitle: 'Reconnect your TikTok account',
      reconnectBody:
        'Sending clips needs a permission your account was not linked with. Reconnect it in Account Settings to enable sending.',
      reconnectAction: 'Go to Account Settings',
      noConnectionTitle: 'No TikTok account linked',
      noConnectionBody: 'Link a TikTok account in Account Settings to send clips to your drafts.',
      badge: {
        sending: 'Sending to TikTok',
        inDrafts: 'In TikTok drafts',
        published: 'Published to TikTok',
        failed: 'Send failed',
        youtube: {
          publishing: 'Publishing to YouTube',
          published: 'Published to YouTube',
          failed: 'YouTube publishing failed',
        },
        instagram: {
          publishing: 'Publishing to Instagram',
          published: 'Published to Instagram',
          failed: 'Instagram publishing failed',
        },
        facebook: {
          publishing: 'Publishing to Facebook',
          published: 'Published to Facebook',
          failed: 'Facebook publishing failed',
        },
      },
      pro: {
        title: 'Social publishing is a PRO feature',
        body: 'Upgrade to publish clips directly to your connected social accounts.',
        dismiss: 'Not now',
        upgrade: 'See plans',
      },
      youtube: {
        dialogTitle: 'Publish to YouTube',
        dialogDescription: 'Review the video details and choose how it will appear on YouTube.',
        loadingAccounts: 'Loading YouTube channels…',
        accountLoadError: 'We could not load your connected accounts. Try again.',
        retryAccounts: 'Try again',
        retryingAccounts: 'Trying again…',
        accountLabel: 'YouTube account',
        accountSettingsAction: 'Go to Account Settings',
        noConnectionBody: 'Link a YouTube account in Account Settings before publishing this clip.',
        reconnectBody:
          'Reconnect your YouTube account in Account Settings to grant video upload permission.',
        titleLabel: 'Title',
        titleHelp: 'Required. YouTube titles can contain up to 100 characters.',
        titleRequired: 'Enter a title to publish this video.',
        descriptionLabel: 'Description',
        descriptionHelp: 'Optional. Add context, links, or credits for your viewers.',
        characterCount: '{{current}} / {{max}}',
        visibilityLabel: 'Visibility',
        visibility: {
          public: 'Public',
          unlisted: 'Unlisted',
          private: 'Private',
        },
        audienceLabel: 'Audience',
        audience: {
          notMadeForKids: 'Not made for kids',
          madeForKids: 'Made for kids',
        },
        visibilityCaveat:
          'Google may force uploads to Private while the connected API project is unaudited. The final visibility shown here will reflect YouTube\'s result.',
        cancel: 'Cancel',
        publish: 'Publish to YouTube',
        publishing: 'Publishing…',
        success: 'Publishing to YouTube started',
        errorTitle: 'Could not publish to YouTube',
        errorDismiss: 'Close',
      },
      tiktok: {
        dialogTitle: 'Publish to TikTok',
        dialogDescription: 'Review the clip and choose how it will appear on TikTok.',
        loadingCreator: 'Loading TikTok posting options…',
        creatorError: 'We could not load TikTok posting options. Reconnect the account and try again.',
        postingAs: 'Posting as {{name}}',
        noConnectionBody: 'Link a TikTok account in Account Settings to publish this clip.',
        reconnectBody:
          'Reconnect your TikTok account in Account Settings to grant Direct Post permission.',
        titleLabel: 'Caption',
        characterCount: '{{current}} / {{max}}',
        privacyLabel: 'Who can watch this',
        privacyPlaceholder: 'Select visibility',
        privacy: {
          everyone: 'Everyone',
          friends: 'Friends',
          followers: 'Followers',
          onlyMe: 'Only me',
        },
        interactionsLabel: 'Allow people to',
        allowComment: 'Comment',
        allowDuet: 'Duet',
        allowStitch: 'Stitch',
        commercialLabel: 'Disclose commercial content',
        yourBrand: 'Your brand',
        brandedContent: 'Branded content',
        yourBrandHint: 'Your video will be labeled as Promotional content.',
        brandedHint: 'Your video will be labeled as Paid partnership.',
        commercialRequired: 'Indicate whether this content promotes yourself, a third party, or both.',
        brandedNotPrivate: 'Branded content cannot be set to private.',
        aiGenerated: 'This video is AI-generated',
        previewLabel: 'Preview',
        watermarked:
          'This clip has the AutoClipper watermark, and TikTok does not allow apps to add their watermark to posted videos. Upgrade your plan and export the clip again to post it on TikTok.',
        watermarkUpgrade: 'See plans',
        tooLong:
          'This video is {{duration}} long, and this TikTok account can post videos up to {{max}}. Trim the clip and export it again.',
        processingNote: 'After you publish, it may take a few minutes for the video to appear on your TikTok profile.',
        declarationMusic: 'By posting, you agree to TikTok\'s',
        declarationBranded: 'By posting, you agree to TikTok\'s Branded Content Policy and',
        musicPolicy: 'Music Usage Confirmation',
        brandedPolicy: 'Branded Content Policy',
        publish: 'Publish to TikTok',
        publishing: 'Publishing…',
        cancel: 'Cancel',
        success: 'Publishing to TikTok started',
      },
      instagram: {
        dialogTitle: 'Publish to Instagram',
        dialogDescription: 'This clip will be published as a Reel on the selected Instagram account.',
        accountLabel: 'Instagram account',
        accountSettingsAction: 'Go to Account Settings',
        noConnectionBody: 'Link an Instagram Business or Creator account in Account Settings before publishing this clip.',
        reconnectBody:
          'Reconnect your Instagram account in Account Settings to grant publishing permission.',
        captionLabel: 'Caption',
        cancel: 'Cancel',
        publish: 'Publish to Instagram',
        publishing: 'Publishing…',
        success: 'Publishing to Instagram started',
      },
      facebook: {
        dialogTitle: 'Post to Facebook',
        dialogDescription:
          'This clip will be posted on the selected Facebook Page: as a Reel when it is vertical and 3 to 90 seconds long, otherwise as a video.',
        accountLabel: 'Facebook Page',
        accountSettingsAction: 'Connect a Facebook Page',
        noConnectionBody: 'Connect a Facebook Page in Account Settings before posting this clip.',
        reconnectBody:
          'None of your connected Pages can be posted on yet. Connect Facebook again in Account Settings and allow posting on a Page you manage.',
        captionLabel: 'Caption',
        cancel: 'Cancel',
        publish: 'Post to Facebook',
        publishing: 'Posting…',
        success: 'Posting to Facebook started',
      },
      when: {
        label: 'When',
        now: 'Now',
        later: 'Later',
      },
      errors: {
        quotaExceeded: 'TikTok allows only 5 pending drafts per account every 24 hours.',
        reconnectRequired: 'Reconnect this account to grant the permissions needed to publish.',
        connectionNotFound: 'This connected account could not be found. Refresh the page and try again.',
        clipNotFound: 'This clip could not be found. Refresh the page and try again.',
        clipNotRendered: 'This clip has not finished rendering yet. Wait for it to finish and try again.',
        publishingDisabled: 'Publishing is temporarily disabled. Try again later.',
        temporarilyUnavailable: 'Publishing is temporarily unavailable. We are on it.',
        videoPullFailed: 'TikTok could not download this clip. Try again.',
        fileFormatCheckFailed: 'TikTok rejected this video format.',
        rateLimitExceeded: 'Too many attempts. Wait a minute and try again.',
        invalidTitle: 'Enter a title between 1 and 100 characters.',
        descriptionTooLong: 'The description must contain no more than 5,000 characters.',
        invalidPrivacyStatus: 'Choose Public, Unlisted, or Private visibility.',
        invalidAudience: 'Choose whether this video is made for kids.',
        mediaOriginNotAllowed: 'This media cannot be published from its current storage location.',
        youtubeQuotaExceeded: 'YouTube\'s upload quota has been reached. Try again later.',
        youtubePermissionDenied: 'YouTube denied this upload. Reconnect the account and try again.',
        youtubeVideoRejected: 'YouTube rejected this video. Review the video and try again.',
        instagramQuotaExceeded: 'Instagram\'s daily publishing limit has been reached. Try again later.',
        instagramMediaRejected: 'Instagram rejected this Reel. Use a portrait clip and try again.',
        facebookQuotaExceeded: 'Facebook\'s publishing limit has been reached. Try again later.',
        facebookMediaFetchFailed: 'Facebook could not download this clip. Try again.',
        facebookMediaRejected: 'Facebook rejected this media. Review the clip and try again.',
        facebookPublishFailed: 'We could not publish to your Facebook Page. Try again.',
        facebookStatusUnknown: 'We could not confirm whether this post reached your Facebook Page. It may already be there, so check your Page before posting again.',
        captionTooLong: 'The caption must contain no more than 2,200 characters.',
        timedOut: 'The platform did not finish processing this clip. Try again.',
        providerUnavailable: 'The publishing service is temporarily unavailable. Try again later.',
        proRequired: 'Publishing is a PRO feature. Upgrade to publish.',
        tooFewImages: 'A carousel needs at least 2 images.',
        tooManyImages: 'A carousel can have at most 10 images.',
        carouselUnsupported: 'This platform does not support this kind of carousel post.',
        clipWatermarked:
          'TikTok does not accept videos with the AutoClipper watermark. Upgrade your plan and export the clip again.',
        unknown: 'Something went wrong while publishing this clip. Try again.',
        scheduledInPast: 'Choose a time at least two minutes from now.',
        notScheduled: 'This post is no longer scheduled and cannot be changed.',
      },
      calendar: {
        carousel: 'Carousel',
        title: 'Calendar',
        subtitle: 'Schedule posts and review what already went out.',
        prevMonth: 'Previous month',
        nextMonth: 'Next month',
        schedule: 'Schedule',
        pickClipTitle: 'Choose a clip',
        pickClipDescription: 'Preview a clip, then post it for {{date}}.',
        clipPreview: 'Preview {{name}}',
        loadMore: 'Load more',
        untitled: 'Untitled clip',
        loading: 'Loading…',
        error: 'We could not load your scheduled posts. Try again.',
        status: {
          scheduled: 'Scheduled',
          pending: 'Sending',
          processing: 'Sending',
          published: 'Published',
          sent_to_drafts: 'In drafts',
          failed: 'Failed',
        },
      },
      schedule: {
        createTitle: 'Schedule a post',
        editTitle: 'Edit scheduled post',
        viewTitle: 'Scheduled post',
        description: 'Pick a clip, account, and time. You can edit until it sends.',
        viewDescription: 'Details for this post.',
        save: 'Save',
        saving: 'Saving…',
        saved: 'Scheduled post saved',
        cancelSend: 'Cancel send',
        cancelling: 'Cancelling…',
        cancelled: 'Scheduled post cancelled',
        clipLabel: 'Clip',
        clipSearch: 'Search clips',
        clipEmpty: 'No postable clips found',
        platformLabel: 'Platform',
        accountLabel: 'Account',
        postLink: 'Video',
        openPost: 'Open on {{platform}}',
        datetimeLabel: 'Date and time',
        openCalendar: 'Choose date and time',
        timeLabel: 'Time',
        timePlaceholder: '15:30',
        hourLabel: 'Hour',
        minuteLabel: 'Min',
        timeEarlier: '15 minutes earlier',
        timeLater: '15 minutes later',
        alreadyScheduled: 'Already scheduled',
        moreScheduled: '+{{count}} more',
        tooSoon: 'Choose a time at least two minutes from now.',
        failReason: 'Failure reason',
        noConnectionBody: 'Link an account in Account Settings to schedule this post.',
        reconnectBody: 'Reconnect this account in Account Settings to grant publishing permission.',
        platforms: {
          tiktok: 'TikTok',
          instagram: 'Instagram',
          youtube: 'YouTube',
          facebook: 'Facebook',
        },
      },
    },
    quoteCarousel: {
      title: 'Quote carousel',
      back: 'Back',
      backToClips: 'Back to clips',
      loadError: 'Could not load this clip.',
      notFound: 'Clip not found.',
      retry: 'Try again',
      saving: 'Saving…',
      saved: 'Saved',
      generate: 'Suggest quotes with AI',
      regenerate: 'Generate again',
      generating: 'Picking the best lines from the transcript…',
      quota: '{{used}}/{{limit}} today',
      empty: 'No slides yet. Suggest quotes with AI or pick lines from the transcript.',
      noTranscript: 'This clip has no transcript yet, so quotes cannot be suggested.',
      notEnoughQuotes: 'The AI found fewer than {{min}} good quotes. Pick lines from the transcript to complete your carousel.',
      regenerateConfirm: {
        title: 'Replace current slides?',
        body: 'New suggestions will replace every slide in this carousel, including your edits.',
        cancel: 'Cancel',
        confirm: 'Replace slides',
      },
      proDialog: {
        title: 'Daily quote limit reached',
        body: 'The free plan includes 1 AI quote suggestion per day. Upgrade to PRO for up to 10 a day and watermark-free downloads.',
        dismiss: 'Not now',
        upgrade: 'See plans',
      },
      errors: {
        daily_limit_reached: 'You reached today\'s AI quote limit. Try again tomorrow.',
        transcript_unavailable: 'This clip has no transcript to pull quotes from.',
        not_found: 'Clip not found.',
        timeout: 'Generating quotes took too long. Try again.',
        generation_failed: 'Could not suggest quotes. Try again.',
      },
      slides: {
        title: 'Slides',
        slideLabel: 'Slide {{number}}',
        dragHandle: 'Drag to reorder',
        moveUp: 'Move up',
        moveDown: 'Move down',
        delete: 'Delete slide',
        minSlides: 'A carousel needs at least {{min}} slides.',
        maxSlides: 'A carousel holds up to {{max}} slides.',
        addFromTranscript: 'Add from transcript',
        charCount: '{{used}}/{{max}}',
      },
      picker: {
        title: 'Pick a line from the transcript',
        description: 'Click a word to start the quote, then click (or shift-click) another word to end it.',
        searchPlaceholder: 'Search the transcript',
        noTranscript: 'No transcript available for this clip.',
        noMatches: 'No words match your search.',
        previewLabel: 'Quote',
        previewEmpty: 'Select words to build the quote.',
        tooLong: 'Quotes can have up to {{max}} characters. Select a shorter span.',
        cancel: 'Cancel',
        add: 'Add',
      },
      preview: {
        title: 'Preview',
        empty: 'Add slides to see the preview.',
        capturing: 'Capturing video frame…',
      },
      placement: {
        dragHint: 'Drag the text to move it; drag the background to reframe it (zoom in first).',
        zoom: 'Background zoom',
        reset: 'Reset position',
      },
      textStyle: {
        title: 'Text',
        reset: 'Back to template',
        font: 'Font',
        text: 'Text',
        accent: 'Accent',
        background: 'Background',
        size: 'Size',
        align: 'Alignment',
        align_left: 'Align left',
        align_center: 'Center',
        align_right: 'Align right',
        bold: 'Bold',
        italic: 'Italic',
        outline: 'Outline',
        outlineWidth: 'Outline width',
      },
      singleImage: {
        download: 'Download image',
        downloadSlide: 'Download slide {{number}} image',
        error: 'Could not render this slide image. Please try again.',
      },
      settings: {
        title: 'Settings',
        style: 'Style',
        styleCard: 'Card',
        styleFrame: 'Video frame',
        format: 'Format',
        format4x5: '4:5 (feed)',
        format9x16: '9:16 (stories)',
        templates: 'Templates',
        noTemplate: 'No template',
        frameSource: 'Frame source',
        frameAuto: 'Automatic: the frame at the quote',
        framePicked: 'Chosen: {{time}} ({{source}})',
        pickFrame: 'Choose frame',
        handle: 'Handle',
        handlePlaceholder: '@yourhandle',
        slideBackground: 'Slide {{number}} background',
        slideBackgroundNone: 'Select a slide to change its background',
        backgroundFrame: 'Video frame',
        backgroundColor: 'Color',
      },
      frameSource: {
        original: 'Original video',
        edited: 'Edited video',
      },
      framePicker: {
        title: 'Choose frame',
        description: 'Scrub the video and pick the exact frame for this slide background.',
        editedUnavailable: 'The edited video is available once the clip has been exported.',
        originalLoadError: 'Could not load the original video.',
        originalLoading: 'Loading the original video…',
        originalUnavailable: 'The original video is not available for this clip.',
        previewAlt: 'Selected frame',
        scrubber: 'Video position',
        prevFrame: 'Previous frame',
        nextFrame: 'Next frame',
        use: 'Use this frame',
        resetAuto: 'Back to automatic',
        cancel: 'Cancel',
      },
      frameCaptureFailed: "We couldn't grab a video frame for some slides, so they use a solid color background. You can switch them back to a video frame to try again.",
      export: {
        download: 'Download ZIP',
        title: 'Generating slides',
        generating: 'Generating {{done}}/{{total}}…',
        keepTabOpen: 'Keep this tab open until all slides are ready.',
        status: {
          pending: 'Waiting',
          rendering: 'Generating…',
          done: 'Ready',
          failed: 'Failed',
        },
        retry: 'Try again',
        failedHint: 'Some slides failed. Try them again to download the ZIP.',
        downloadZip: 'Download ZIP',
        close: 'Close',
        zipError: "We couldn't create the ZIP file. Try again.",
        blocked: {
          too_few_slides: 'A carousel needs at least {{min}} slides to be downloaded.',
          empty_text: 'Every slide needs text before downloading.',
          frames_pending: 'Wait until the video frames finish loading, then try again.',
        },
      },
      publish: {
        menu: 'Post',
        title: 'Post carousel to {{platform}}',
        description_one: '{{count}} slide will be posted as an image carousel.',
        description_other: '{{count}} slides will be posted as an image carousel.',
        captionLabel: 'Caption',
        submit: 'Post now',
        schedule: 'Schedule',
        started: 'Carousel sent. It will appear on {{platform}} in a few minutes.',
        noConnection: 'Connect a {{platform}} account in Account Settings to post carousels.',
        noConnectionFacebook: 'Connect a Facebook Page in Account Settings to post carousels.',
        tiktokReconnect: 'Posting carousels to TikTok needs direct posting permission. Reconnect your TikTok account to grant it.',
        tiktokNowOnly: 'TikTok carousels are posted right away; scheduling is not available.',
        instagramFormatBlocked: 'Instagram does not accept 9:16 images in carousels. Switch this carousel to 4:5 to post it.',
        switchTo4x5: 'Switch to 4:5',
        stage: {
          rendering: 'Generating slides {{done}}/{{total}}…',
          uploading: 'Uploading images {{done}}/{{total}}…',
          publishing: 'Sending to the platform…',
        },
        errors: {
          renderFailed: "Some slides couldn't be generated. Try again.",
          uploadFailed: "We couldn't upload the slide images. Try again.",
        },
        blocked: {
          too_few_slides: 'A carousel needs at least {{min}} slides to be posted.',
          empty_text: 'Every slide needs text before posting.',
          frames_pending: 'Wait until the video frames finish loading, then try again.',
        },
        proDialog: {
          title: 'Posting is a PRO feature',
          body: 'Upgrade to PRO to post your carousels straight to your connected social accounts, without the watermark.',
        },
      },
    },

    editorWatermark: {
      handleLabel: "Watermark — drag to move",
      appearsAt: "Appears at {{seconds}}s",
      reset: "Reset position",
    },
    aiAssistant: {
      studio: {
        play: 'Play',
        pause: 'Pause',
        mute: 'Mute',
        unmute: 'Unmute',
        seek: 'Position in the clip',
        fullscreen: 'Full screen',
        clip: 'Clip',
        undo: 'Undo',
        redo: 'Redo',
        fullEditor: 'Open full editor',
        timeline: 'Timeline',
        open: 'AI Studio',
        editWithAi: 'Edit with AI',
      },
      title: 'AI assistant',
      short: 'AI',
      beta: 'Beta',
      open: 'Open AI assistant',
      close: 'Close',
      more: 'More options',
      newChat: 'New conversation',
      history: 'Recent conversations',
      noHistory: 'No conversations yet.',
      untitled: 'Untitled conversation',
      deleteConversation: 'Delete conversation',
      deleteTitle: 'Delete this conversation?',
      deleteBody: 'Its messages are removed for good. Nothing it did in your account is undone.',
      emptyTitle: 'What should we do?',
      openingConversation: 'Opening the conversation…',
      suggestionsLoading: 'Thinking of ideas for this page…',
      suggestionsLoadingClip: 'Thinking of ideas for this clip…',
      emptyBody: 'Ask for clips, renders, posts, campaigns or anything about Autoclipper. Send images, videos or a link to a video you want to copy. I confirm with you before changing your account.',
      placeholder: 'Ask the assistant…',
      send: 'Send',
      thinking: 'Working on it…',
      stopped: 'You stopped the reply.',
      stop: 'Stop',
      loadError: "Couldn't load the conversation.",
      retry: 'Try again',
      steps_one: '{{count}} step',
      steps_other: '{{count}} steps',
      stepsFailed: '{{count}} failed',
      activity: {
        sending: 'Sending…',
        thinking: 'Thinking…',
        editing: 'Editing the video…',
        capturing: 'Capturing the screen…',
        awaitingConfirmation: 'Confirm on the card above',
        tool: '{{tool}}…',
        elapsed: '{{seconds}} s',
        longWait: 'may take up to 2 min',
        tools: {
          analyze_video: 'Watching the video…',
          wait_for_import: 'Preparing the video…',
        },
      },
      interrupted: 'The last answer was interrupted. Send your request again.',
      reloadNotice: 'The assistant changed data shown on this page. Reload to see it.',
      reload: 'Reload',
      disclaimer: 'AI can make mistakes. Account actions need your confirmation; editor edits can be undone.',
      editApplied: 'The AI edited this clip.',
      undoEdit: 'Undo',
      editUndone: 'AI edits undone',
      toolFailed: '{{tool}} failed',
      action: {
        title: 'Confirm: {{action}}',
        confirm: 'Confirm',
        cancel: 'Cancel',
        status: {
          pending: 'Waiting for confirmation',
          approved: 'Confirmed',
          cancelled: 'Cancelled',
          expired: 'Not confirmed',
        },
      },
      suggestions: {
        studioFunny: 'Make this clip funny',
        studioHormozi: 'Add Hormozi-style captions',
        studioCutPauses: 'Cut the pauses',
        studioLayout: 'Use the Cortes layout',
        studioBroll: 'Add b-roll at the start',
        makeClips: 'Make clips from a YouTube video',
        latestProjects: 'How are my latest videos doing?',
        myUsage: 'How much quota do I have left this month?',
        bestClips: 'Which clips here look the most viral?',
        renderBest: 'Render the best clip of this video vertically',
        captionIdeas: 'Write a title and caption for the first clip',
        renderThisProject: 'Render the clips of this project',
        subtitleStyleHelp: 'How do I change the subtitle style here?',
        editorTour: 'What can I do in this editor?',
        trendingNow: 'What is trending in the community library this week?',
        remixIdea: 'Find a podcast video to remix',
        bestCampaign: 'Which campaign pays the most right now?',
        howEarn: 'How does Clip & Pix work?',
        myEarnings: 'How much have I earned so far?',
        analyticsSummary: 'Summarize my social media results',
        bestPosts: 'Which of my posts performed best?',
      },
      errors: {
        featureDisabled: 'The AI assistant is not enabled for your account.',
        busy: 'The assistant is still answering. Wait for it to finish.',
        dailyLimit: 'You reached today\'s message limit. Try again tomorrow.',
        unavailable: 'The assistant is unavailable right now. Try again later.',
        actionExpired: 'This confirmation is no longer valid.',
        clientCallsExpired: 'The assistant lost track of the editor. Send your request again.',
        notFound: 'This conversation no longer exists.',
        invalidInput: 'Write a message of up to 4,000 characters.',
        generic: 'Something went wrong with the assistant. Try again.',
      },
      attach: {
        button: 'Attach image or video',
        captureFrame: 'Attach current frame',
        remove: 'Remove attachment',
        errors: {
          capture_failed: "Couldn't capture the frame.",
          unsupported_type: 'Only images (PNG, JPG, WebP, GIF) and videos (MP4, MOV, WebM).',
          too_large: 'Too large: images up to 10 MB, videos up to 300 MB.',
          too_many: 'Up to 4 attachments per message, 2 of them videos.',
          upload_failed: 'Upload failed. Remove it and try again.',
        },
      },
      previewKinds: {
        clip: 'Clip',
        project: 'Project',
        library: 'Curation',
        community_video: 'Community video',
        video_url: 'Video',
        campaign: 'Campaign',
        plan: 'Plan',
      },
      args: {
        aspect_ratio_format: 'Format',
        subtitles_enabled: 'Subtitles',
        subtitle_position: 'Subtitle position',
        name: 'New name',
        rating: 'Rating',
        platform: 'Platform',
        title: 'Title',
        caption: 'Caption',
        description: 'Description',
        privacy_status: 'Visibility',
        made_for_kids: 'Made for kids',
        scheduled_at: 'Scheduled for',
        tiktok_direct_post: 'Post directly on TikTok',
        youtube_url: 'Link',
        video_url: 'Link',
        url: 'Link',
        language: 'Language',
        format: 'Clip length',
        start_time: 'Start',
        end_time: 'End',
        yearly: 'Yearly billing',
        provider: 'Payment',
        version: 'Terms version',
      },
      values: {
        true: 'Yes',
        false: 'No',
        vertical: 'Vertical',
        horizontal: 'Horizontal',
        like: 'Keep',
        dislike: 'Discard',
        neutral: 'No rating',
        instagram: 'Instagram',
        tiktok: 'TikTok',
        youtube: 'YouTube',
        public: 'Public',
        private: 'Private',
        unlisted: 'Unlisted',
        stripe: 'Card (Stripe)',
        pagarme: 'PIX',
      },
      tools: {
        analyze_video: 'Video watched',
        wait_for_import: 'Video preparation',
        ui_open_page: 'Open page',
        editor_set_subtitle_style: 'Subtitle style',
        editor_apply_template: 'Template applied',
        editor_add_text: 'Text added',
        editor_update_text: 'Text adjusted',
        editor_remove_layer: 'Layer removed',
        editor_add_effect: 'Effect added',
        editor_remove_effect: 'Effect removed',
        editor_set_transition: 'Transition',
        editor_set_look: 'Video color',
        editor_seek: 'Preview moved',
        editor_capture_frames: 'Looked at the video',
        editor_select_clip: 'Clip selected',
        editor_cut_ranges: 'Cuts in the video',
        editor_trim: 'Clip start and end',
        editor_extend: 'More of the video',
        editor_split: 'Scene split',
        editor_remove_scene: 'Scene removed',
        editor_reorder_scenes: 'Scene order',
        editor_set_framing: 'Framing',
        editor_camera_move: 'Camera move',
        editor_set_layout: 'Layout',
        editor_search_media: 'Media search',
        editor_add_media: 'Media added',
        editor_update_layer: 'Layer adjusted',
        editor_set_cover: 'Cover',
        editor_motion_reference: 'Motion reference',
        editor_add_motion: 'Animation added',
        editor_get_motion: 'Animation inspected',
        editor_update_motion: 'Animation adjusted',
        editor_add_captions: 'Caption tiers added',
        navigate_to: 'Open page',
        get_my_account: 'Account details',
        list_plans: 'Plan list',
        create_checkout: 'Checkout link',
        get_checkout_status: 'Payment status',
        search_community_libraries: 'Community library search',
        get_community_library: 'Community video details',
        search_community_channels: 'Community channel search',
        get_community_channel: 'Community channel details',
        list_community_channel_libraries: 'Channel videos',
        search_community_tags: 'Community topics',
        check_community_url: 'Community check for the link',
        list_import_videos: 'Videos in the share link',
        create_project: 'New project',
        create_library: 'New curation',
        remix_community_library: 'Community video remix',
        update_project: 'Project update',
        delete_project: 'Project deletion',
        retry_project: 'Project retry',
        update_library: 'Curation update',
        delete_library: 'Curation deletion',
        retry_library: 'Curation retry',
        list_my_projects: 'Project list',
        get_project: 'Project details',
        list_my_libraries: 'Curation list',
        get_library: 'Curation details',
        list_clips: 'Clip list',
        get_clip: 'Clip details',
        generate_clip_copy: 'Title and caption for the clip',
        rate_clip: 'Clip rating',
        render_clip: 'Clip render',
        get_render_status: 'Render status',
        list_social_connections: 'Linked social accounts',
        publish_clip: 'Clip publication',
        list_cpm_campaigns: 'Clip & Pix campaigns',
        accept_cpm_terms: 'Clip & Pix terms acceptance',
        join_cpm_campaign: 'Campaign sign-up',
        submit_cpm_clip: 'Clip submission to the campaign',
        list_brand_kits: 'Brand kits',
        schedule_clip_publish: 'Scheduled publication',
        list_scheduled_publishes: 'Scheduled publications',
        cancel_scheduled_publish: 'Scheduled publication cancellation',
        list_publish_queues: 'Publish queues',
        create_publish_queue: 'New publish queue',
        update_publish_queue: 'Publish queue update',
        delete_publish_queue: 'Publish queue deletion',
        enqueue_clip_to_queue: 'Clip added to the queue',
        list_analytics_accounts: 'Analytics accounts',
        get_analytics_summary: 'Analytics summary',
        list_analytics_media: 'Analytics posts',
        list_analytics_cpm_submissions: 'Campaign submission analytics',
        open_billing_portal: 'Billing portal link',
        preview_clip_frame: 'Clip preview frame',
      },
    },
  },
};
